{
  "account": {
    "account_settings": "Accountinstellingen",
    "add_card": "Kaart toevoegen",
    "add_new_subscription": "Nieuw abonnement toevoegen",
    "add_your_card_first": "Voeg eerst je kaart toe",
    "all_your_activity_data_will_be_emailed": "Alle activiteitsgegevens worden per e-mail verstuurd",
    "amount": "Bedrag",
    "are_you_sure_that_you_want_to_end_your_subscription": "Weet je zeker dat je je abonnement wilt beëindigen?",
    "card_holder_name": "Naam kaarthouder",
    "card_holder_name_required": "Naam kaarthouder is vereist",
    "card_not_added": "Kaart niet toegevoegd",
    "change_card": "Kaart wijzigen",
    "change_subscription": "Abonnement wijzigen",
    "credit_card_debit_card": "Creditcard/ Debitcard",
    "earlier_subscription_will_work_until": "Eerder abonnement blijft van kracht tot {{date}}",
    "end_subscription": "Abonnement beëindigen",
    "export_my_data": "Exporteer mijn gegevens",
    "invoices": "Facturen",
    "last_4_digits": "**** ***** **** {{last4}}",
    "next_charge_on": "Volgende betaling op {{date}}",
    "no_invoices_have_been_added": "Er zijn geen facturen toegevoegd…",
    "no_of_users": "Aantal gebruikers",
    "pay_now": "Nu betalen",
    "payment_is_overdue_by": "Betaling is achterstallig met {{days}} {{days === 1 ? 'dag' : 'dagen'}}",
    "payment_method": "Betalingsmethode",
    "plus_gst_with_percentage": "+BTW ({{percentage}}%)",
    "select_subscription_type": "Selecteer abonnementstype",
    "status": "Status",
    "subscription": "Abonnement",
    "subscription_details": "Abonnementdetails",
    "subscription_plan_with_amount": "{{title}} - {{amount}}$ /jaar",
    "subscription_type_required": "Abonnementstype is vereist",
    "subscription_will_end_on": "Abonnement eindigt op {{date}}",
    "trial_period_ends_on": "Proefperiode eindigt op {{date}}",
    "update_account_details": "Accountgegevens bijwerken",
    "you_need_to_add_a_card_before_add_a_new_subscription_plan_click_the_add_card_button_to_start_your_subscription": "Je moet eerst een kaart toevoegen voor je een nieuw abonnement kan aanvragen. Klik op de knop 'Kaart toevoegen' om jouw abonnement te starten.",
    "your_new_subscription_rate_will_begin_immediately": "Je nieuwe abonnementstarief gaat onmiddelijk in",
    "your_plan_includes": "Jouw abonnement bevat"
  },
  "account_status": {
    "active": "Actief",
    "all": "Alle",
    "inactive": "Inactief"
  },
  "account_type": {
    "individual": "Individu",
    "organisation": "Organisatie"
  },
  "actions": {
    "accept": "Accepteren",
    "activate": "Activeren",
    "add": "Toevoegen",
    "apply": "Toepassen",
    "approve": "Goedkeuren",
    "archive": "Archiveren",
    "are_you_sure_you_want_to_remove": "Weet je zeker dat je dit wilt verwijderen:",
    "assign_to": "Toewijzen aan",
    "back": "Terug",
    "browse": "Bladeren",
    "browse_file": "Bestand bladeren",
    "cancel": "Annuleren",
    "change": "Wijzigen",
    "clear": "Wissen",
    "clear_all": "Alles wissen",
    "click_to_edit": "Klik om te bewerken",
    "close": "Sluiten",
    "confirm": "Bevestigen",
    "continue": "Doorgaan",
    "copied": "Gekopieerd",
    "copy": "Kopiëren",
    "copy_link": "Link kopiëren",
    "create": "Aanmaken",
    "create_activity": "Activiteit aanmaken",
    "deactivate": "Deactiveren",
    "delete": "Verwijderen",
    "do_you_want_to_continue": "Wil je doorgaan?",
    "download": "Downloaden",
    "download_csv_template": "CSV-sjabloon downloaden",
    "download_evidence": "Bewijs downloaden",
    "download_json": "JSON downloaden",
    "download_report": "Rapport downloaden",
    "edit": "Bewerken",
    "end": "Eindigen",
    "enter_activity": "Activiteit invoeren",
    "export": "Exporteren",
    "got_it": "Begrepen",
    "import": "Importeren",
    "leave": "Verlaten",
    "next": "Volgende",
    "no": "Nee",
    "notify": "Melden",
    "ok": "OK",
    "one_way_change": "Dit is een definitieve wijziging die niet ongedaan kan worden gemaakt.",
    "proceed": "Doorgaan",
    "read": "Lezen",
    "reassign": "Overdragen",
    "refresh": "Vernieuwen",
    "refreshing": "Aan het vernieuwen",
    "reject": "Weigeren",
    "remove": "Verwijderen",
    "replace_image": "Afbeelding vervangen",
    "reset": "Resetten",
    "reset_password": "Wachtwoord opnieuw instellen",
    "reset_to_default": "Terugzetten naar standaardinstellingen",
    "save": "Opslaan",
    "save_changes": "Wijzigingen opslaan",
    "search": "Zoeken",
    "search_by_activity": "Zoeken op activiteit",
    "search_by_user": "Zoeken op gebruiker",
    "select_activities_from": "Activiteiten selecteren van",
    "select_activity": "Activiteit selecteren",
    "select_all_lower": "alles selecteren",
    "send": "Verzenden",
    "sign_in": "Aanmelden",
    "sign_up": "Registreren",
    "skip": "Overslaan",
    "stay": "Blijven",
    "submit": "Indienen",
    "this_action_cannot_be_undone": "Deze actie kan niet ongedaan worden gemaakt!",
    "to": "tot",
    "update": "Bijwerken",
    "update_partner": "Partner bijwerken",
    "upload": "Uploaden",
    "verify": "Verifiëren",
    "view": "Bekijken",
    "view_report": "Rapport bekijken",
    "write": "Schrijven",
    "yes": "Ja"
  },
  "activity": {
    "activity_has_been_approved": "De activiteit is goedgekeurd.",
    "activity_manager": "Activiteitenbeheerder",
    "activity_plan": {
      "activity_description": "Activiteitsomschrijving",
      "activity_input": {
        "actual_expenditure": "Werkelijke uitgaven",
        "actual_program_contribution_fund": "Werkelijke programmabijdrage",
        "actual_program_grant_fund": "Werkelijke programmasubsidie",
        "actual_venue_hire": "Werkelijke zaalhuur",
        "address": "Adres",
        "anonymous_donor": "Anonieme donor",
        "contractor_cost": "Leverancierskosten",
        "contribution": "Bijdrage",
        "contribution_allocated": "Toegewezen bijdrage",
        "counted_as_program_amount": "Hierboven meegeteld als programmabedrag",
        "estimated_value": "Geschatte waarde",
        "estimated_value_partner_contribution": "Geschatte waarde partnerbijdrage",
        "expenditure": "Uitgaven",
        "expenditure_value_required": "Uitgavenwaarde is vereist",
        "grant_amount": "Subsidiebedrag",
        "grants_allocated": "Toegewezen subsidie(s)",
        "green_light_date": "'groen licht' datum",
        "in_kind_not_counted": "Waarde in natura (niet meegeteld in het financieel resultaat)",
        "invite": "Uitnodigen",
        "invite_to_activity_member": "Uitnodigen als activiteitslid",
        "message_for_invited_user": "Bericht voor uitgenodigde gebruiker",
        "network_no_amount": "Netwerk, geen bedrag",
        "no_contractors": "Er zijn geen leveranciers toegevoegd",
        "no_partners": "Er zijn geen partners toegevoegd",
        "no_reportable_expenditure": "Geen te rapporteren overige uitgaven",
        "no_venues": "Er zijn geen eventlocaties toegevoegd",
        "note_on_dates_and_timing": {
          "label": "Opmerking over data en tijdstippen",
          "placeholder": "Voeg informatie toe over de keuze van de data of het tijdstip."
        },
        "only_numbers_can_be_entered": "Alleen cijfers kunnen ingevoerd worden",
        "other_expenditure": "Overige uitgaven",
        "partner": "Partner",
        "partner_name": "Naam partner",
        "partners_help_linked": "Partners die rechtstreeks aan deze activiteit bijdragen, los van de programmabijdrage en van partners van het programma zelf.",
        "partners_help_program": "Partners die aan het programma zelf bijdragen, los van partners van de gekoppelde activiteiten.",
        "permissions": "Toestemmingen",
        "program_amount_help": "Het bedrag dat het programma rechtstreeks aan deze activiteit bijdraagt, los van eventuele partnerfinanciering die de activiteit zelf binnenhaalt.",
        "program_contribution_fund": "Programmabijdrage",
        "program_fund_remaining": "Resterend",
        "program_grant_fund": "Programmasubsidie",
        "projected_amount": "Gepland",
        "projected_contractor_incomplete": "Gepland. Graag aanvullen",
        "projected_expenditure": "Geplande uitgaven",
        "projected_program_contribution": "Geplande programmabijdrage",
        "projected_program_grant": "Geplande programmasubsidie",
        "remove_partner_from_activity": "Partner uit activiteit verwijderen",
        "search_for_existing_contractors": "Zoeken onder opgeslagen leveranciers",
        "search_for_existing_partners": "Zoeken onder opgeslagen partners",
        "search_for_existing_venues": "Zoeken onder opgeslagen locaties",
        "total_volunteers": "Totaal aantal vrijwilligers",
        "venue": "Eventlocatie",
        "venue_hire": "Zaalhuur"
      },
      "activity_manager": "Activiteitmanager",
      "activity_members": "Activiteitsleden",
      "activity_section": "Activiteitssectie",
      "actual_input": {
        "total_volunteers": "TOTAAL AANTAL VRIJWILLIGERS",
        "venues": "EVENTLOCATIE(S)"
      },
      "actual_inputs": "Werkelijke inputs",
      "actual_outputs": "Werkelijke outputs",
      "add_group": "Groep toevoegen",
      "add_guest_user": "Gastgebruiker toevoegen",
      "add_guest_user_modal_title": "Gastgebruiker toevoegen",
      "add_new_contractor": "Nieuwe leverancier toevoegen",
      "add_new_group": "Nieuwe groep toevoegen",
      "are_you_sure_you_want_to_delete_this_group": "Weet je zeker dat je deze groep wilt verwijderen?",
      "change_ownership": {
        "contact_email_required": "Contact-e-mail is vereist",
        "enter_details_title": "Voeg de gegevens toe van de nieuwe activiteitmanager",
        "found_user_info": "We hebben een Takso-gebruiker gevonden die overeenkomt met het ingevoerde e-mailadres.",
        "notify_existing_user": "Informeer bestaande gebruiker",
        "notify_new_user": "Informeer nieuwe gebruiker",
        "notify_of_changes": "Informeer over wijzigingen",
        "notify_option_required": "Meldingoptie is vereist",
        "trigger": "Beheerder wijzigen"
      },
      "core_participant_group": "Subgroep deelnemers",
      "couldnt_add_participant": "Kon deelnemer niet toevoegen",
      "couldnt_change_permissions": "Kon toestemming niet wijzigen",
      "create_new_group": "Nieuwe groep aanmaken",
      "create_new_subgroup": "Subgroep aanmaken",
      "current_members": "Huidige leden",
      "deactivate": {
        "no_permission_message": "Deze beheerder heeft niet de vereiste toestemming om bij te dragen aan dit activiteitstype",
        "permanent_remove_message": "Gekoppelde activiteit wordt permanent verwijderd en toegewezen aan de contactorganisatie",
        "reason_label": "Reden voor {{mode}}",
        "reason_required": "Reden voor deactivering is vereist"
      },
      "delete_activity": {
        "linked_confirm": "Weet je zeker dat je deze gekoppelde activiteit wil verwijderen?",
        "linked_title": "Verwijder gekoppelde activiteit",
        "remove_projected_confirm": "Weet je zeker dat je deze geplande activiteit wil verwijderen?",
        "title_with_name": "Activiteit verwijderen – {{name}}",
        "trigger": "Activiteit verwijderen"
      },
      "delete_confirmation": "Bevestiging verwijderen",
      "deleted_user": "Verwijderde gebruiker",
      "details": {
        "activation_information": "Activatie-informatie",
        "notify_grantee_confirm": "Weet je zeker dat je de begunstigden wilt informeren?",
        "notify_grantee_title": "Informeer begunstigden",
        "projected_grant_amount": "Gepland subsidiebedrag",
        "re_send_notification": "Herinnering opnieuw versturen",
        "update_contact_information": "Contactgegevens bijwerken",
        "update_contact_information_desc": "De contactgegevens met dit e-mailadres bestaan al in Takso. Je kunt het record bijwerken met de ingevoerde informatie in de {{type}}-applicatie door op bijwerken te drukken. Om door te gaan zonder bijwerken, druk op nee.",
        "view_report": "Bekijk rapport"
      },
      "discard_changes": "Wijzigingen annuleren",
      "do_you_want_to_create_evaluation_subgroups_for_your_participants": "Subgroepen toevoegen bij evaluatieplan",
      "do_you_want_to_identify_any_core_groups_within_these_participants": "Wil je subgroepen identificeren binnen deze deelnemers.",
      "duplicate_permission": "Mag deze activiteit dupliceren",
      "duplicate_permission_hint": "Zij kunnen een eigen kopie van deze activiteit maken, net als de beheerder. Alleen voor leden van je organisatie.",
      "duplicate_permission_locked": "Beschikbaar met de toestemming Medewerker of Aangepast.",
      "edit_group": "Groep bewerken",
      "evaluation_subgroups": "Evaluatiesubgroepen",
      "form": {
        "activity_manager": "Activiteitmanager",
        "activity_name_required": "Activiteitsnaam is vereist",
        "add_linked_activity": "Gekoppelde activiteit toevoegen",
        "enter_summary_description": "Maak een samenvatting van",
        "evaluation_of_this_program_will_be_an_aggregate_of_evaluation_from_the_programs_linked_activity_records_and_reported_through_the_documentation_page_of_this_program": "De evaluatie van dit programma zal een samenvoeging zijn van de evaluaties uit de gekoppelde activiteitenverslagen van de programma's en zal worden gerapporteerd via de documentatiepagina van dit programma.",
        "grant_id": "Subsidie-ID",
        "grant_id_required": "Subsidie-ID is vereist",
        "manage_reference": "Referentie beheren",
        "no_reference_selected": "Geen referentie geselecteerd",
        "primary_domain": "Primair domein",
        "primary_objective": "Primaire doelstelling",
        "projected_grant_amount_required": "Gepland subsidiebedrag is vereist",
        "secondary_domain": "Secundair domein",
        "secondary_objective": "Secundaire doelstellingen",
        "select_festival_type": "Selecteer festivalsoort",
        "select_primary_objective": "Selecteer primaire doelstelling",
        "select_reference": "Selecteer",
        "select_reference_with_label": "Selecteer {{label}}",
        "summarise": "Samenvatten",
        "support_description": "Ondersteuningsbeschrijving",
        "you_have_not_created_any_linked_activities_yet": "Je hebt nog geen gekoppelde activiteiten aangemaakt…"
      },
      "grant_program": {
        "are_you_sure_you_want_to_remove_this_file_from_the_grant_program": "Weet je zeker dat je dit bestand wilt verwijderen uit het subsidieprogramma?",
        "delete_item": "Item verwijderen",
        "export_program_data": "Exporteer programmainformatie",
        "export_program_information_needed_for_the_grant_application_form": "Exporteer programmainformatie die nodig is voor het subsidieaanvraagformulier.",
        "format": "Formaat",
        "grants": "Subsidies",
        "import_grantees": "Importeer begunstigden",
        "import_grantees_from_smarty_grants": "Importeer begunstigden van Smarty Grants",
        "import_successful_grant_applicant_information_to_create_the_linked_activities_for_this_program": "Importeer succesvolle subsidie-aanvragergegevens om de gekoppelde activiteiten voor dit programma te maken.",
        "max_file_size": "Maximaal bestandsgrootte - {{max_file_size}}",
        "non_required_field_entry_errors_detected": "Er zijn fouten gedetecteerd in optionele velden. je kunt doorgaan met uploaden, maar de volgende gegevens worden niet geüpload als de fouten niet worden opgelost.",
        "required_information_errors_preventing_upload": "Er zijn fouten in verplichte informatie die het uploaden verhinderen. Los het volgende op:",
        "smarty_grants": "Smarty Grants"
      },
      "grants_program": "Subsidieprogramma",
      "group_not_in_any_plan": "{{groupName}} heeft {{count}} geregistreerd, maar is nog niet opgenomen in een evaluatieplan.",
      "group_not_in_any_plan_tooltip": "{{groupName}} heeft {{count}} geregistreerd. Deze groep was oorspronkelijk niet opgenomen in een evaluatieplan.\n\nOm dit op te lossen, heropen je de activiteit (bovenaan de pagina Evaluatieplan) en bewerk je een bestaand evaluatieplan om deze groep op te nemen, of maak je een nieuw evaluatieplan aan als je deze groep afzonderlijk wilt evalueren.\n\nDit is slechts ter informatie. Het weerhoud je er niet van je activiteit te voltooien.",
      "group_reason_required": "Reden voor groep is vereist",
      "invite": "Uitnodigen",
      "invite_organisation_members": "Nodig anderen uit om samen te werken aan deze activiteit",
      "linked_activity": {
        "activate_activity": "Activiteit activeren",
        "activity_type_not_accessible": "Activiteitstype niet toegankelijk",
        "add_modal_label": "{{label}} toevoegen",
        "create_new_modal_label": "Nieuwe {{label}} aanmaken",
        "deactivate_activity": "Activiteit deactiveren",
        "deactivate_external_linked_activity": "Externe gekoppelde activiteit deactiveren",
        "deactivate_external_linked_activity_confirmation": "De beheerder van deze gekoppelde activiteit is een gebruiker in een externe Takso-account. Bij bevestiging van deactivering wordt het activiteitrecord naar dat account overgebracht waar ze kunnen kiezen om door te gaan of de activiteit te verwijderen.",
        "delete_activity": "Activiteit verwijderen",
        "delete_linked_activity": "Gekoppelde activiteit verwijderen",
        "delete_linked_activity_confirmation": "Weet je zeker dat je deze gekoppelde activiteit wilt verwijderen?",
        "delete_projected_activity_confirmation": "Weet je zeker dat je deze geplande activiteit wilt verwijderen?",
        "invitation_activity_type_not_accessible": "Uitnodiging voor deze activiteit is niet mogelijk voor deze gebruiker omdat het activiteitstype niet toegankelijk of beschikbaar is voor hen",
        "invitation_blocked_root_not_organisation_owned": "Deze uitnodiging is niet mogelijk omdat het hoofdprogramma geen eigendom is van een organisatiegebruiker.",
        "linked_activity_will_be_permanently_removed_and_assigned_to_contact_organisation": "Gekoppelde activiteit wordt permanent verwijderd en toegewezen aan de contactorganisatie",
        "proceed_with_deactivation": "Doorgaan met deactivering.",
        "reason_for_activation": "Reden voor activatie",
        "reason_for_deactivation": "Reden voor deactivering",
        "reason_for_deactivation_is_required": "Reden voor deactivering is vereist",
        "status": {
          "accepted": "Geaccepteerd",
          "activated": "Geactiveerd",
          "deactivated": "Gedeactiveerd",
          "projected": "Gepland",
          "review": "Beoordelen"
        },
        "this_email_does_not_match_an_existing_account_in_takso_enter_details_below_to_create_a_guest_account_for_this_person": "Dit e-mailadres komt niet overeen met een bestaande account in Takso. Voer hieronder details in om een gastaccount voor deze persoon te maken",
        "you_cannot_invite_to_same_user_again": "Je kunt deze gebruiker niet opnieuw uitnodigen",
        "you_cannot_invite_user_activity_organisation_not_matched": "Je kunt deze gebruiker niet uitnodigen voor deze activiteit. De organisatie komt niet overeen"
      },
      "manage_activity": "Activiteit beheren",
      "message_for_guest_user": "Bericht voor gastgebruiker",
      "no_contractor_found": "Geen leverancier gevonden",
      "no_of_participants": "Aantal deelnemers",
      "no_sub_groups_have_been_created": "Er zijn geen subgroepen aangemaakt",
      "no_users_added": "Er zijn nog geen gebruikers toegevoegd",
      "no_users_has_been_added": "Er zijn geen gebruikers toegevoegd",
      "output": {
        "activity_data": "Activiteitsgegevens",
        "final_result": "Eindresultaat",
        "financial_result": "Financieel resultaat",
        "only_numbers_accepted": "Alleen cijfers zijn toegestaan",
        "other_income": "Overige inkomsten",
        "other_income_help": "Inkomsten die de activiteit zelf genereert (bijv. ticketverkoop), los van partnerfinanciering en de programmabijdrage.",
        "placeholder_date": "Selecteer datum",
        "projected_activity_final_result": "Eindresultaat van de geplande activiteit",
        "projected_activity_financial_result": "Gepland financieel resultaat van de activiteit",
        "projected_income": "Geplande inkomsten",
        "this_field_invalid": "Dit veld is ongeldig",
        "ticketed": "Evenement met tickets of registratie",
        "warning_content": "Je hebt wijzigingen aangebracht aan de activiteit nadat documentatie is toegevoegd. Controleer de documentatie om te zorgen dat alles nog correct is en werk velden bij die door de wijzigingen zijn beïnvloed."
      },
      "participant_adding_success": "Deelnemer succesvol toegevoegd",
      "participant_groups": {
        "at_least_one_eval_stage_must_have_participants": "Ten minste één evaluatiefase moet deelnemers hebben.",
        "do_your_group_numbers_vary": "Variëren de aantallen van je subgroepen?",
        "no_negative_numbers": "Negatieve getallen worden niet geaccepteerd.",
        "num_participants_must_be_at_least_zero": "Het aantal deelnemers moet 0 of groter zijn.",
        "remove_all_subgroups": "Verwijder alle subgroepen voordat je deze instelling wijzigt naar \"nee\".",
        "vary_by_series_tooltip": "Je hebt een meerfasig evaluatieplan aangemaakt. ullen de aantallen deelnemers per subgroep voor dit plan variëren?"
      },
      "participant_permission_update_success": "Toegang deelnemer succesvol bijgewerkt",
      "permission_changed": "Toegang gewijzigd",
      "plan_participants_considered_exceed_groups": "\"{{planName}}\" telt {{count}} deelnemers, wat meer is dan het aantal deelnemers in de evaluatiegroepen: {{breakdown}} ({{total}} in totaal).",
      "plan_responses_exceed_groups": "\"{{planName}}\" heeft {{count}} geregistreerde reacties, wat meer is dan het aantal deelnemers in de evaluatiegroepen: {{breakdown}} ({{total}} in totaal).",
      "please_set_permissions": "Stel alstublieft toegang in",
      "please_set_permissions_activity_member": "Stel toegang in voor activiteitlid",
      "please_set_permissions_new_member": "Stel toegang in voor nieuw lid",
      "potential_issues": "Mogelijke problemen",
      "program_collaborator": "Medewerker programma",
      "program_description": "Programma­beschrijving",
      "program_manager": "Activiteitenbeheerder",
      "projected": {
        "activity_description": "Activiteitsbeschrijving",
        "activity_period": "Activiteitsperiode",
        "grant_id": "Subsidie-ID",
        "modal_title": "Geplande gekoppelde activiteit",
        "organisation_goal": "Doel van de organisatie ",
        "period_to": " tot "
      },
      "projected_inputs": "Geplande inputs",
      "projected_outputs": "Geplande outputs",
      "re_invite": "Opnieuw uitnodigen",
      "reason": "Reden",
      "reason_for_this_group": "Reden voor deze groep",
      "save_group": "Groep opslaan",
      "search_by_activity_name": "Zoeken naar activiteitnaam",
      "search_for_existing_users": "Gebruikers in je organisatie zoeken",
      "setup_activity": "Activiteit instellen",
      "status": {
        "accepted": "Geaccepteerd",
        "activated": "Geactiveerd",
        "deactivated": "Gedeactiveerd",
        "review": "Beoordelen"
      },
      "subgroup_exceeds_total_participants": "Subgroep \"{{groupName}}\" heeft {{count}} deelnemers, wat meer is dan het totale aantal deelnemers van deze activiteit ({{total}}).",
      "subgroup_exceeds_total_participants_tooltip": "Het hierboven geregistreerde totale aantal deelnemers moet alle deelnemers aan de activiteit weerspiegelen. Subgroepen zijn bedoeld om een specifiek deel van je totaal aantal deelnemers te kunnen selecteren; het aantal subgroepdeelnemers mag dus nooit meer zijn dan je totaal aantal deelnemers.",
      "table": {
        "activation_information": "Activatie-informatie",
        "contact_org": "Contact/Organisatie",
        "contact_organisation": "Contact/Organisatie",
        "empty_linked_activities": "Je hebt nog geen gekoppelde activiteiten aangemaakt...",
        "tooltip_view_activity": "Klik op tekst om de activiteit te bekijken",
        "view_report": "Bekijk rapport"
      },
      "total_no_of_participants": "Totaal aantal deelnemers",
      "update_group": "De actuele deelnemerslijst bijwerken voor {{groupName}}",
      "update_permissions": "Toegang bijwerken",
      "user_added_activity": "Gebruiker toegevoegd aan activiteit"
    },
    "activity_steps": {
      "activity_confirmation_modal_body": "Je staat op het punt het doel voor je activiteit te bevestigen. Vanaf dit moment wordt het doel vergrendeld en kan het niet meer worden gewijzigd. Wil je doorgaan met deze activiteit en dit doel selecteren?",
      "activity_confirmation_modal_title": "Activiteitsbevestiging",
      "activity_goals_overview": "Overzicht activiteitsdoelen",
      "analysis_and_reflection_title": "Analyse en reflectie",
      "approved_by_label": "Goedgekeurd door",
      "contact_admin_msg": "Neem alstublieft contact op met Takso-admin voor ondersteuning…",
      "document_title": "Activiteiten – Flow | {{app_name}}",
      "error_occurred": "ER IS EEN FOUT OPGETREDEN",
      "evaluation_plans_title": "Evaluatieplannen",
      "intended_outcomes": "Beoogde uitkomsten",
      "intended_outcomes_for_policy": "Beoogde uitkomsten – {{policyName}}",
      "joyride_goal_tip": "Je wordt gevraagd het doel van de organisatie te benoemen die deze activiteit zal aanpakken. Zodra je deze invulten de planning is gestart, kan deze niet meer worden gewijzigd.",
      "joyride_report_tip": "De <b>Report-pagina</b> is een real-time samenvatting van de activiteit terwijl deze wordt opgebouwd en kan op elk moment worden bekeken, afgedrukt of geëxporteerd.",
      "joyride_steps_tip": "De stappen tussen <b>Doelstellingen</b> en <b>Evaluation</b> kunnen zo vaak als nodig worden gewijzigd en bewerkt, totdat de activiteit de <b>'Groen licht'</b> krijgt om door te gaan",
      "key_activity_data_title": "Belangrijke activiteitgegevens",
      "multi_stage_evaluation_only_label": "Alleen meerfasige evaluatie",
      "objective_intended_outcomes": "Doelstellingen – Beoogde uitkomsten",
      "organisation_goal_to_be_addressed": "Doel van de organisatie instellen",
      "outcome_summary_title": "Samenvatting uitkomsten",
      "outstanding_information_title": "Informatie vereist om de activiteit te voltooien",
      "set_objective_title": "Doelstelling selecteren",
      "validation_errors_for_approval": "Problemen die opgelost moeten worden voordat je goedkeuring aanvraagt",
      "validation_errors_for_green_light": "Problemen die moeten worden opgelost voordat je de activiteit goedkeurt",
      "validation_errors_for_re_request_approval": "Problemen die moeten worden opgelost voordat je opnieuw goedkeuring aanvraagt"
    },
    "actual_outcomes": {
      "no_responses": "Er zijn geen reacties geregistreerd voor dit evaluatieplan.",
      "title": "Werkelijke uitkomsten"
    },
    "actual_output": {
      "total_volunteers": "Totaal aantal vrijwilligers",
      "venues": "Event locatie(s)"
    },
    "archive": {
      "archive_activity": "Activiteit archiveren",
      "complete_activity_record": "Activiteitsrecord voltooien",
      "reopen_activity": "Activiteit heropenen",
      "thank_you_for_completing_the_activity": "Bedankt voor het voltooien van de activiteit. Vanaf dit punt kan je deze activiteit niet meer bewerken. De activiteitenbeheerder bekijkt je activiteitsrapport en je wordt op de hoogte gebracht wanneer het is goedgekeurd. Als er problemen zijn, zal de activiteitenbeheerder je direct contacteren."
    },
    "browse": {
      "filter_by_activity_type": "Filteren op activiteitstype",
      "no_event_details_recorded_yet": "Nog geen evenementdetails geregistreerd."
    },
    "core_data": {
      "data": "Gegevens",
      "data_to_collect": "Te verzamelen gegevens",
      "enter_notes": "Notities invoeren",
      "inputs": "Inputs",
      "no_inputs_found": "Geen inputs gevonden...",
      "no_reference_documents": "Geen referentiedocumenten",
      "reference_documents": "Referentiedocumenten met basisgegevens",
      "report_year": "Verslagjaar",
      "reporting_year": "Verslagjaar",
      "select_reporting_year": "Selecteer rapportagejaar",
      "upload_report": "Rapport uploaden"
    },
    "departments": {
      "no_departments_have_been_added": "Er zijn geen afdelingen toegevoegd"
    },
    "documentation": {
      "activity_data": "Activiteitsgegevens",
      "actualInputs": {
        "title": "Werkelijke inputs"
      },
      "actualOutputs": {
        "title": "Werkelijke outputs"
      },
      "aggregateReports": {
        "advancedFilter": "GEAVANCEERDE FILTER",
        "backToOutcomesAddressed": "Terug naar reeds behandelde uitkomsten",
        "reportPreview": "Je rapport wordt hier voorgesteld",
        "reportTypes": {
          "inputsOutputs": "Inputs & Outputs",
          "outcomesReported": "Gerapporteerde uitkomsten"
        }
      },
      "analysisAndReflection": {
        "subtitle": "Licht activiteit toe",
        "title": "Analyse en reflectie"
      },
      "analysis_and_reflection": {
        "evaluationResultsAnalysis": "Bevindingen",
        "evaluationResultsPlaceholder": "Wat vertellen de evaluatieresultaten je over de uitkomsten voor deelnemers en de factoren die van betekenis waren?",
        "nextSteps": "Volgende stappen",
        "nextStepsPlaceholder": "Welke vervolgacties, toekomstige activiteiten of aanbevelingen komen voort uit deze activiteit?",
        "reflection": "Reflectie",
        "reflectionPlaceholder": "Overweeg de activiteit als geheel en wat je zou willen meegeven aan lezers van het activiteitsrapport. Was de activiteit succesvol in het bereiken van de beoogde uitkomsten? Werd je theory of change bevestigd? Wat heb je geleerd? Waren er belangrijke belemmeringen of problemen?",
        "summary": "Volgende stappen",
        "unpublishedNote": "Niet gepubliceerd opmerking",
        "unpublishedNoteHelp": "Dit is niet zichtbaar op het activiteitsrapport of export."
      },
      "documents_and_media": {
        "delete": {
          "confirmation": "Weet je zeker dat je dit bestand uit de activiteit wilt verwijderen?",
          "title": "Media verwijderen"
        },
        "document": "Document",
        "form": {
          "acceptedFileTypes": "Geaccepteerde bestandstypes: .pdf, .docx, .jpg, .jpeg, .png",
          "browseFile": "Blader bestand",
          "enterLink": "Voer link in",
          "maxFileSize": "Maximale bestandsgrootte – 50 MB"
        },
        "link": "Link",
        "notifications": {
          "copiedToClipboard": "gekopieerd naar klembord",
          "documentLink": "Documentlink"
        },
        "table": {
          "emptyMessage": "Geen items toegevoegd",
          "format": "Formaat"
        },
        "title": "Documenten & Media",
        "uploadDescription": "Upload foto's, korte video's en documenten van de activiteit om ze vast te leggen. URL's worden alleen als tekst opgeslagen en moet je kopiëren en plakken in een browser om ze te bekijken.",
        "uploadItems": "Items uploaden",
        "uploadMedia": "Media uploaden"
      },
      "expenditure": "Uitgaven",
      "finalDescription": {
        "activityDescription": "Activiteitsbeschrijving",
        "subtitle": "Zorg dat de beschrijving een nauwkeurige weergave is van de activiteit of het programma dat je hebt uitgevoerd.",
        "theActivity": "de activiteit",
        "title": "Managementsamenvatting"
      },
      "financialSummary": {
        "actual": "Werkelijk",
        "contractor": "Opdrachtnemer",
        "contractors": "Opdrachtnemers",
        "financial_result": "Financieel resultaat",
        "in_kind_support": "Steun in natura",
        "note_label": "Financiële toelichting",
        "note_placeholder": "Geef de context die een lezer nodig heeft om deze bedragen te begrijpen.",
        "other_expenditure": "Overige uitgaven",
        "other_income": "Overige inkomsten",
        "partner": "Partner",
        "partners": "Partners",
        "program_contribution": "Programmabijdrage",
        "program_grant": "Programmasubsidie",
        "projected": "Gepland",
        "title": "Financieel overzicht",
        "venue": "Locatie",
        "venues": "Locaties"
      },
      "grant_amount": "Subsidiebedrag",
      "other_income": "Overige Inkomsten",
      "programReports": {
        "title": "Programmarapporten"
      },
      "results": {
        "label": "Resultaat",
        "placeholder": "Voer de belangrijkste resultaten van de activiteit in, inclusief significante outputs en onverwachte en opmerkelijke uitkomsten."
      },
      "summary": {
        "label": "Definitieve activiteitsbeschrijving voor rapport",
        "tooltip": "Werk de activiteitsbeschrijving bij zodat deze als inleiding voor de managementssamenvatting van het rapport kan dienen"
      },
      "total_volunteers": "Totaal Vrijwilligers"
    },
    "duplicate": {
      "duplicate_as_a_standalone_activity": "Dupliceren als een op zichzelf staande, losse activiteit",
      "keep_in_program": "In het programma houden",
      "keep_in_program_linked_to": "In het programma opnemen — gekoppeld aan „{{parentName}}”"
    },
    "errors": {
      "couldnt_delete_activity": "We konden de activiteit niet verwijderen",
      "couldnt_submit_activity": "We konden de activiteit niet indienen",
      "couldnt_unassign_the_group": "We konden de groep niet loskoppelen"
    },
    "evaluation": {
      "activity_approval": "Goedkeuring activiteit",
      "activity_description": "Activiteitsbeschrijving",
      "activity_on_a_page": "Activiteit op een pagina",
      "activity_requires_approval": "Activiteit vereist goedkeuring",
      "add_more_questions": "Meer vragen toevoegen",
      "add_new_evaluation_plan": "Evaluatieplan toevoegen",
      "add_subtitle": "Ondertitel toevoegen",
      "add_subtitle_to_evaluation_series": "Ondertitel toevoegen aan evaluatieserie",
      "add_to_report_shortlist": "Toevoegen voor gebruik in rapport",
      "additional_questions": "Extra vragen",
      "additional_questions_warning": "Wanneer je besluit extra vragen toe te voegen, zorg dan dat de opgevraagde informatie nodig is en zal worden gebruikt. Dit voorkomt het verzamelen van onnodige informatie en zorgt dat je enquête beknopt blijft",
      "after": "Na",
      "after_average": "Na gemiddelde",
      "after_response_1_10": "na reactie (1-10)",
      "after_responses": "Na reacties",
      "all_methods": "Alle methoden",
      "another_evaluation_exists": "Een ander evaluatieplan met deze groep en uitkomsten bestaat al, wil je een zelfbeoordeling doen voor dit plan?",
      "approval_user_required": "Goedkeuring van gebruiker is vereist",
      "approved": "Goedgekeurd",
      "average_number_of_respondents": "Gemiddeld aantal respondenten",
      "average_response": "Gemiddelde: {{value}}",
      "before": "Voor",
      "before_average": "Voor gemiddelde",
      "before_response_1_10": "voor reactie (1-10)",
      "before_responses": "Voor reacties",
      "cannot_be_undone_warning": "Dit kan niet ongedaan worden gemaakt. Als je een nieuwe evaluatiemethode wilt toepassen, ga dan naar de evaluatiepagina",
      "cdp_reference_code": "CDP-referentiecode",
      "click_individual_plan_access": "Klik op het specifieke plan om je evaluatie-informatie te openen.",
      "closed": "Gesloten",
      "closed_message": "Dit evaluatieplan is gesloten en er kunnen geen verdere wijzigingen worden aangebracht.",
      "comment": "Opmerking",
      "comments": "Opmerkingen",
      "confirmation": "Bevestiging",
      "copied_to_clipboard": "Gekopieerd naar klembord",
      "could_not_delete_subtitle": "We konden de ondertitel niet verwijderen",
      "create_multi_stage_evaluation_series": "Meerfasige evaluatie",
      "create_new_evaluation_plan": "Nieuw evaluatieplan aanmaken",
      "csv_template_instructions": "Download het evaluatiesjabloon, voer de antwoorden van de {{csvRespondentType}} in en upload vervolgens het ingevulde CSV-bestand. Als je een nieuw CSV-bestand uploadt, worden de eerder via CSV geüploade reacties vervangen. Online enquête-antwoorden worden hierdoor niet beïnvloed.",
      "csv_upload": "CSV upload",
      "culture_counts": "Culture Counts",
      "culture_counts_instruction": "Vul je gegevens in en gebruik de uploadknop om je deelnemersreacties  op te laden.",
      "custom_question": "Aangepaste vraag",
      "custom_questions": "Extra vragen",
      "custom_success_message": "Aangepast succesbericht",
      "data_collection_method": "DATAVERZAMELINGSMETHODE",
      "data_collection_method_required": "Dataverzamelingsmethode is vereist",
      "delete_confirmation": "Bevestiging verwijderen",
      "delete_subtitle_confirmation": "Weet je zeker dat je deze ondertitel wilt verwijderen?",
      "delete_survey_confirmation": "Weet je zeker dat je deze {{type}} wilt verwijderen?",
      "disabled": "Evaluatie uitgeschakeld",
      "disabled_message": "Deze evaluatie heeft niet plaatsgevonden, uitkomsten van deelnemers zijn bevraagd in een ander evaluatieplan.",
      "do_you_intend_to_survey_same_people": "Ben je van plan dezelfde personen meerdere keren te enquêteren?",
      "documentation_changes_warning": "Je hebt wijzigingen aangebracht in de activiteit nadat documentatie-informatie is toegevoegd. Controleer alstublieft de documentatie-informatie om te zorgen dat alles nog correct is en werk velden bij die beïnvloed zijn.",
      "dont_send": "Niet verzenden",
      "download_csv_template": "Download CSV-sjabloon",
      "download_culture_counts_results": "Download evaluatieuitkomsten van Culture Counts als CSV-bestand.",
      "download_instruction": "Download om individuele evaluatieuitkomsten en opmerkingen te bekijken",
      "download_response_csv": "Download CSV met antwoorden",
      "download_takker_csv_template": "Schildpadmethode CSV-sjabloon downloaden",
      "download_template_instructions": "Download de evaluatiesjabloon, vul je gegevens in en gebruik de uploadknop om je deelnemersreacties op te laden.",
      "edit_evaluation_plan": "Evaluatieplan bewerken",
      "edit_the_plan": "Plan bewerken",
      "enter_request_for_respondent_email": "Voer verzoek in voor e-mail van respondent",
      "enter_your_question": "Voer je vraag in",
      "evaluation_closed": "Evaluatie gesloten",
      "evaluation_complete_confirmation": "Bevestiging voltooiing evaluatie",
      "evaluation_completed": "Evaluatie voltooid",
      "evaluation_completed_message": "Je hebt geselecteerd dat een evaluatie is voltooid voor deze doelstelling, wil je doorgaan? De selectie kan niet ongedaan worden gemaakt",
      "evaluation_disabled": "Evaluatie uitgeschakeld",
      "evaluation_groups": "Evaluatiegroepen",
      "evaluation_information": "Evaluatie informatie",
      "evaluation_method": "EVALUATIEMETHODE",
      "evaluation_method_required": "Evaluatiemethode is vereist",
      "evaluation_not_completed_message": "Je hebt geselecteerd dat geen evaluatie is voltooid voor deze doelstelling; wil je doorgaan? De selectie kan niet ongedaan worden gemaakt",
      "evaluation_plan": "Evaluatieplan",
      "evaluation_plan_name": "Naam evaluatieplan",
      "evaluation_plan_name_required": "Naam evaluatieplan is vereist",
      "evaluation_plan_rename": "Evaluatieplan hernoemen",
      "evaluation_plans": "Evaluatieplannen",
      "evaluation_questions": "Evaluatievragen",
      "evaluation_respondent_type": "TYPE RESPONDENT EVALUATIE",
      "evaluations_takso_link_info": "Voor evaluaties met de Takso-link zijn enquête-links beschikbaar onder het relevante plan. Als je de Takso-link niet gebruikt, is de enquêtevraag beschikbaar om te kopiëren naar je een enquêtetool van je voorkeur. ",
      "evidence_types_used": "Gebruikt bewijsmateriaal",
      "facilitator_notes": "Tips bij het uitvoeren van deze evaluatie",
      "festival_types": "Festivaltypes",
      "final_result": "Eindresultaat",
      "financial_result": "Financieel resultaat",
      "go_to_culture_counts": "Ga naar Culture Counts",
      "green_light_request_approval": "Goedkeuring voor 'groen licht' aanvragen",
      "hide_evaluation_details": "Verberg evaluatiedetails",
      "hide_evaluation_question": "Verberg evaluatievraag",
      "hide_survey_information": "Enquête-informatie verbergen",
      "how_many_times_placeholder": "Aantal keren dat deze evaluatie wordt herhaald",
      "import_csv_data": "CSV-gegevens importeren",
      "import_culture_counts_csv_file_into_takso": "Importeer Culture Counts CSV-bestand in Takso",
      "import_culture_counts_survey": "Importeer Culture Counts-enquête",
      "include_in_report": "Opnemen in rapport",
      "individual_rate_of_change": "Individueel - Mate van verandering",
      "individual_responses": "Individuele reacties",
      "intercept_only": "Alleen Intercept",
      "invitation_method_required": "Uitnodigingsmethode is vereist",
      "leave_page_confirmation": "Weet je zeker dat je deze pagina wilt verlaten?",
      "linked_evaluation_groups_required": "Gekoppelde evaluatiegroepen zijn vereist",
      "linked_objectives_required": "Gekoppelde doelstellingen zijn vereist",
      "manager_of_activity": "Manager van activiteit",
      "manual_collection_instruction": "Specificeer in de onderstaande velden het aantal evaluatiedeelnemers dat het getal op de schaal selecteerde van helemaal-niet tot meest denkbaar.",
      "manual_evaluation_instructions": "Vul in de velden hieronder het aantal evaluatie­deelnemers in dat het getal op de schaal selecteerde van niet-over- hoofd tot meest denkbaar.",
      "method_proceed_warning": "Je kunt niet doorgaan met deze methode. Als je overweegt meerdere evaluaties uit te voeren met verschillende mensen, raadpleeg dan de help-pagina om te zien hoe dit kan worden gedaan.",
      "mgr_assessed_evaluation_message": "De evaluatie beoordeeld door de activiteitenbeheerder  wordt voltooid op de documentatiepagina.",
      "mgr_assessment_instructions": "Klik op de knop \"Evaluatiedetails weergeven\" en beantwoord hieronder de vragen beoordeeld door activiteitenbeheerder, zodat jouw activiteit wordt geëvalueerd en het dossier volledig is.",
      "must_be_minimum_2_evaluations": "Moet minimaal 2 evaluaties zijn",
      "new_evaluation_name": "Nieuwe evaluatienaam",
      "no_data_in_all_methods": "Geen gegevens in alle methoden.",
      "no_data_in_selected_outcome": "Geen gegevens in geselecteerde uitkomst.",
      "no_evaluation_group_to_select": "Er is geen evaluatiegroep om te selecteren",
      "no_objective_selected": "Er is geen doelstelling geselecteerd",
      "number_of_contractors": "Aantal leveranciers",
      "number_of_csv_responses": "Antwoorden via CSV-upload: {{value}}",
      "number_of_online_responses": "Antwoorden via online enquêtes: {{value}}",
      "number_of_participants_completed": "Totaal aantal antwoorden: {{value}}",
      "number_of_respondents": "Aantal respondenten",
      "number_required": "Aantal nieuwe werknemers aangemaakt is vereist",
      "objective_name": "Naam doelstelling",
      "okay": "Oké",
      "only_numbers_accepted": "Alleen getallen worden geaccepteerd",
      "organisation_goal": "Doel van de organisatie",
      "organisation_members_in_team": "Organisatieleden in team",
      "outcome_analysis_editor_placeholder": "Beschrijf wat de gegevens voor deze uitkomst laten zien — vooruitgangsscores, patronen en onverwachte zaken.",
      "outcome_narrative": {
        "toolbar_placeholder": "Beschrijf wat de gegevens voor deze uitkomst laten zien — vooruitgangsscores, patronen en onverwachte zaken."
      },
      "outstanding_information": "Informatie vereist om de activiteit te voltooien",
      "participant_response_1_10": "deelnemersreactie (1-10)",
      "participants": "deelnemers",
      "participants_considered_but_group_listed_zero_self_assessed": "{{count}} deelnemers meegenomen, maar de enige groep van deze evaluatie staat vermeld met 0 deelnemers.",
      "participants_considered_exceeds_target_self_assessed": "\"{{count}} deelnemers meegenomen, meer dan de {{listed}} geplande.",
      "participants_exceeded": "Stel correcte waarden in ({{count}} deelnemers overschreden)",
      "participation_warning": "Bij {{csvUploadWarningCount}} invoer is de score van de voormeting hoger dan die van de nameting",
      "participation_warning2": "Dit geeft aan dat je activiteit een negatieve impact had op deze deelnemer.",
      "participation_warning2_plural": "Dit geeft aan dat je activiteit een negatieve impact had op deze deelnemers.",
      "participation_warning_correct": "Als dit resultaat correct is, is geen actie nodig.",
      "participation_warning_plural": "Bij {{csvUploadWarningCount}} invoeren is de score van de voormeting hoger dan die van de nameting",
      "participation_warning_reupload": "Zo niet, corrigeer en upload je CSV opnieuw.",
      "pending": "In afwachting",
      "please_select_file": "Selecteer alstublieft een bestand",
      "post_average_response": "Gemiddelde erna: {{value}}",
      "post_rate": "Na rate",
      "pre_average_response": "Gemiddelde ervoor: {{value}}",
      "pre_rate": "Voor rate",
      "preview_survey": "Bekijk enquête",
      "primary_objective": "Primaire doelstelling",
      "projected_expenditure": "Geplande uitgaven ",
      "projected_income": "Geplande inkomsten",
      "projected_inputs": "Geplande inputs",
      "projected_outputs": "Geplande outputs",
      "qst_component_heading": "Vraagkop",
      "qst_component_method_heading": "Enquête-inleiding",
      "qst_component_question1": "Eerste vraag",
      "qst_component_question2": "Tweede vraag",
      "qst_text_choice_graded": "Gescoord",
      "qst_text_choice_heading": "Vraagtekst",
      "qst_text_choice_std": "Standaard",
      "questions": "Vragen",
      "re_notify_invitees": "Herinner genodigden ",
      "re_open": "Heropenen",
      "re_request_approval": "Herbevestiging aanvragen",
      "reason": "Reden",
      "reason_for_disabling": "Reden voor uitschakeling",
      "reason_free_text": "reden (vrije tekst)",
      "reason_required": "Reden is vereist",
      "recommended_sample_size": "Aanbevolen steekproefgrootte",
      "recommended_sample_size_is": "Wij raden een steekproefgrootte van {{recommendedSampleSize}} deelnemers aan.",
      "remove_from_report_shortlist": "Verwijderen uit rapportshortlist",
      "remove_series": "Verwijder serie",
      "request_approval": "Goedkeuring aanvragen",
      "request_approval_button": "Goedkeuring aanvragen",
      "request_approval_label": "Goedkeuring aanvragen",
      "request_email": "Verzoek e-mail",
      "requiring_green_light": "Vereist 'groen licht'",
      "respondent_email_message_required": "E-mailbericht voor respondent is vereist",
      "respondent_subset": "Respondentensubset",
      "respondent_subset_takker": "Schildpadmethode",
      "response_date": "reactiedatum",
      "responses_exceed_total_participants": "{{count}} reacties, meer dan de {{listed}} vermelde deelnemers. Mogelijk moeten de aantallen worden bijgewerkt op de <planLink>pagina Activiteitsplan</planLink>.",
      "responses_recorded_but_group_listed_zero": "{{count}} reacties geregistreerd, maar de enige groep van deze evaluatie staat vermeld met 0 deelnemers. Mogelijk moeten de aantallen worden bijgewerkt op de <planLink>pagina Activiteitsplan</planLink>.",
      "responses_recorded_message": "Voor dit evaluatieplan zijn er al reacties opgenomen; wil je reacties verwijderen en een zelfevaluatie voor dit plan uitvoeren?",
      "results": "Uitkomsten",
      "sample_size_description": "Gebaseerd op <b>{{totalParticipants}} totale deelnemers</b> in de geselecteerde groepen en een <b>betrouwbaarheidsniveau van 95 %</b> en een <b>betrouwbaarheidsinterval van ±5</b> is de aanbevolen steekproefgrootte <b>{{sampleSize}}</b>.",
      "save_evaluation_plan": "Evaluatieplan opslaan",
      "secondary_objective": "Secundaire doelstelling",
      "select_data_collection_method": "Selecteer dataverzamelingsmethode",
      "select_evaluation_group": "Selecteer evaluatiegroep",
      "select_evaluation_method": "Enquêtemethode",
      "select_evaluation_respondent_type": "Enquêterespondent",
      "select_invitees": "Selecteer genodigden",
      "select_invitees_placeholder": "Selecteer genodigden",
      "select_predefined_questions": "Selecteer vooraf gedefinieerde vragen",
      "select_request_approval_placeholder": "Selecteer aanvraag goedkeuring",
      "select_user_required": "Selecteer gebruikers is vereist",
      "self_assessed_chart": {
        "activity_count": "Aantal Activiteiten",
        "mgr_assessed_separate": "Beoordeeld door de activiteitenbeheerder (gescheiden)",
        "name_after_response": "{{name}} Na Respons",
        "name_before_response": "{{name}} Voor Respons",
        "participants": "Deelnemers",
        "respondent_percentage": "Respondenten Percentage",
        "respondents": "Respondenten",
        "self_assessed_separate": "Zelfbeoordeeld Afzonderlijk"
      },
      "self_assessed_evaluation_message": "Zelfbeoordelingsevaluatie zal worden voltooid op de Documentatie-pagina.",
      "self_assessment_confirmation": "Wil je een zelfbeoordeling doen voor dit plan?",
      "self_assessment_instructions": "Klik alstublieft op toon evaluatiedetails knop en voltooi de zelfevaluatievragen hieronder om ervoor te zorgen dat je activiteit wordt geëvalueerd en het record compleet is.",
      "self_evaluation_confirmation": "Bevestiging zelfevaluatie",
      "send_request": "Verzoek verzenden",
      "send_to_all": "Verzend naar allen",
      "send_to_selected": "Verzend naar geselecteerde",
      "show_evaluation_details": "Toon evaluatiedetails",
      "show_evaluation_question": "Toon evaluatievraag",
      "show_survey_information": "Enquête-informatie tonen",
      "source": "Bron",
      "std_to_graded_warning": "De tekst van je vraag verandert wanneer je wisselt tussen standaard formaat en formaat met scoring. Als je doorgaat, controleer dan de vraagtekst en alle vervangingsvelden om te verzekeren dat deze overeenkomen met wat je wilt.",
      "subtitle": "Ondertitel",
      "subtitle_deleted_successfully": "Ondertitel is succesvol verwijderd",
      "survey": "enquête",
      "survey_completion_message": "Bericht voltooiing enquête",
      "survey_series": "enquêteserie",
      "survey_title": "Titel van de enquête",
      "survey_title_reqd": "Enquêtetitel is vereist",
      "takker_csv": "Evaluatievragen zijn herschreven zodat ze beter geschikt zijn voor 6- tot 8-jarigen. In deze proeffase is alleen CSV-upload beschikbaar.",
      "takso_link": "Takso-link",
      "tell_us_more_one_rating": "Kan je ons vertellen waarom je deze beoordelingen gaf?",
      "tell_us_more_two_ratings": "Kan je ons vertellen waarom je deze beoordelingen gaf?",
      "trend_rate_of_change": "Trend - Mate van verandering",
      "type_reason_placeholder": "Typ hier je reden",
      "unsaved_changes_message": "Je hebt niet-opgeslagen wijzigingen. Wil je de pagina verlaten?",
      "update_evaluation_plan": "Evaluatieplan bijwerken",
      "upload_csv": "Upload CSV",
      "upload_csv_file": "CSV-bestand uploaden",
      "upload_evaluation_template": "EVALUATIESJABLOON UPLOADEN",
      "venue_s": "Eventlocatie(s)",
      "view_series": "Bekijk serie",
      "view_the_plan": "Bekijk het plan",
      "warning_message": "Om een evaluatieplan te maken, moet je eerst project doelstelling(en) selecteren en ten minste één geplande deelnemersgroep van de activiteitsplanningspagina.",
      "was_evaluation_completed": "Is de evaluatie voltooid?",
      "what_is_your_age": "Wat is jouw leeftijd?",
      "what_is_your_postcode": "Wat is jouw postcode?",
      "your_organisation_requires_approval": "Je organisatie vereist dat activiteiten worden goedgekeurd om door te gaan voordat 'groen licht' kan worden gegeven."
    },
    "evaluation_methodology": {
      "placeholder": "Vat de aanpak samen die je volgde bij het evalueren van deze activiteit, inclusief het plan of de plannen die hieronder zijn gebruikt.",
      "title": "Evaluatiemethodologie"
    },
    "evaluation_plan": {
      "10_12_years_old": "10-12 jaar",
      "6_9_years_old": "6-9 jaar",
      "after_1_to_10": "Na {{outcomeTitle}} (1-10)",
      "before_1_to_10": "Voor {{outcomeTitle}} (1-10)",
      "error_messages": {
        "assessment_basis": "Basis voor beoordeling",
        "cannot_be_transferred_to_manager_assessed": "<p> Dit evaluatieplan bevat momenteel <strong>{{responseCount}}</strong> reacties van deelnemers. </p> <p> Dit plan kan niet worden omgezet naar 'beoordeeld door de activiteitenbeheerder', omdat er voor deze evaluatiegroepen al een plan bestaat dat door de activiteitenbeheerder wordt beoordeeld. </p> <p> Je kunt dit plan verwijderen, maar alle reacties gaan dan verloren. </p> <div> <p>Let op: deze actie kan niet ongedaan worden gemaakt.</p> </div>",
        "cannot_be_transferred_to_manager_assessed_because_of_series_conflict": "<p> Dit plan kan momenteel niet worden omgezet naar 'beoordeeld door de activiteitenbeheerder' vanwege een conflict in de serie. </p> <p> Voltooi of pas eerst andere plannen in deze serie aan en probeer het daarna opnieuw. </p>",
        "cannot_transfer_to_manager_assessed": "<p> Dit evaluatieplan bevat momenteel <strong>{{responseCount}}</strong> reacties van deelnemers. </p> <p> Dit plan kan niet worden omgezet naar 'beoordeeld door de activiteitenbeheerder', omdat er voor deze evaluatiegroepen al een plan bestaat dat door de activiteitenbeheerder wordt beoordeeld. </p> <p>Je kan dit plan verwijderen, maar alle reacties gaan dan verloren.</p> <div> <p>Let op: deze actie kan niet ongedaan worden gemaakt.</p> </div>",
        "duplicate_manager_assessed_plan_found": "Er is een dubbel exemplaar van een door de activiteitsbeheerder beoordeeld plan gevonden",
        "number_of_participants_considered": "Aantal in aanmerking genomen deelnemers",
        "reason_for_evaluation_method": "Reden voor evaluatiemethode",
        "reason_for_evaluation_rating": "Reden voor evaluatiebeoordeling"
      },
      "evaluation_groups": "Evaluatiegroepen",
      "evaluation_information": "Evaluatie-informatie",
      "invalid_evaluation_method": "Ongeldige evaluatiemethode geselecteerd",
      "mark_as_complete": "Evaluatie als voltooid markeren",
      "mark_as_complete_tooltip": "Selecteer dit alleen wanneer alle gegevens zijn vastgelegd. Deze actie vergrendelt het plan en voorkomt dat er extra gegevens worden toegevoegd.",
      "no_responses_recorded": "Er zijn geen reacties geregistreerd voor dit evaluatieplan.",
      "plan_switched_to_manager_assessed": "Dit plan is omgezet naar' beoordeeld door de activiteitenbeheerder'.",
      "proxy_respondents_only": "Alleen vertegenwoordigers/experts als respondenten",
      "remove_plan": "Plan verwijderen",
      "reopen_allows_you_to_add": "Door opnieuw te openen je de gegevens toevoegen of bewerken.",
      "reopen_evaluation": "Evaluatie heropenen",
      "reopen_only_available_when_complete": "Heropenen is alleen mogelijk wanneer alle andere evaluatieplannen in deze serie als voltooid zijn gemarkeerd.",
      "reopening_allows_new_data": "Door opnieuw te openen kunnen nieuwe gegevens worden geüpload en reacties worden bijgewerkt voor dit plan.",
      "replace_with_manager_assessed_button": "Vervangen door evaluatie beoordeeld door de activiteitenbeheerder",
      "replace_with_manager_assessed_evaluation": "Vervangen door evaluatie beoordeeld door de activiteitenbeheerder",
      "replace_with_manager_assessed_evaluation_warning": "<p> <strong>{{evalPlanName}}</strong> bevat {{responseCount}} reacties. </p> <p>Als je doorgaat:</p> <ul> <li>blijven de reacties in het systeem bewaard.</li> <li>  worden ze niet meegeteld in de rapportage.</li> <li>zal een door de activiteitenbeheerder beoordeelde evaluatie dit plan vervangen.</li> </ul> <div> <p>Dit is een definitieve wijziging die niet teruggedraaid  kan worden.</p> </div>",
      "select_at_least_one_evaluation_group": "Selecteer minstens één evaluatiegroep",
      "select_data_collection_method": "Selecteer een methode voor gegevensverzameling",
      "select_evaluation_method": "Selecteer  een evaluatiemethode",
      "select_one_objective": "Selecteer ten minste één doelstelling",
      "select_respondent_type": "Selecteer een type respondent voor de evaluatie",
      "switch_to_manager_assessed": "Overschakelen naar evaluatie beoordeeld door activiteitenbeheerder",
      "switch_to_manager_assessed_tooltip_warning": "Deze wijziging kan niet ongedaan worden gemaakt. Als je deze evaluatie opnieuw wilt uitvoeren, heropen dan de activiteit bij 'goedkeuring activiteit' (bovenaan deze pagina) en maak vervolgens een nieuw evaluatieplan aan.",
      "switch_to_manager_assessed_will_replace_eval_plan": "<p>Het huidige plan beoordeelt deze groepen:</p> <groupList/> <p>Een evaluatie beoordeeld door de activiteitenbeheerder vervangt dit plan.</p> <div> <p>Dit is een definitieve wijziging die niet kan teruggedraaid worden.</p> </div>",
      "underage_participants_by_proxy": "Minderjarige deelnemers worden door een vertegenwoordiger vertegenwoordigd"
    },
    "evidence": {
      "allow_in_all_takso": "Voeg aan 'Alle Takso Gegevens'  bibliotheek toe.",
      "assign_evidence": "Bewijs toewijzen",
      "consider_the_evidence": "Overweeg het bewijs (praktijkkennis, onderzoek en gegevens) dat de keuze voor een {{title}} ondersteunt en hoe het zal worden opgesteld om het doel aan te pakken.",
      "evidence_from_the_takso_library_cannot_be_edited": "Bewijs uit de Takso-bibliotheek kan niet bewerkt worden.",
      "evidence_library": "Bewijzenbibliotheek",
      "evidence_section_description": "Je kunt hier je eigen praktijkkennis vastleggen of de artikelen, documenten en media vermelden die hebben bijgedragen aan de ontwikkeling van je activiteit.",
      "form": {
        "add": "Bewijs toevoegen",
        "add_author": "Auteur toevoegen",
        "add_new_evidence": "Nieuw bewijs toevoegen",
        "author": "Auteur",
        "change_type": "Type wijzigen",
        "content": "Inhoud",
        "content_placeholder": "Voer de relevante informatie in uit het bewijsmateriaal dat je gebruikt",
        "create_button": "Bewijs aanmaken",
        "create_new_evidence": "Nieuw bewijs aanmaken",
        "date_added": "Datum toegevoegd",
        "doi": "DOI",
        "doi_placeholder": "bijv. 10.1000/xyz123",
        "edit_evidence": "Bewijs bewerken",
        "enter_evidence": "Bewijs invoeren",
        "evidence_type": "Bewijstype",
        "library_cannot_edit": "Bibliotheekbewijs kan niet bewerkt worden",
        "library_evidence": "Bibliotheekbewijs",
        "link": "Link",
        "link_placeholder": "https://",
        "linked_objectives": "Gekoppelde doelstellingen",
        "material_type": "Materiaaltype",
        "primary_objective_label": "Primaire doelstelling",
        "relevant_objectives": "Relevante doelstellingen",
        "remove_author": "Auteur verwijderen",
        "remove_evidence": "Bewijs verwijderen",
        "remove_evidence_confirm": "Weet je zeker dat je dit bewijs wilt verwijderen?",
        "restrict_to_my_evidence": "Beperk tot mijn bewijs",
        "search_placeholder": "Zoeken naar bewijs",
        "secondary_objective_label": "Secundaire doelstelling",
        "select_evidence_type": "Selecteer bewijstype",
        "select_evidence_type_placeholder": "Selecteer bewijstype",
        "select_objective": "Selecteer doelstelling",
        "source": "Bron",
        "source_placeholder": "Voer brongegevens in - bijv. auteur, titel en datum",
        "update_button": "Bewijs bijwerken",
        "view_evidence": "Bewijs bekijken"
      },
      "goal_description": "Beschrijving van doel",
      "intended_outcomes": "Beoogde uitkomsten",
      "library": {
        "add_to_this_activity": "Aan deze activiteit toevoegen",
        "already_added_to_activity": "Al aan deze activiteit toegevoegd",
        "browse": "Bekijk bewijsmateriaal dat je eerder hebt gebruikt, of van anderen binnen je organisatie , of uit de hele Takso bibliotheek dat de doelstellingen van deze activiteit kan ondersteunen. <span>Let op: bewijsmateriaal wordt pas aan de bibliotheken ‘Organisatie’ en ‘Alle Takso Gegevens’ toegevoegd zodra de activiteit als voltooid is gemarkeerd.</span>",
        "evidence_only_added_once": "Opmerking: bewijsmateriaal wordt pas aan de bibliotheken ‘Organisatie’ en ‘Alle Takso Gegevens’ toegevoegd zodra een activiteit als voltooid is gemarkeerd.",
        "filter_by_evidence_type": "Filteren op bewijstype",
        "no_evidence_found": "Geen bewijs gevonden.",
        "previously_linked_to": "Eerder gekoppeld aan",
        "remove_from_activity": "Uit activiteit verwijderen",
        "search_evidence": "Zoeken naar bewijs...",
        "used_on_these_activities": "Gebruikt bij deze activiteiten"
      },
      "no_evidence_added": "Geen bewijs toegevoegd",
      "no_evidence_has_been_added": "Geen bewijs toegevoegd",
      "please_select_outcomes": "Selecteer alstublieft uitkomsten",
      "restrict_to_my_evidence": "Beperk tot mijn bewijs",
      "search_evidence_placeholder": "Zoeken naar bewijs",
      "select_a_goal": "Selecteer een doel",
      "select_an_objective": "Selecteer een doelstelling",
      "selected_objectives": "Geselecteerde doelstellingen",
      "source_label": "Bron (oude versie)",
      "visibility_usage": "Je bewijs is altijd zichtbaar voor jou en je organisatie zodra de activiteit is voltooid. Deze schakelaar bepaalt alleen of het ook platformbreed wordt gedeeld met andere organisaties. Laat deze uit voor alles wat nog niet is vrijgegeven of intern is; anders helpt delen om de bredere kennisbasis van Takso op te bouwen."
    },
    "goal": {
      "cultural_activity_must_have_outcome": "Cultureel (een activiteit moet een culturele uitkomst hebben)",
      "duplicate_modal_body": "Je activiteit is succesvol gedupliceerd. Controleer alstublieft Bewijs, Theory of Change, Activiteitsplan en Evaluatiepagina’s om te zorgen dat alle informatie up-to-date en relevant is voor de implementatie van de activiteit.",
      "duplicate_modal_title": "Activiteit succesvol gedupliceerd",
      "no_primary_domain_for_activity": "Geen primair domein voor deze activiteit",
      "no_second_domain_for_activity": "Geen secundair domein voor deze activiteit",
      "objective_goal_description": "Een gemeenschap die kunst, cultuur en erfgoed kent en waardeert.",
      "primary_policy_domain": "Primair domein",
      "primary_policy_domain_for_activity": "Primair domein voor activiteit",
      "primary_policy_domain_objectives": "{{policy_name}} Doelstellingen van het domein",
      "primary_policy_populated_from_goal": "Je primair beleidsdomein wordt ingevuld op basis van de geselecteerde doelstelling",
      "secondary_policy_domain": "Secundair domein",
      "secondary_policy_domain_for_activity": "Secundair beleidsdomein voor activiteit",
      "secondary_policy_domain_objectives": "{{policy_name}} domeindoelstellingen – tweede beleidsdomein",
      "secondary_policy_domains_optional": "Secundaire beleidsdomeinen voor activiteit (optioneel)",
      "secondary_policy_populated_from_goal": "Je secundair beleidsdomein wordt ingevuld op basis van de geselecteerde doelstelling",
      "select_primary_policy_domain": "Selecteer primair beleidsdomein",
      "select_primary_policy_domain_from_options": "Selecteer het primaire domein uit de beschikbare opties.",
      "select_secondary_policy_domain": "Selecteer een secundair beleidsdomein",
      "select_secondary_policy_domain_from_options": "Selecteer het secundaire domein uit de beschikbare opties.",
      "what_is_a_goal": "Een doel is een visie op de toekomst of een gewenst resultaat dat een persoon of een groep mensen voor ogen heeft, plant en zich ertoe verbindt te bereiken."
    },
    "group_unassign": {
      "confirm": "Weet je zeker dat je deze groep uit deze activiteit wilt loskoppelen?",
      "title": "Groep loskoppelen"
    },
    "home": {
      "activity_dates": "Data van de activiteiten",
      "activity_or_temporary_title_required": "Activiteitstitel of tijdelijke titel is vereist",
      "activity_plan_type_required": "Type activiteitplan is verplicht",
      "create": {
        "add_button": "Activiteit toevoegen",
        "modal_title": "Nieuw activiteitsrecord"
      },
      "dates_not_set": "Data nog niet vastgesteld",
      "delete": {
        "confirm": "Weet je zeker dat je deze activiteit wilt verwijderen?",
        "title": "Activiteit verwijderen"
      },
      "duplicate": {
        "created_with_previous_goal": "Deze activiteit is aangemaakt met een vorige doelstelling. Om deze te dupliceren, moet je een huidige doelstelling selecteren met overeenkomende domeinen",
        "goal": "Doel van de organisatie aan te pakken",
        "new_activity_name": "Nieuwe activiteitsnaam",
        "new_activity_required": "Nieuwe activiteitsnaam is vereist",
        "primary_domain_objectives": "{{policy_name}} domeindoelstellingen – primair beleidsdomein",
        "secondary_domain_objectives": "{{policy_name}} domeindoelstellingen – secundaire beleidsdomein",
        "title": "Activiteit dupliceren",
        "unable_to_duplicate": "Niet te dupliceren. De activiteit die je probeert te dupliceren, werd aangemaakt op basis van een vorig doel. Er zijn geen huidige doelen met bijpassende domeinen. Maak deze activiteit alstublieft opnieuw aan als een nieuw record."
      },
      "group_add": {
        "title": "Toevoegen aan groep"
      },
      "group_change": {
        "title": "Groep wijzigen"
      },
      "group_form": {
        "existing": "Bestaande groep",
        "name_required": "Nieuwe groepsnaam is vereist",
        "new": "Nieuwe groep",
        "new_name": "Nieuwe groepsnaam",
        "required_existing": "Bestaande groep is vereist",
        "select_existing": "Selecteer een bestaande groep",
        "select_placeholder": "Selecteer een groep"
      },
      "invited": {
        "request_withdrawal": "Verzoek tot opzegging"
      },
      "manage_group": {
        "modal_title": "Groepsbeheer",
        "trigger": "Groepen beheren"
      },
      "manage_group_form": {
        "actions": "Acties",
        "activity_count": "Aantal activiteiten",
        "no_groups": "Je hebt nog geen projectgroepen aangemaakt..."
      },
      "new_invitations": "Nieuwe uitnodigingen",
      "no_groups": "Geen groepen",
      "owned": {
        "add_to_group": "Toevoegen aan groep",
        "change_group": "Groep wijzigen",
        "duplicate": "Dupliceren",
        "remove_from_group": "Verwijderen uit groep",
        "view_team": "Bekijk team"
      },
      "program_list": {
        "activity_managed_by": "Beheerd door {{name}}",
        "hide_linked": "Alleen mijn activiteiten in {{name}} tonen",
        "linked_breakdown": "({{own}} door jezelf beheerd, {{others}} door anderen beheerd)",
        "linked_count_one": "{{count}} activiteit",
        "linked_count_other": "{{count}} activiteiten",
        "part_of": "Onderdeel van",
        "program_managed_by": "programma beheerd door {{name}}",
        "show_linked": "Alle activiteiten in {{name}} tonen"
      },
      "remove_group": {
        "confirmation": "Weet je zeker dat je deze activiteiten wilt splitsen?",
        "modal_title": "Groep verwijderen – {{groupName}}",
        "notification_body": "We konden de projectgroep niet verwijderen",
        "notification_title": "Er is iets misgegaan",
        "trigger": "Uit groep halen"
      },
      "rename_group": {
        "group_name_required": "Groepsnaam is vereist",
        "modal_title": "Groep hernoemen",
        "notificationBody": "We konden de activiteit niet indienen",
        "notification_title": "Er is iets misgegaan",
        "trigger": "Hernoemen"
      },
      "search_by_name": "Zoeken op activiteitsnaam",
      "steps": {
        "step_1": "Op deze pagina vind je al jouw activiteiten of waarvoor je bent uitgenodigd.",
        "step_2": "Gebruik dit om een nieuwe activiteit te starten",
        "step_3": "Al jouw activiteiten verschijnen in dit vak. De gekleurde tab geeft de status van de activiteit weer. Activiteiten waarvoor je bent uitgenodigd om bij te dragen, verschijnen in een aparte sectie hieronder.",
        "step_4": "Je kunt de activiteiten filteren die hier in het vak verschijnen."
      }
    },
    "individual_rate_of_change": {
      "activity_count": "Aantal activiteiten",
      "after_response": "Na reactie",
      "after_response_with_name": "{{name}} Na reactie",
      "aggregate_chart": "Samengevoegd",
      "average": "Gemiddelde",
      "before_response": "Voor reactie",
      "before_response_with_name": "{{name}} Voor reactie",
      "count": "aantal: ",
      "evaluation_plan": "evaluatieplan",
      "include_in_report": "Opnemen in rapport",
      "mgr_assessed_aggregate": "Beoordeeld door activiteitenbeheerder (geaggregeerd)",
      "mgr_assessed_separate": "Beoordeeld door activiteitenbeheerder (geaggregeerd)",
      "no_data_in_that_method": "Geen gegevens in die methode.",
      "no_response": "geen reactie",
      "no_responses": "Geen reacties",
      "participants": "Deelnemers",
      "post_result": "na resultaat: ",
      "pre_result": "voor resultaat: ",
      "respondent_percentage": "Percentage respondenten",
      "respondents": "Respondenten",
      "response": "{{name}} Reactie",
      "self_assessed_aggregate": "Zelfbeoordeeld - samengevoegd",
      "self_assessed_separate": "Zelfbeoordeeld - afzonderlijk",
      "separate_chart": "Afzonderlijk",
      "title": "Individuele mate van verandering"
    },
    "linked_activity": {
      "change_ownership": "Beheerder wijzigen",
      "enter_details_of_the_new_activity_manager": "Voer details van de nieuwe activiteitenbeheerder in",
      "notify_activity_manager": "Activiteitmanager informeren",
      "notify_activity_manager_confirm": "Weet u zeker dat je de activiteitenbeheerder wilt informeren?",
      "notify_existing_user": "Bestaande gebruiker op de hoogte stellen",
      "notify_new_user": "Nieuwe gebruiker op de hoogte stellen",
      "notify_of_changes": "Wijzigingen melden",
      "re_send_notification": "Notificatie opnieuw verzenden",
      "this_activity_will_be_managed_by": "Deze activiteit wordt beheerd door:"
    },
    "linked_activity_approval": {
      "accept_report": "Rapport goedkeuren",
      "report_approval_title": "RAPPORTGOEDKEURING",
      "review_report": "Rapport beoordelen"
    },
    "make_visible_in_takso_library": "Zichtbaar maken in de Takso-bibliotheek",
    "media": {
      "image_credit": {
        "label": "Bronvermelding",
        "placeholder": "Vermeld een credit of bron als dit in rapportages wordt gebruikt."
      }
    },
    "messages": {
      "activity_accepted": "Activiteit is succesvol goedgekeurd!",
      "activity_documentation": "Activiteitsdocumentatie",
      "activity_evidence": "Activiteitsbewijs",
      "activity_group": "Activiteitengroep",
      "activity_group_updated": "Activiteitengroep is succesvol bijgewerkt!",
      "activity_member": "Activiteitslid",
      "activity_member_added": "Je nieuwe activiteitslid is succesvol toegevoegd!",
      "activity_rejected": "Activiteit is succesvol afgewezen!",
      "evaluation_plan": "Evaluatieplan",
      "evaluation_plan_closed_next_active": "{{evalPlanName}} is succesvol gesloten en het volgende plan in de serie is nu actief!",
      "evaluation_plan_created": "Evaluatieplan is succesvol aangemaakt!",
      "evaluation_plan_deleted": "Evaluatieplan is succesvol verwijderd!",
      "evaluation_plan_updated": "Evaluatieplan is succesvol bijgewerkt!",
      "evaluation_template_uploaded": "Je evaluatiesjabloon is succesvol geüpload!",
      "final_evaluation_plan_closed": "Laatste evaluatieplan is succesvol gesloten.",
      "group_created": "Groep is succesvol aangemaakt!",
      "group_deleted": "Groep is succesvol verwijderd!",
      "group_updated": "Groep is succesvol bijgewerkt!",
      "linked_activity": "Gekoppelde activiteit",
      "linked_activity_deleted": "Gekoppelde activiteit is verwijderd.",
      "objective_evidences_created": "Doelstelling bewijzen zijn succesvol aangemaakt!",
      "objective_evidences_removed": "Doelstelling bewijzen zijn succesvol verwijderd!",
      "objective_evidences_updated": "Doelstelling bewijzen zijn succesvol bijgewerkt!",
      "outcome_summary": "Samenvatting uitkomsten",
      "outcome_summary_updated": "Samenvatting van de uitkomsten is met success bijgewerkt!",
      "participant_group": "Deelnemersgroep",
      "project_contractor": "Projectleverancier",
      "project_contractor_added": "Projectleverancier is succesvol toegevoegd!",
      "project_contractor_deleted": "Projectleverancier is succesvol verwijderd!",
      "project_group": "Projectgroep",
      "project_group_name": "Projectgroepnaam",
      "project_group_name_updated": "Je projectgroepsnaam is succesvol bijgewerkt!",
      "project_note_created": "Projectnotitie is succesvol aangemaakt!",
      "project_note_deleted": "Projectnotitie is succesvol verwijderd!",
      "project_notes": "Projectnotities",
      "project_partner": "Projectpartner",
      "project_partner_added": "Projectpartner is succesvol toegevoegd!",
      "project_partner_deleted": "Projectpartner is succesvol verwijderd!",
      "project_partner_description_updated": "Projectpartnerbeschrijving is succesvol bijgewerkt!",
      "project_references": "Projectreferenties",
      "project_references_updated": "Je projectreferenties zijn succesvol bijgewerkt!",
      "project_venue": "Projectlocatie",
      "project_venue_deleted": "Projectlocatie is succesvol verwijderd!",
      "project_venues": "Projectlocaties",
      "project_venues_added": "Projectlocaties zijn succesvol toegevoegd!",
      "projected_activity_activated": "Je geplande activiteit is geactiveerd.",
      "projected_activity_added": "Nieuwe geplande activiteit is toegevoegd.",
      "projected_activity_deleted": "Geplande activiteit is verwijderd.",
      "projected_activity_updated": "Je geplande activiteit is bijgewerkt.",
      "subtitle_deleted": "Ondertitel is succesvol verwijderd!"
    },
    "no_activity_selected": "Geen activiteit geselecteerd.",
    "notes": {
      "evaluation_results_analysis": "Evaluatieanalyse",
      "reflection": "Reflectie"
    },
    "objective": {
      "domain_objective": "Domeindoelstelling",
      "error": {
        "content": "Doelstellingen kun je alleen bijwerken voordat er deelnemersgegevens zijn verzameld. Er zijn al antwoorden van deelnemers geregistreerd op een evaluatieplan dat naar deze doelstelling verwijst."
      },
      "heading": "Beoogde uitkomst ({{policy}})",
      "missing_outcome_header": "Het spijt ons, we kunnen de uitkomst voor \"{{objective}}\" niet vinden.",
      "please_select_an_goal": "Selecteer alstublieft een doelstelling",
      "policy_domain_objective": "{{policy}}-domeindoelstelling",
      "select_placeholder": "Selecteren",
      "select_primary_domain": "Selecteer doelstelling voor {{policy}}-domein",
      "select_secondary_domain": "Selecteer doelstelling voor {{policy}}-domein",
      "warning": {
        "change_objective": "Je staat op het punt een doelstelling van deze activiteit te wijzigen; dit kan betekenen dat bewijs en theory of change gekoppeld aan de uitkomst niet langer relevant zijn. Indien je doorgaat, controleer dan alstublieft bewijs en theory of change.",
        "content": "Je staat op het punt de doelstelling van je activiteit te wijzigen. Controleer je bewijsmateriaal en 'theory of change' om er zeker van te zijn dat deze aansluiten bij deze wijziging. De tekst van de enquêtevragen wordt gereset naar de standaardwaarde; eventuele aanpassingen die je hebt gemaakt, gaan verloren."
      }
    },
    "outcome_summary": {
      "heading": "Samenvatting uitkomsten"
    },
    "participants": {
      "activity_manager": "Activiteitmanager",
      "add_guest_user": "Gastgebruiker toevoegen",
      "are_you_sure_you_want_to_delete_this_participant": "Weet je zeker dat je deze deelnemer wilt verwijderen?",
      "delete_participant": "Deelnemer verwijderen",
      "edit_permission_of": "Toegang bewerken van {{name}}",
      "email": "E-mail",
      "invitation_status": "Uitnodigingsstatus",
      "invite_user": "Gebruiker uitnodigen",
      "leave_withdrawn_in_list": "Naam van teruggetrokken lid in de ledenlijst laten staan",
      "manage_activity_members": "Beheer activiteitsleden",
      "member_name": "Naam lid",
      "message_is_required": "Bericht is vereist",
      "message_to_member": "Bericht aan lid",
      "notify_member": "Lid informeren",
      "owner": "Beheerder",
      "participant_remove_success": "Verwijderen deelnemer succesvol",
      "permission": "Toestemmingen",
      "please_enter_message_to_notify_participant": "Voer een bericht in om deelnemer te informeren",
      "remove_participant": "Deelnemer verwijderen",
      "remove_withdrawn_from_list": "Naam van teruggetrokken lid uit de ledenlijst verwijderen",
      "type": "Type",
      "update_permission": "Toestemmingen bijwerken",
      "user_was_removed_from_the_activity": "Gebruiker is verwijderd uit de activiteit",
      "we_couldnt_delete_the_activity": "We konden de activiteit niet verwijderen",
      "withdraw_confirm": "Verwijderen",
      "withdraw_member": "Lid verwijderen",
      "you_have_not_created_any_participants_yet": "Je hebt nog geen deelnemers aangemaakt…"
    },
    "permissions": {
      "guest_users_no_permission": "Gastgebruikers hebben geen toestemming om deze actie uit te voeren."
    },
    "preview": {
      "analysis_and_reflection": "Analyse en reflectie",
      "key_activity_data": "Belangrijke activiteitgegevens",
      "objective_intended_outcomes": "Doelstelling – Beoogde uitkomsten",
      "objective_intended_outcomes_with_policy": "Doelstelling – Beoogde uitkomsten ({{policy}})",
      "report_compiled_contact": "Als je je rapport binnen 15 minuten niet hebt ontvangen, neem dan contact op met",
      "report_compiled_line1": "Je rapport wordt samengesteld en wordt naar het e-mailadres dat aan dewe account is gekoppeld verzonden.",
      "report_compiled_line2": "Het kan enkele minuten duren om rapporten met meerdere grafieken samen te stellen.",
      "report_is_being_generated": "Rapport wordt gegenereerd"
    },
    "report": {
      "custom_reports": {
        "button_tooltip": "Bekijk een voorbeeld van een rapport voor deze activiteit en pas het aan",
        "button_tooltip_not_available": "De rapportgenerator is momenteel alleen beschikbaar voor enkelvoudige activiteiten"
      },
      "if_you_have_not_received_your_report_in_15_minutes_please_contact": "Als je je rapport niet binnen 15 minuten ontvangt, neem dan contact op met",
      "report_being_generated": "Rapport wordt gegenereerd",
      "reports_with_multiple_graphs_may_take_a_few_minutes_to_generate": "Rapporten met meerdere grafieken kunnen enkele minuten duren om te worden gegenereerd.",
      "show_in_report": "Tonen in rapport",
      "your_report_is_being_compiled_and_will_be_sent_to_the_email_address_associated_with_this_account": "Je rapport wordt samengesteld en wordt verzonden naar het e-mailadres dat is gekoppeld aan deze account."
    },
    "report_activity": {
      "activity_description": "Activiteitsbeschrijving",
      "festival_types": "Festivaltypes",
      "organisation_goal": "Doel van de organisatie",
      "period_to": " tot "
    },
    "search": {
      "no_activities_found": "Geen activiteiten gevonden",
      "no_activities_found_matching_filters": "Geen activiteiten gevonden die overeenkomen met je filters",
      "search_by_activity_name_or_id": "Zoeken op activiteitsnaam of ID"
    },
    "takso_access": "Takso-toegang",
    "theory_of_change": {
      "create_theory_of_change": "Theory of Change aanmaken",
      "describe_activity_required": "Beschrijf op basis van wat je hierboven hebt ingevoerd wat je gaat doen om de uitkomst te bereiken",
      "describe_how_this_program_will_be_structured_to_achieve_the_objectives": "Beschrijf hoe dit programma zal worden opgebouwd om de doelstellingen te bereiken",
      "evidence_types_used": "Gebruikt bewijs",
      "preview_theory_of_change": "Bekijk Theory of Change",
      "primary_domain": "",
      "secondary_domain_one": "",
      "secondary_domain_other": "",
      "selected_outcome": "Geselecteerde uitkomst",
      "summarise_strongest_points": "Geef een samenvatting van het bewijsmateriaal dat je aanpak van de activiteit onderbouwt.",
      "we_are_aiming_for_outcomes_in_no_selected_domains": "",
      "we_are_aiming_for_outcomes_in_the_selected_domains_one": "",
      "we_are_aiming_for_outcomes_in_the_selected_domains_other": ""
    },
    "unarchive_parent_before_duplicating": "\"{{parentName}}\" moet eerst uit het archief worden gehaald voordat je deze activiteit daarin kunt dupliceren."
  },
  "activity_manager_description": "{{percentage}} van deze reacties is beoordeeld door de activiteitenbeheerder. Bij deze methode observeert de activiteitenbeheerder de deelnemers en schat in welke beoordeling zij zouden geven, en modelleert vervolgens een verdeling met behulp van een standaarddeviatie. Dit is een indirecte maatstaf en geen beoordeling die rechtstreeks bij de deelnemers is verzameld. De bovenstaande verdeling kan het oordeel van de beheerder weerspiegelen in plaats van de eigen ervaring van de deelnemers, en moet in dat licht worden geïnterpreteerd.",
  "activity_status": {
    "active": "Actief",
    "all": "Alle",
    "all_activities": "Alle activiteiten",
    "archived": "Gearchiveerd",
    "completed": "Voltooid",
    "completed_activities": "Voltooide activiteiten",
    "deactivated": "Gedeactiveerd",
    "documentation_delayed": "Documentatie vertraagd",
    "in_development": "In ontwikkeling",
    "labels": {
      "active": "Actief",
      "cancelled": "Geannuleerd",
      "completed": "Voltooid",
      "draft": "Concept",
      "greenlit": "Groen licht gegeven"
    },
    "missed_green_light": "Gemist 'groen licht'",
    "ongoing": "Lopend",
    "ongoing_activities": "Lopende activiteiten",
    "projected": "Gepland",
    "ready_to_archive": "Klaar om te archiveren"
  },
  "activity_type": {
    "all_types": "Alle typen",
    "festival": "Festival",
    "festival_program": "Festivalprogramma",
    "grant": "Subsidie",
    "grants_program": "Subsidieprogramma",
    "linked": "Gekoppeld",
    "linked_activity": "Gekoppelde activiteit",
    "multi_activity": "Multi-activiteit",
    "multi_activity_program": "Meervoudige activiteitenprogramma",
    "single": "Enkelvoudig",
    "single_activity": "Enkele activiteit"
  },
  "admin": {
    "account": {
      "added_successfully": "Account is succesvol toegevoegd!",
      "created_successfully": "Account is succesvol aangemaakt!",
      "info_label": "Accountinformatie",
      "updated_successfully": "Je accountinformatie is succesvol bijgewerkt!"
    },
    "account_permission": {
      "label": "Accountrechten"
    },
    "account_permission_group": {
      "added_successfully": "Accountrechtengroep is succesvol toegevoegd!"
    },
    "activity_settings": {
      "activity_types": {
        "add_activity_type": "Activiteitstype toevoegen",
        "create_activity_type": "Activiteitstype aanmaken",
        "edit_activity_details": "Activiteitsdetails bewerken",
        "no_activity_details": "Geen activiteitsdetails",
        "output_fields": "Outputvelden"
      },
      "evaluation_methods_tab": "Evaluatiemethoden",
      "evaluation_questions": {
        "enable": "Inschakelen",
        "evaluation_question": "Evaluatievraag",
        "introduction_outcome_measure": "Introductie uitkomstmaat",
        "post_pre_test_question": "Dit resultaat heeft een post-pre-testvraag",
        "preamble_required": "Inleiding is vereist",
        "question_1": "Vraag 1",
        "question_1_required": "Vraag 1 is vereist",
        "question_2": "Vraag 2",
        "question_2_required": "Vraag 2 is vereist"
      },
      "evaluation_questions_tab": "Evaluatievragen",
      "outcomes": {
        "add_outcome": "Uitkomst toevoegen",
        "create_outcome": "Uitkomst aanmaken",
        "enable": "Inschakelen"
      },
      "output_formatters": {
        "add_format_groups": "Formaatgroepen toevoegen",
        "add_output_format": "Outputformaat toevoegen",
        "checkbox_names": "Selectievaknamen",
        "checkbox_options": "Selectievakopties",
        "create_output_format": "Outputformaat aanmaken",
        "create_output_format_group": "Outputformatgroep aanmaken",
        "delete_confirmation": "Verwijder bevestiging",
        "delete_output_format_confirm": "Weet je zeker dat je dit outputformaat wilt verwijderen?",
        "delete_output_format_group_confirm": "Weet je zeker dat je deze outputformaatgroep wilt verwijderen?",
        "edit_format_group": "Formaatgroep bewerken",
        "edit_output_format": "Outputformaat bewerken",
        "field_name": "Veldnaam",
        "field_name_required": "Veldnaam is vereist",
        "format_group": "Formaatgroep",
        "formula": "Formule",
        "formula_no_whitespace": "De formule mag geen spaties bevatten",
        "formula_required": "Formule is vereist",
        "include_formula": "Formule opnemen",
        "label_name": "Labelnaam",
        "label_required": "Label is vereist",
        "no_output_formats_yet": "Je hebt nog geen outputformaten aangemaakt...",
        "search_by_name_or_field": "Zoeken op naam of veldnaam",
        "type_required": "Type is vereist",
        "view_format_groups": "Formaatgroepen bekijken"
      },
      "output_formatters_tab": "Outputformatteerders",
      "reference_formal_version": "Referentie: formele versie ({{locale}})",
      "title": "Activiteitsinstellingen"
    },
    "activity_type": {
      "added_successfully": "Activiteitstype is succesvol toegevoegd!",
      "updated_successfully": "Activiteitstype is succesvol bijgewerkt!"
    },
    "email": {
      "sent_successfully": "E-mail is succesvol verzonden!"
    },
    "email_logs": {
      "advanced_search": "Geavanceerd zoeken",
      "context": "Context",
      "dates": "Datums",
      "email_content_preview": "Voorbeeld van e-mailinhoud",
      "email_logs_advanced_search": "E-maillogs - Geavanceerd zoeken",
      "email_logs_details": "E-maillogs - Details",
      "message": "Bericht",
      "no_email_logs_yet": "Nog geen e-maillogs...",
      "no_html_content": "Geen HTML-inhoud beschikbaar voor deze e-mail.",
      "recipient_email_address": "E-mailadres van ontvanger",
      "search_by_recipient_name_or_email": "Zoeken op naam of e-mailadres van ontvanger",
      "search_subject": "Onderwerp zoeken",
      "send_test_email": "Test-e-mail verzenden",
      "status": "Status",
      "subject": "Onderwerp",
      "template": "Sjabloon",
      "test_email_queued": "Test-e-mail staat in de wachtrij om te worden verzonden.",
      "to": "Aan",
      "to_user": "Aan de gebruiker"
    },
    "evaluation_methods": {
      "facilitator_notes": "Tips voor het uitvoeren van deze evaluatie",
      "method": "Methode",
      "no_methods": "Geen methoden",
      "respondent_type": "Type respondent"
    },
    "evaluation_question": {
      "label": "Evaluatievraag",
      "updated_successfully": "Evaluatievraag is succesvol bijgewerkt!"
    },
    "feature": {
      "added_successfully": "Functie is succesvol toegevoegd!",
      "label": "Functie",
      "updated_successfully": "Functie is succesvol bijgewerkt!"
    },
    "help_page": {
      "added_successfully": "Hulppagina is succesvol toegevoegd!",
      "label": "Hulppagina",
      "updated_successfully": "Hulppagina is succesvol bijgewerkt!"
    },
    "help_tip": {
      "added_successfully": "Hulptip is succesvol toegevoegd!",
      "label": "Hulptip",
      "updated_successfully": "Hulptip is succesvol bijgewerkt!"
    },
    "individual": {
      "label": "Individu"
    },
    "industry": {
      "added_successfully": "Sector is succesvol toegevoegd!",
      "label": "Sector  ",
      "updated_successfully": "Sector is succesvol bijgewerkt!"
    },
    "invoice": {
      "label": "Facturen",
      "status_updated_successfully": "Factuurstatus is succesvol bijgewerkt!"
    },
    "logs": {
      "email_logs": "E-maillogbestanden",
      "logs": "Logbestanden",
      "system_logs": "Systeemlogboeken"
    },
    "method": {
      "label": "Methode",
      "updated_successfully": "Methode is succesvol bijgewerkt!"
    },
    "outcome": {
      "added_successfully": "Uitkomst is succesvol toegevoegd!",
      "label": "Uitkomst",
      "updated_successfully": "Uitkomst is succesvol bijgewerkt!"
    },
    "output_format": {
      "added_successfully": "Outputformaat is succesvol toegevoegd!",
      "deleted_successfully": "Outputformaat is succesvol verwijderd!",
      "label": "Outputformaat",
      "updated_successfully": "Outputformatter is succesvol bijgewerkt!"
    },
    "output_format_group": {
      "label": "Outputformatgroep",
      "updated_successfully": "Outputformatgroep is succesvol bijgewerkt!"
    },
    "permission_group": {
      "added_successfully": "Rechtengroep is succesvol toegevoegd!",
      "label": "Rechtengroep",
      "updated_successfully": "Rechtengroep is succesvol bijgewerkt!"
    },
    "question": {
      "enable_disable_updated_successfully": "In-/uitschakelen van vraag is succesvol bijgewerkt!",
      "label": "Vraag"
    },
    "system_feature": {
      "activate": "Activeren",
      "active_status": "Actieve status",
      "add_new_feature": "Nieuwe functie toevoegen",
      "add_permission_group": "Rechtengroep toevoegen",
      "create_new_feature": "Nieuwe functie aanmaken",
      "create_permission_group": "Toegangsgroep aanmaken",
      "feature_details": "Functiedetails",
      "feature_name": "Functienaam",
      "feature_name_required": "Functienaam is vereist",
      "name_required": "Naam is vereist",
      "no_features": "Geen functies...",
      "no_permission_grants": "Geen verleende rechten",
      "not_visible": "Niet zichtbaar",
      "please_enter_a_version": "Voer een versie in",
      "search_by_feature_name": "Zoeken op functienaam",
      "search_by_permission_name": "Zoeken op rechtennaam",
      "select_all": "Alles selecteren",
      "userstory_link": "Userstory-link",
      "visibility": "Zichtbaarheid",
      "visible": "Zichtbaar"
    },
    "system_logs": {
      "advance_search": "Geavanceerd zoeken",
      "advance_search_header": "Geavanceerd zoeken",
      "advanced_search": "Geavanceerd zoeken",
      "change_activity_type": "Activiteitstype wijzigen",
      "guest_user": "Gastgebruiker",
      "handle_submit_activity_type": "Beheer inzending activiteitstype:",
      "keyword": "Trefwoord",
      "message": "Bericht",
      "no_data_activity_type": "Geen gegevens in dat datumbereik, activiteitstype of geselecteerde uitkomst.",
      "no_logs": "Geen logboeken...",
      "selected_activity_type_description": "BESCHRIJVING GESELECTEERD ACTIVITEITSTYPE",
      "title": "Logboeken"
    },
    "system_reports": {
      "account_count": "Aantal accounts",
      "activity_count": "Aantal activiteiten",
      "activity_summary": "Activiteitsoverzicht",
      "actual_expenditures": "Werkelijke uitgaven",
      "aggregate": "Opgeteld",
      "aggregrate_tab": "Opgeteld",
      "calendar_year": "Kalenderjaar",
      "chart_type": "Grafiektype",
      "completed_activities": "Voltooide activiteiten",
      "dataset": "Dataset",
      "date_range": "Datumbereik",
      "download_csv_template": "CSV-sjabloon downloaden",
      "enter_activity_count": "Voer aantal activiteiten in",
      "festival_program": "Festivalprogramma",
      "financial_reporting_period": "Financiële rapportageperiode",
      "financial_year": "Boekjaar",
      "grant_program": "Subsidieprogramma",
      "headline_data": "Kerngegevens",
      "individual_rate_of_change": "Individuele mate van verandering",
      "intercept_aggregate": "Interceptaggregaat",
      "invalid_format": "Ongeldig formaat, gebruik het volgende formaat",
      "january_1_to_december_31": "1 januari tot 31 december",
      "july_1_to_june_30_following_year": "1 juli tot 30 juni volgend jaar",
      "linked_activity": "Gekoppelde activiteit",
      "manual_outcomes_summary": "Handmatig overzicht uitkomsten",
      "method": "Methode",
      "multi_activity_program": "Multi-activiteitsprogramma",
      "ongoing_activities": "Lopende activiteiten",
      "outcomes_summary": "Overzicht uitkomsten",
      "preview_report": "Voorbeeldrapport",
      "projected_expenditures": "Verwachte uitgaven",
      "reference": "Referentie",
      "report_year": "Rapportjaar",
      "save_chart": "Grafiek opslaan",
      "separate": "Gescheiden",
      "system_overview": "Systeemoverzicht",
      "title": "Systeemrapporten",
      "total_participants": "Totaal aantal deelnemers",
      "total_respondents": "Totaal aantal respondenten",
      "trend_rate_of_change": "Trend mate van verandering",
      "trend_rate_of_change_tab": "Trend - Mate van verandering",
      "upload_template": "Sjabloon uploaden",
      "your_report_will_be_previewed_here": "Je rapport wordt hier weergegeven"
    },
    "system_settings": {
      "export": {
        "all_organisations": "Alle organisaties",
        "filter_by_organisation": "Filter op organisatie"
      },
      "helps": {
        "add_help_page": "Hulppagina toevoegen",
        "add_help_tip": "Hulptip toevoegen",
        "content": "Inhoud",
        "create_help_page": "Hulppagina aanmaken",
        "create_tip": "Tip aanmaken",
        "edit_help_page": "Hulppagina bewerken",
        "edit_help_tip": "Hulptip bewerken",
        "field_name": "Veldnaam",
        "field_name_header": "Veldnaam",
        "field_name_lower": "Veldnaam",
        "field_name_lower_required": "Veldnaam is vereist",
        "field_name_required": "Veldnaam is vereist",
        "help_page_is_required": "Hulppagina is vereist",
        "help_page_name": "Naam van hulppagina",
        "help_page_required": "Hulppagina is vereist",
        "id": "ID",
        "select_help_page": "Selecteer hulppagina"
      },
      "industry_sector_types": {
        "add_industry_sector_type": "Sectortype toevoegen",
        "create_industry_sector_type": "Sectortype aanmaken",
        "edit_industry_sector_type": "Sectortype bewerken",
        "sector_type_description": "Beschrijving van sectortype",
        "sector_type_description_required": "Beschrijving van sectortype is vereist"
      },
      "page_title": "Systeeminstellingen",
      "system_data_export": "Systeemdata-export",
      "system_data_export_title": "Systeemdata-export",
      "system_help": "Systeemhulp",
      "system_help_title": "Systeemhulp",
      "venue_types": {
        "add_venue_type": "Locatietype toevoegen",
        "create_venue_type": "Locatietype aanmaken",
        "edit_venue_type": "Locatietype bewerken",
        "enter_sector_type_description": "Voer een beschrijving van het sectortype in",
        "environmental_tester_only": "Alleen voor omgevingstesters",
        "venue_no_street_address": "Deze locatie heeft geen straatadres",
        "venue_options_must_have_english_text": "De locatieoptie(s) {{value}} moeten in het Engels zijn opgesteld.",
        "venue_type_options": "Opties voor locatietype"
      }
    },
    "user": {
      "account_guest_user_label": "Gastgebruiker van account",
      "account_updated_successfully": "Accountgebruiker is succesvol bijgewerkt!",
      "account_user_label": "Accountgebruiker",
      "all_invited_activities_withdrawn": "Alle uitgenodigde activiteiten van gebruiker zijn ingetrokken!",
      "created_successfully": "Gebruiker is succesvol aangemaakt!",
      "deleted_successfully": "Gebruiker is succesvol verwijderd!",
      "guest_updated_successfully": "Gastgebruiker is succesvol bijgewerkt!",
      "new_user_label": "Nieuwe gebruiker",
      "type_updated_successfully": "Gebruikerstype is succesvol bijgewerkt!"
    },
    "user_organisation": {
      "accounts": {
        "account_permission_group": "Accountrechtengroep",
        "account_type": "Accounttype:",
        "account_type_and_subscription": "Accounttype en abonnement",
        "activate_account": "Account activeren",
        "activate_accounts": "Accounts activeren",
        "add_new_account": "Nieuw account toevoegen",
        "admin_details": "Beheerdersgegevens",
        "amount": "Bedrag",
        "badges": {
          "demo": "Demo",
          "evidence_blocked": "Bewijs geblokkeerd"
        },
        "bank_reference_id": "Bankreferentie-ID",
        "bank_reference_id_required": "Bankreferentie is vereist",
        "billing_and_invoices": "Facturatie en facturen",
        "block_evidence": "Bewijs blokkeren",
        "comments": "Opmerkingen",
        "comments_required": "Beschrijving is vereist",
        "date": "Datum",
        "date_required": "Datum is vereist",
        "demo_account": "Demo-account",
        "edit_account": "Account bewerken",
        "edit_account_type": "Accounttype bewerken",
        "edit_permission": "Rechten bewerken",
        "features": "Functies",
        "graded_qsts": "Gescoorde vragen standaard",
        "invoice_id": "Factuurnummer",
        "last_payment": "Laatste betaling",
        "manage_account": "Account beheren",
        "mark_as_paid_now": "Markeren als betaald",
        "marked_by": "Gemarkeerd door",
        "marked_on": "Gemarkeerd op",
        "no_features": "Geen functies...",
        "no_invoices_for_organisation": "Er zijn geen facturen voor deze organisatie...",
        "no_of_users": "Aantal gebruikers",
        "organisation_code": "Organisatiecode",
        "organisation_details": "Organisatiedetails",
        "payment_preference": "Betaalvoorkeur",
        "permission_group": "Rechtengroep",
        "permissions": "Rechten",
        "required_program_feature": "Programmafunctie is vereist",
        "search_by_name_email": "Zoeken op naam / e-mail",
        "select_account_type": "Selecteer accounttype",
        "select_at_least_one_permission_group": "Selecteer minstens één rechtengroep",
        "select_payment_preference": "Selecteer betaalvoorkeur",
        "select_subscription": "Abonnement selecteren",
        "subscription": "Abonnement",
        "system": "Systeem",
        "takso_support_email": "Takso-support e-mail (het systeem verstuurt geen e-mails naar dit adres)",
        "update_permission": "Rechten bijwerken",
        "will_be_not_added_since_all_feature_groups_are_redundant": "{{redundantPermission}} wordt niet toegevoegd omdat alle functiegroepen redundant zijn."
      },
      "communication": {
        "all_system_users": "Versturen naar alle systeemgebruikers",
        "broadcast_message": "Broadcastbericht",
        "broadcast_new_message": "Nieuw broadcastbericht",
        "contact_organisation_users": "CONTACTEER ORGANISATIEGEBRUIKERS",
        "contact_takso_support": "CONTACT TAKSO SUPPORT",
        "errors": {
          "message_reqd": "Bericht is verplicht",
          "select_a_target": "Selecteer ten minste één bestemming (e-mail of dashboard)",
          "select_one_option_required": "Kies een bestemming",
          "select_organisation_required": "Kies een organisatie"
        },
        "message": "Bericht",
        "new_badge": "Nieuw",
        "no_notification_found": "Geen melding gevonden...",
        "send_to_all_organisation": "Versturen naar alle organisaties",
        "send_to_all_users": "Versturen naar alle gebruikers",
        "send_to_myself": "Test naar mijzelf versturen",
        "send_to_only_admins": "Alleen naar beheerders versturen",
        "send_to_selected_organisation": "Versturen naar geselecteerde organisaties",
        "table": {
          "action": "Actie",
          "all_organisations": "Alle organisaties",
          "all_system_users": "Alle systeemgebruikers",
          "created_at": "Aangemaakt op",
          "sender": "Afzender",
          "test_message": "Testbericht"
        },
        "view_broadcast_message": "Broadcastbericht bekijken"
      },
      "graded_questions_on_by_default": "Gescoorde vragen zijn standaard ingeschakeld",
      "page_title": "Gebruikers en organisaties",
      "users": {
        "are_you_sure_you_want_to_delete_this_user": "Weet je zeker dat je deze gebruiker wilt verwijderen?",
        "change_user_type": "Gebruikerstype wijzigen",
        "delete_user": "Gebruiker verwijderen",
        "download_takso_users": "Takso-gebruikers downloaden",
        "edit_organisation": "Organisatie bewerken",
        "edit_user": "Gebruiker bewerken",
        "manage_users": "Gebruikers beheren",
        "no_users": "Geen gebruikers...",
        "reassign": {
          "activity_group_description": "Deze activiteit maakt deel uit van een groep met {{count}} andere activiteiten. Als je deze activiteit wilt verwijderen uit de groep en toewijzen aan een andere gebruiker, selecteer 'Enkele activiteit'. Als je alle activiteiten in de groep wilt overdragen aan een nieuwe gebruiker, selecteer 'Alle activiteiten'.",
          "reassign_all_activities": "Alle activiteiten overdragen",
          "reassign_an_activity": "Een activiteit overdragen",
          "select_activity_placeholder": "Selecteer activiteit",
          "select_project": "Selecteer project",
          "select_project_and_reassign": "Selecteer een project om over te dragen naar een andere gebruiker",
          "transfer_all": "Selecteer een gebruiker om activiteiten van over te dragen naar een andere gebruiker"
        },
        "reset_password": "Wachtwoord opnieuw instellen",
        "search_by_user": "Zoeken op gebruiker",
        "takso_support_email": "Takso-support e-mail (het systeem verstuurt geen e-mails naar dit adres)",
        "the_account_associated_with_this_user_is_currently_disabled": "Het account dat bij deze gebruiker hoort is momenteel uitgeschakeld",
        "user_has_active_development_activities": "Gebruiker heeft {{count}} actieve / ontwikkelingsactiviteiten. Activiteiten voor deze gebruiker moeten eerst worden overgedragen."
      }
    },
    "users": {
      "login_as": "Log in als {{name}} (#{{id}}) en ga naar Activiteit",
      "login_as_id": "Inloggen als #{{id}}"
    },
    "venue_type": {
      "added_successfully": "Locatietype is succesvol toegevoegd!",
      "updated_successfully": "Locatietype is succesvol bijgewerkt!"
    }
  },
  "audit": {
    "activities_with_no_resolvable_org": "Inspectie: Activiteiten zonder toewijsbare organisatie",
    "activity_universe_funnel": "Trechter van alle activiteiten",
    "data_audit": "Data-audit",
    "deleted_excluded_from_universe": "Verwijderd (uitgesloten uit de dataset): <strong>{{numDeleted}}</strong> · Uitgesloten van de geldige gegevens: activiteiten waarbij de organisatie niet kan worden vastgesteld of die bij een demo-account horen.",
    "internal_data_quality_checks": "Interne controles van de gegevenskwaliteit — alleen voor beheerders.",
    "linked_singles_with_no_valid_parent": "Inspectie: Gekoppelde enkelvoudige activiteiten zonder geldig bovenliggend programma",
    "no_issues_found": "Geen problemen gevonden.",
    "non_deleted_activities_parent_not_resolved": "Niet-verwijderde activiteiten waarvan noch de organisatie van de beheerder, noch de organisatie van de beheerder van het bovenliggende programma kan worden vastgesteld. Er worden maximaal 200 weergegeven.",
    "percentage_of_total": "% van totaal",
    "reportable_singles_by_status": "Rapporteerbare enkelvoudige activiteiten per status",
    "singles_flagged_as_linked": "Enkelvoudige activiteiten gemarkeerd als gekoppeld (isLinkedActivity=1) maar zonder geldige rij voor een bovenliggend programma, of waarvan het bovenliggende item geen programmatype is. Maximaal 200 weergegeven.",
    "tables": {
      "headings": {
        "demo": "Demo?",
        "direct_org": "Directe organisatie",
        "id": "ID",
        "name": "Naam",
        "org": "Organisatie",
        "owner_email": "E-mail beheerder",
        "parent_id": "ID bovenliggend programma",
        "parent_name": "Naam bovenliggend programma",
        "parent_org": "Organisatie bovenliggend programma",
        "parent_plan_type": "Plantype bovenliggend programma",
        "parent_program": "Bovenliggend programma",
        "pct_of_universe": "% van totaal",
        "programs": "Programma's",
        "reason": "Reden",
        "reportable": "Rapporteerbaar",
        "singles": "Enkelvoudige activiteiten",
        "status": "Status",
        "tier": "Niveau",
        "type": "Type",
        "universe": "Totaal",
        "valid": "Geldig"
      }
    }
  },
  "auth": {
    "account": {
      "disabled": {
        "description": {
          "line1": "Dit account is gedeactiveerd.",
          "line2": "Voor meer informatie of hulp, neem contact met ons op via <1>{{contactEmail}}</1>"
        },
        "title": "Inactief account"
      }
    },
    "errors": {
      "idle1": "Je sessie is verlopen!",
      "idle2": "Je bent te lang inactief geweest, je moet opnieuw inloggen."
    },
    "forgot_password": {
      "back_to_signin": "Terug naar inloggen",
      "contact_us": "Neem contact met ons op",
      "email_placeholder": "Voer je e-mailadres in",
      "form_subtitle": "We helpen je weer toegang te krijgen.",
      "form_title": "Wachtwoord vergeten?",
      "instructions": "Voer het e-mailadres in dat je hebt gebruikt bij registratie en we sturen je instructies om je wachtwoord opnieuw in te stellen.",
      "invalid_email": "Voer een geldig e-mailadres in",
      "recovery_sub": "We hebben een herstel-link gestuurd naar",
      "reset_button": "Wachtwoord opnieuw instellen",
      "subtitle": "We helpen je weer toegang te krijgen",
      "title": "Wachtwoord vergeten?"
    },
    "hello": "Hallo!",
    "help": {
      "answer": "Antwoord:",
      "frequently_asked_questions": "Veelgestelde vragen",
      "no_takso_administrators_found": "Geen Takso beheerders gevonden…",
      "q1": {
        "description": "Takso Outcomes Planning Platform® is een cloud-based service geleverd door Cultural Development Network om producenten, presenters, planners en kunstenaars te helpen hun activiteiten te plannen, bouwen, registreren en evalueren. <1>Meer informatie</1>",
        "title": "Q1. Wat is Takso?"
      },
      "q2": {
        "description": "Er zijn vier bronnen van hulp.",
        "description_line1": "Wanneer je voor het eerst inlogt, wordt elke pagina ingeleid met onboarding tips. Deze tips kunnen worden ingeschakeld of uitgeschakeld via de profielinstellingen onder je naam.",
        "description_line2": "Pagina Help sliders kunnen worden geactiveerd door het selecteren van de oranje ‘i’ informatiepictogram op de bovenste titelbalk van de pagina.",
        "description_line3": "Hover-over tips zijn beschikbaar. Wanneer je met de muis pointer over een veld in het lichaam van een pagina houdt, zie je een kort help-tekst die verschijnt.",
        "description_line4": "Je kunt contact opnemen met je Takso Administrator/s via de contactgegevens hierboven.",
        "title": "Q2. Waar kan ik meer informatie vinden over hoe Takso werkt?"
      },
      "q3": {
        "description": "Alleen jij en de mensen waarmee je samenwerkt bij de activiteit kunnen je werk zien en dit kan worden beperkt of uitgebreid door de toegang die je ze geeft. Wanneer je een activiteit voltooit en deze wordt gearchiveerd, is de <strong>‘Rapport’</strong> openbaar voor andere Takso-gebruikers op het systeem.",
        "title": "Q3. Is mijn werk privé?"
      },
      "q4": {
        "description": "Takso vangt de volledige verhaal van een activiteit op, inclusief uw eigen reflectie over wat het bereikt heeft. Door deze samenvattende informatie te delen, kunnen anderen van onze ervaringen leren, en op de langere termijn bouwen we onze collectieve kennis over het sector.",
        "title": "Q4. Waarom deelt Takso mijn eindrapport met anderen?"
      },
      "q5": {
        "description": "De ingave die je maakt in Takso wordt automatisch opgeslagen naarmate je verdergaat.",
        "title": "Q5. Is er een 'Opslaan' knop om mijn werk op te slaan"
      },
      "takso_administrators": "Takso beheerders"
    },
    "invite_link_expired": {
      "line1": "Het lijkt erop dat deze uitnodigingslink kapot is of al is gebruikt.",
      "line2": "Neem contact op met de activiteitmanager, hun details staan in de uitnodigingsemail.",
      "this_invite_link_is_no_longer_active": "Deze uitnodigingslink is niet meer actief."
    },
    "organization_welcome": {
      "back_to_home_page": "Terug naar homepagina",
      "hello": "Hallo!",
      "line1": "We hebben je accountgegevens succesvol ontvangen.",
      "line2": "Een van onze agenten zal je contacteren.",
      "thank_you_for_signed_up_with_takso": "Bedankt voor het registreren bij Takso."
    },
    "pages": {
      "account_access": "Accounttoegang",
      "email_verification": "E-mailverificatie",
      "forgot_password": "Wachtwoord vergeten",
      "invitation_verification": "Uitnodigingsverificatie",
      "reset_password": "Wachtwoord opnieuw instellen",
      "sign_in": "Inloggen",
      "user_profile": "Gebruikersprofiel",
      "user_registration": "Gebruikersregistratie"
    },
    "password_changed": {
      "success_button": "Terug naar inloggen",
      "success_line_1": "Je wachtwoord is succesvol gewijzigd. Je kunt nu inloggen",
      "success_line_2": "met je nieuwe wachtwoord.",
      "success_title": "Wachtwoord gewijzigd!"
    },
    "password_link_expired": {
      "description": {
        "line1": "Je aanvraag om je wachtwoord te resetten is verlopen of de link is",
        "line2": "al gebruikt."
      },
      "title": "Dit wachtwoord reset link is niet meer actief."
    },
    "reset_password": {
      "button": "Terug naar inloggen",
      "description": "Stel een nieuw wachtwoord in voor je account",
      "title": "Nieuw wachtwoord aanmaken"
    },
    "settings": {
      "help_tips": "Hulpsuggesties",
      "show_application_help_tips": "Toon hulpsuggesties voor de applicatie",
      "show_onboarding_help_tips": "Toon onboarding-hulpsuggesties"
    },
    "sign_in": "Inloggen",
    "sign_up": {
      "already_have_an_account": "Heb je al een account?",
      "good_news": "Goed nieuws! <orange>Takso</orange> kan een grote fit zijn voor je bedrijf en mensen over de hele wereld vertrouwen ons.",
      "multiple_users_in_one_organisation": "Meerdere gebruikers in één organisatie",
      "quote_name": "Chanie Hyde",
      "quote_name_sub": "Beta Launch",
      "quote_text": "“Ik denk dat wat geweldig is aan Intercom is dat elke bericht onmiddellijk en persoonlijk voelt, waardoor we kunnen schalen terwijl we echte blijven.”",
      "subtitle": "Registreren om verder te gaan",
      "title": "Registreren",
      "to_manage_your_own_activities": "Om je eigen activiteiten te beheren",
      "what_type_of_account": "Wat voor soort account?"
    },
    "signin": {
      "email": "E-mail",
      "new_user": "Nieuwe gebruiker? Neem contact met ons op via ",
      "password_forgot": "Wachtwoord vergeten?",
      "subtitle": "Log in om verder te gaan.",
      "tagline": "<orange>Plannen</orange> en evalueren eenvoudig gemaakt... en de uitkomsten zijn krachtig",
      "takso_definition": {
        "1": "<bold>Een productiviteitstool:</bold> bespaart tijd bij het plannen en rapporteren van activiteiten",
        "2": "<bold>Een leermiddel:</bold> vergroot onze kennis als artiesten en producenten",
        "3": "<bold>Een pleitbezorgingstool:</bold> levert bewijs voor verdere investeringen",
        "4": "<bold>Een innovatietool:</bold> wijst ons de weg naar nieuwe denkwijzen",
        "5": "<bold>Een evaluatietool:</bold> begeleidt consistente planning voor evaluatie",
        "6": "<bold>Een ideeënbank:</bold> is een database van elke denkbare culturele activiteit",
        "7": "<bold>Gemakkelijk te gebruiken:</bold> het is online en maakt gebruik van intuïtieve menselijke processen",
        "intro": "Wat is <orange>Takso?</orange>"
      },
      "title": "Hallo!"
    },
    "subscription_details": {
      "select_subscription_type": "Selecteer abonnementstype...",
      "select_your_subscription_plan_and_enjoy_a_14_days_free_trial": "Selecteer je abonnement en geniet van een 14-daagse gratis proefperiode",
      "subscription_details": "Abonnementsdetails",
      "subscription_plan": "Abonnementplan",
      "subscription_type_required": "Abonnementstype is vereist",
      "your_plan_includes": "Je plan omvat"
    },
    "user_profile": {
      "change_password": "WACHTWOORD WIJZIGEN",
      "profile_details": "PROFIELGEGEVENS"
    },
    "user_registration": {
      "you_are_invited": "Je bent uitgenodigd!",
      "you_have_been_invited_please_complete_the_registration_to_continue": "Je bent uitgenodigd bij Takso. Vul alstublieft de registratie in om verder te gaan"
    },
    "verification": {
      "almost_there": "Bijna klaar!",
      "button": "Terug naar inloggen",
      "description": {
        "line1": "Klik op de link die net naar je e-mailadres is verzonden",
        "line2": "om je account te verifiëren en de registratieproces te voltooien"
      },
      "we_have_sent_you_a_verification_link": "We hebben je een verificatielink verzonden."
    },
    "welcome_to_takso": "Welkom bij Takso",
    "you_can_now_sign_in_to_your_account": "Je kan nu inloggen op je account",
    "your_account_has_been_activated_successfully": "Je account is succesvol geactiveerd."
  },
  "chart_types": {
    "aggregate": "Samengevoegd",
    "aggregate_individual_rate_of_change": "Geaggregeerde individuele uitkomsten – Mate van verandering",
    "aggregate_results": "Geaggregeerde uitkomsten",
    "aggregate_trend_rate_of_change": "Geaggregeerde trend – Mate van verandering",
    "individual_rate_of_change": "Individuele – Mate van verandering",
    "manager_assessed_rate_of_change": "Beoordeeld door de activiteitenbeheerder – Mate van verandering",
    "self_assessed_rate_of_change": "Zelfbeoordeeld – Mate van verandering",
    "separated": "Gescheiden",
    "separated_results": "Gescheiden uitkomsten",
    "single_results": "Enkelvoudige uitkomsten",
    "trend_rate_of_change": "Trend – Mate van verandering"
  },
  "charts": {
    "100_pct": "1",
    "activity_type_prose": {
      "breakdown1": "De verdeling van activiteiten toont {{activities}}, allemaal geclassificeerd als {{classifiedAs}}.",
      "breakdown2": "De uitsplitsing van activiteiten toont {{activities}} verdeeld over {{outputGroups}}. {{largestGroup}} is de grootste groep met {{largestGroupNumActivities}} ({{largestGroupPct}}), gevolgd door {{secondLargestGroup}} met {{secondLargestGroupNumActivities}} ({{secondLargestGroupPct}}).",
      "most_common_acitity_type": "Het meest voorkomende activiteitstype is {{mostCommonType}} met {{activities}} ({{pct}} van het totaal)."
    },
    "after": "Na",
    "after_responses": "Na reacties",
    "all_fall_in_upper_range": "Alle {{distWordLower}} vallen in het hogere bereik van de schaal, van {{lowestRating}} tot {{highestRating}}.",
    "assessments": "Beoordelingen",
    "average": "Gemiddelde",
    "average_abbrev": "gem.",
    "average_after": "Gemiddelde na",
    "average_after_fmt": "{{label}}: <strong>{{avg}}</strong>",
    "average_before": "Gemiddelde vóór",
    "average_before_fmt": "Gemiddelde ervoor: <strong>{{avg}}</strong>",
    "average_for": "Gemiddelde - {{label}}",
    "avg_post_rating_compares": "De gemiddelde beoordeling na deelname van {{avg}} is, vergeleken met een beoordeling voor deelname van {{preAvg}}, een {{magnitude}} {{increaseOrDecrease}} van {{pctChange}}%.",
    "avg_post_rating_sits": "De gemiddelde beoordeling na deelname van {{avg}} valt in de {{avgZone}}.",
    "avg_rating_sits": "De gemiddelde beoordeling van {{avg}} valt in de {{avgZone}}.",
    "before": "Voor",
    "before_and_after_counts": "Voor {{b}} → Na {{a}}",
    "before_responses": "Voor reacties",
    "chart_host": {
      "copy_picture_in_ppt_template": "Kopiëren — gebruik als vormnaam voor een afbeeldingsplaatshouder in een PowerPoint-sjabloon",
      "display": "Weergave",
      "error_loading_chart": "Fout bij het laden van de grafiek",
      "loading_chart": "Grafiek laden",
      "show_link_counts": "Aantal koppelingen tonen",
      "show_node_names": "Knooppuntnamen tonen",
      "unknown_chart": "Onbekende grafiek"
    },
    "custom_chart_subtitle": "Aangepaste ondertitel voor grafiek",
    "data_direction": {
      "decrease": "daling",
      "increase": "stijging"
    },
    "data_zones": {
      "lower_third": "onderste derde deel",
      "middle_range": "middenbereik",
      "upper_third": "bovenste derde"
    },
    "display_view": {
      "grouped": "Gegroepeerd",
      "ranked": "Gerangschikt"
    },
    "download_graph": "Grafiek downloaden",
    "errors": {
      "error_loading_ratings": "Fout bij het laden van beoordelingen",
      "no_svg_found": "Geen SVG gevonden"
    },
    "estimated_hours_per_volunteer": "naar schatting {{hours}} per vrijwilliger",
    "evaluation_plans": {
      "evaluation_plan": "evaluatieplan",
      "filter_by_evaluation_plan": "Filteren op evaluatieplan",
      "plan": "Plan"
    },
    "evaluations_plural_one": "evaluatie",
    "evaluations_plural_other": "evaluaties",
    "figure": "Figuur",
    "filter_by_method": "Filteren op methode",
    "filter_by_method_or_eval_plan": "Filteren op methode of evaluatieplan",
    "filter_by_series": "Filteren op reeks",
    "including_volunteers": "incl. {{volunteers}}",
    "loading_ratings": "Beoordelingen laden",
    "method": "Methode",
    "modes": {
      "individual_rate_of_change": "Individueel – Mate van verandering",
      "trend_rate_of_change": "Trend – Mate van verandering",
      "trend_separate": "Gescheiden"
    },
    "multi_series_selection": "selectie uit meerdere series",
    "multi_stage_evaluations_plural_one": "meerfasige evaluatie",
    "multi_stage_evaluations_plural_other": "meerfasige evaluaties",
    "multiseries": "Meerfasig",
    "nearly_100_pct": "Bijna 100%",
    "no_activity_type_data_available": "Geen gegevens over activiteitstypen beschikbaar.",
    "no_data": "Geen gegevens",
    "no_data_for_current_eval_plan_choose_one_above": "Geen gegevens voor het huidige filter voor methode/plan — kies er hierboven minstens één.",
    "no_data_for_filter": "Geen gegevens voor het filter dat op deze grafiek is toegepast op het tabblad Evaluatie.",
    "no_dollar_value": "geen geldwaarde",
    "no_investment_data_for_completed_activities": "Geen investeringsgegevens voor voltooide activiteiten.",
    "no_outcomes_selected": "Geen uitkomsten geselecteerd",
    "no_partner_data_for_completed_activities": "Geen partnergegevens voor voltooide activiteiten.",
    "no_venu_data_for_completed_activities": "Geen locatiegegevens voor voltooide activiteiten.",
    "none_recorded": "Niets geregistreerd",
    "not_at_all": "Helemaal niet",
    "not_available_for_individual_graph": "Niet beschikbaar voor de individuele grafiek",
    "num_activities_one": "1 activiteit",
    "num_activities_other": "{{countFmt}} activiteiten",
    "num_hours_one": "{{countFmt}} uur",
    "num_hours_other": "{{countFmt}} uur",
    "num_output_groups_one": "1 outputgroep",
    "num_output_groups_other": "{{count}} outputgroepen",
    "num_participants_html": "<strong>{{cnt}}</strong> {{value}}",
    "num_respondents_one": "{{countFmt}} respondent",
    "num_respondents_other": "{{countFmt}} respondenten",
    "num_stages_aggregated": "{{num}} fasen, samengevoegd",
    "num_volunteers_one": "{{countFmt}} vrijwilliger",
    "num_volunteers_other": "{{countFmt}} vrijwilligers",
    "number_of_responses": "Aantal reacties",
    "only_completed_activities_included": "Alleen voltooide activiteiten worden meegeteld. Lopende en ontwikkelingsactiviteiten worden niet meegenomen in de investeringscijfers.",
    "outcome_network": {
      "click_a_second_outcome": "Klik nu op een tweede uitkomst om hun verband weer te geven",
      "computing_layout": "Indeling berekenen"
    },
    "outcome_ratings": {
      "activities_included": "Opgenomen activiteiten",
      "measure": "Maatstaf",
      "no_evaluation_data_for_this_outcome_under_current_filter": "Geen evaluatiegegevens gevonden voor deze uitkomst met het huidige filter.",
      "number_of_responses": "Aantal reacties",
      "participants_in_evaluation": "Deelnemers aan de evaluatie",
      "pct_response_rate_fmt": "<strong>{{rate}}%</strong> responspercentage",
      "report_view_title": "RAPPORTWEERGAVE — grafiek zoals deze in het rapport verschijnt",
      "select_an_activity": "Selecteer hieronder minstens één activiteit om de grafiek weer te geven.",
      "select_an_eval_method": "Selecteer minstens één evaluatiemethode om de grafiek weer te geven."
    },
    "participant_ladder": {
      "from_non_ticketed_events": "van evenementen zonder tickets",
      "from_ticketed_and_reg_events": "van evenementen met tickets of registratie",
      "groups": {
        "active": "Actief",
        "receptive": "Receptief"
      },
      "largest_category": "De grootste categorie is {{name}} met {{num}} deelnemers ({{pct}} van het totale bereik).",
      "no_participant_data_available": "Geen deelnemersgegevens beschikbaar.",
      "no_participant_data_recorded_for": "Er zijn geen deelnemersgegevens geregistreerd voor {{category}} evenementen in de huidige selectie.",
      "non_ticketed": "zonder tickets",
      "participant_data_shows": "De deelnemersgegevens tonen {{numPeople}} personen{{fromEventType}}, bestaande uit {{numReceptive}} receptieve (publiek) en {{numActive}} actieve deelnemers.",
      "receptive_participant_accounts": "Receptieve deelname vormt {{pct}} van het totale bereik; de rest bestaat uit actieve deelname — uitvoerders, deelnemers aan wedstrijden en workshopdeelnemers.",
      "ticketed_registered": "met tickets / registratie"
    },
    "participants_by_type": {
      "all_types_hidden": "Alle typen verborgen",
      "data_by_activity_type_shows": "De deelnemersgegevens per activiteitstype tonen {{num}} deelnemers, allemaal afkomstig van {{group}} activiteiten.",
      "data_by_activity_type_with_most": "De deelnemersgegevens per activiteitstype tonen {{num}} deelnemers verdeeld over {{numGroups}} outputgroepen. {{group}} activiteiten nemen met {{topGroupNum}} deelnemers het grootste deel voor hun rekening.",
      "hide_unused": "Ongebruikte verbergen",
      "most_common_activity_type": "Het meest voorkomende activiteitstype is {{name}} met {{num}} deelnemers.",
      "no_data_for_this_group": "Geen deelnemersgegevens voor deze groep",
      "no_participant_data_by_activity_type": "Geen deelnemersgegevens per activiteitstype beschikbaar.",
      "num_participants_one": "1 deelnemer",
      "num_participants_other": "{{countFmt}} deelnemers"
    },
    "participants_considered": "in aanmerking genomen deelnemers",
    "participants_in_evaluation": "Deelnemers aan evaluatie",
    "participants_plural_one": "deelnemer",
    "participants_plural_other": "deelnemers",
    "pct_of_responses_in_7_to_10_range": "{{highPct}}% van de {{distWordLower}} ligt in het bereik 7–10.",
    "pct_of_responses_in_lower_half": "{{lowPct}}% van de {{distWordLower}} ligt in de onderste helft van de schaal.",
    "per_hour_compact": "/uur",
    "post": "Na",
    "post_data_fmt": "<strong>{{value}}</strong> {{afterOrResponsesLabel}}",
    "post_result_with_count": "Resultaat na - {{label}} Aantal - {{numParticipants}}",
    "post_result_with_participants_and_eval_plan_or_activity": "Resultaat na - {{context}} Aantal - {{numParticipants}} Naam {{forLabel}} - {{name}}",
    "pre": "Voor",
    "pre_data_fmt": "<strong>{{value}}</strong> voor",
    "rating": "Beoordeling",
    "reponse_rating_for": "Beoordeling van reacties voor '{{displayName}}'",
    "reponses_tightly_grouped": "{{distWord}} liggen dicht bij elkaar tussen {{lowestRating}} en {{highestRating}}, wat duidt op een consistent resultaat tussen de deelnemers.",
    "response_rate": "Deelnamepercentage",
    "responses": "reacties",
    "responses_come_from": "Reacties zijn afkomstig van {{num}} activiteiten.",
    "responses_range_from_to": "{{distWord}} variëren van {{lowestRating}} tot {{highestRating}}.",
    "result": "Resultaat",
    "samples_small_and_indicative_only": "De steekproef is klein en de resultaten zijn slechts indicatief.",
    "series": "Reeks",
    "stages_plural_one": "fase",
    "stages_plural_other": "fasen",
    "the_most": "Het meest",
    "this_chart_has_been_filtered_by": "Deze grafiek is gefilterd (ingesteld op het tabblad Evaluatie) op {{filterKindLabel}} en omvat: {{evalPlanNames}}.",
    "venues": {
      "num_unique_venues_one": "{{count}} unieke locatie",
      "num_unique_venues_other": "{{count}} unieke locaties",
      "num_venue_links_one": "{{count}} koppeling tussen activiteit en locatie",
      "num_venue_links_other": "{{count}} koppelingen tussen activiteit en locatie"
    },
    "view_rating_dist_for": "Verdeling van beoordelingen bekijken voor \"{{title}}\""
  },
  "common": {
    "account": "Account",
    "accounts": "Accounts",
    "action": "Actie",
    "activate": "Activeren",
    "active": "Actief",
    "activities": "Activiteiten",
    "activity": "Activiteit",
    "activity_name": "Naam van activiteit",
    "activity_notes": "Activiteitnotities",
    "activity_plan": "Activiteitsplan",
    "activity_section": "Activiteitsectie",
    "activity_type": "Activiteitstype",
    "activity_types": "Activiteitstypen",
    "actual": "Werkelijk",
    "admins": "Beheerders",
    "aiming_for": "Met als doelstelling",
    "aiming_for_outcomes_in_the": "Met als doelstelling uitkomsten in de",
    "all": "Alles",
    "all_activities": "Alle activiteiten",
    "all_organisations": "Alle organisaties",
    "analysis": "Analyse",
    "and": "En",
    "and_go_to_activity": "en ga naar activiteit",
    "and_knowing": "En in de wetenschap dat",
    "are_you_sure_you_want_to_leave": "Weet je zeker dat je de pagina wil verlaten?",
    "ascending": "Oplopend",
    "beta_tester": "Bètatester",
    "billing": "Facturering",
    "business_organisation": "Bedrijf/organisatie",
    "cdn_admin": "CDN Admin",
    "checklist": "Checklist",
    "collapse_all": "Alles inklappen",
    "comment": "Opmerking",
    "communication": "Communicatie",
    "completed": "Voltooid",
    "contact": "Contact",
    "contractor": "Leverancier",
    "contractors": "Leveranciers",
    "copied_to_clipboard": "Gekopieerd naar klembord",
    "created": "Aangemaakt",
    "created_date": "Datum aangemaakt",
    "csv_file": "CSV-bestand",
    "current": "Huidig",
    "custom": "Aangepast",
    "dashboard": "Dashboard",
    "data": "Gegevens",
    "data_source": "Gegevensbron",
    "date": "Datum",
    "date_added": "Datum toegevoegd",
    "date_created": "Aangemaakt op",
    "date_updated": "Bijgewerkt op",
    "deactivated": "Gedeactiveerd",
    "default": "Standaard",
    "department": "Afdeling",
    "departments": "Afdelingen",
    "dept_admin": "Afdelingsbeheerder",
    "descending": "Aflopend",
    "description": "Beschrijving",
    "disable": "Uitschakelen",
    "disabled": "Uitgeschakeld",
    "documentation": "Documentatie",
    "domains_and_knowing": "domeinen en kennis",
    "downloading": "Downloaden",
    "edit": "Bewerking",
    "email": "E-mail",
    "enter_email": "E-mailadres invoeren",
    "error": "Fout",
    "evaluation": "Evaluatie",
    "evaluation_group": "Evaluatiegroep",
    "evaluation_groups": "Evaluatiegroepen",
    "evidence": "Bewijs",
    "expand_all": "Alles uitklappen",
    "features": "Functies",
    "for_example_abbrev": "bijv.",
    "goal": "Doel ",
    "goal_description": "Beschrijving van doel",
    "goal_w_num_one": "{{count}} doel",
    "goal_w_num_other": "{{count}} Doelen",
    "goals": "Doelen",
    "goals_not_created": "Er zijn nog geen doelen aangemaakt",
    "grant_id": "Subsidie-ID",
    "green_light": "Groen licht'",
    "group_name": "Groepsnaam",
    "help": "Help",
    "hide_unused": "Ongebruikte verbergen",
    "in_development": "In ontwikkeling",
    "industry_sector_types": "Sectortypes",
    "information": "Informatie",
    "invited_activities": "Uitgenodigde activiteiten",
    "is_required": "is vereist",
    "language": "Taal",
    "last_update": "Laatste update",
    "last_updated": "Laatst bijgewerkt",
    "linked": "Gekoppeld",
    "loading": "Laden",
    "loading_data": "Gegevens laden",
    "login_as": "Inloggen als",
    "managed_activities": "Beheerde activiteiten",
    "manager": "Manager",
    "method": "Methode",
    "more_as_in_6_more": "meer",
    "most_imaginable": "Meest voorstelbaar",
    "most_imagined": "Meest voorgesteld",
    "name": "Naam",
    "next": "Volgende",
    "no_access": "Geen toegang",
    "no_activities": "Geen activiteiten",
    "no_goals_found": "Geen doelen gevonden",
    "no_records": "Geen gegevens",
    "no_records_found": "Geen records gevonden",
    "no_tooltips": "Geen tooltips",
    "no_users_found": "Geen gebruikers gevonden.",
    "none": "Geen",
    "not_applicable": "n.v.t.",
    "not_at_all": "Helemaal niet",
    "not_known": "Onbekend",
    "note": "Notitie",
    "notes": "Notities",
    "objective": "Doelstelling",
    "objectives": "Doelstellingen",
    "off": "Uit",
    "ok": "OK",
    "on": "Aan",
    "optional": "Optioneel",
    "options": "Opties",
    "order_by": "Sorteren op",
    "org_abbrev": "Org.",
    "organisation": "Organisatie",
    "organisation_type": "Organisatietype",
    "outcome": "Uitkomst",
    "outcomes": "Uitkomsten",
    "owner": "Beheerder",
    "parent": "Bovenliggend",
    "partner_with_cnt_one": "{{countFmt}} partner",
    "partner_with_cnt_other": "{{countFmt}} partners",
    "partner_with_cnt_zero": "{{countFmt}} partners",
    "partners": "Partners",
    "people_one": "{{count}} persoon",
    "people_other": "{{count}} personen",
    "peoplez_one": "{{count}} persoon",
    "peoplez_other": "{{count}} personen",
    "peoplez_zero": "geen personen",
    "permission": "Recht",
    "permission_groups": "Rechtengroepen",
    "plus_n_more": "+{{count}} meer",
    "policy_domain": "Domein ",
    "preamble": "Inleiding",
    "previous": "Vorige",
    "primary": "Primair",
    "primary_domain": "Primair domein",
    "primary_objective": "Primaire doelstelling",
    "profile": "Profiel",
    "program": "Programma",
    "program_activities": "Programma-activiteiten",
    "program_activity": "Programma-activiteit",
    "projected": "Gepland",
    "read": "Lezen",
    "read_less": "Minder lezen",
    "read_more": "Meer lezen",
    "reference": "Verwijzing",
    "references": "Verwijzingen",
    "replaced": "Vervangen",
    "report": "Rapport",
    "report_type": "Rapporttype",
    "reporting_date": "Rapportagedatum",
    "reports": "Rapporten",
    "save_png": "PNG opslaan",
    "saved": "Opgeslagen",
    "saving": "Opslaan",
    "secondary": "Secundair",
    "secondary_domain": "Secundair domein",
    "secondary_objective": "Secundaire doelstelling",
    "selected": "Geselecteerd",
    "sender": "Afzender",
    "settings": "Instellingen",
    "show": "Tonen",
    "single_activity": "Enkele activiteit",
    "something_went_wrong": "Er is iets misgegaan",
    "sort_by": "Sorteren op",
    "source": "Bron",
    "status": "Status",
    "success": "Succes",
    "takso_platform": "Takso-platform",
    "theory_of_change": "Theory of Change",
    "therefore_we_will": "Daarom zullen wij",
    "title": "Titel",
    "to_be_designed": "Nog te ontwerpen.",
    "todo": "Takenlijst",
    "total": "Totaal",
    "type": "Type",
    "unit": "Eenheid",
    "units": "Eenheden",
    "unknown": "Onbekend",
    "untitled": "Zonder titel",
    "updated": "Bijgewerkt",
    "updated_date": "Datum bijgewerkt",
    "upgrade": "Upgraden",
    "user": "Gebruiker",
    "users": "Gebruikers",
    "venue_types": "Locatietypen",
    "venues": "Locaties",
    "view_activity": "Activiteit bekijken",
    "view_less": "Minder weergeven",
    "view_more": "Meer weergeven",
    "warning": "Waarschuwing",
    "warning_shriek": "Waarschuwing!",
    "we_are": "We zijn",
    "we_are_aiming_for": "Wij streven naar",
    "we_know_that": "Wij weten dat",
    "we_will": "Wij zullen",
    "write": "Schrijven",
    "you_have_unsaved_changes": "Je hebt niet-opgeslagen wijzigingen. Wilt je de pagina verlaten?"
  },
  "constant": {
    "admin_setup": {
      "data_export": "Gegevensexport"
    },
    "admin_tabs": {
      "evaluation_methods": "Evaluatiemethoden",
      "evaluation_qsts": "Evaluatievragen",
      "output_formatters": "Outputformatters"
    },
    "managed_by_options": {
      "externally": "Extern",
      "internally": "Intern",
      "myself": "Mijzelf"
    },
    "organisation_report_types": {
      "inputs_outputs": "Inputs & Outputs",
      "management_summary": "Beheerssamenvatting",
      "outcomes_reported": "Gerapporteerde uitkomsten"
    },
    "routes": {
      "accounts_users": "Accounts & Gebruikers",
      "activities": "Activiteiten",
      "activity_settings": "Activiteitsinstellingen",
      "data_audit": "Data-audit",
      "library": "Bibliotheek",
      "logs": "Logbestanden",
      "preview_survey": "Voorbeeld enquête",
      "report_builder": "Rapportgenerator",
      "reports": "Rapporten",
      "system_logs": "Systeemlogboeken",
      "system_reports": "Systeemrapporten",
      "system_settings": "Systeeminstellingen",
      "user_help": "Gebruikershulp",
      "user_profile": "Gebruikersprofiel"
    },
    "subscriptions": {
      "access_library": "Toegang tot Takso-bibliotheek",
      "aggregated_reports": "Geaggregeerde en gegenereerde rapporten",
      "basic_contract_templates": "Basiscontractsjablonen",
      "basic_onboarding": "Basis onboarding",
      "duplicate_plans": "Activiteitsplannen dupliceren",
      "group_activities": "Groepsactiviteiten",
      "plan_evaluate": "Plannen en evalueren van afzonderlijke activiteiten",
      "up_to_25_profiles": "Tot 25 profielen"
    }
  },
  "contractor_status": {
    "confirmed": "Bevestigd",
    "projected": "Gepland"
  },
  "contractors": {
    "by_occupation": "Leveranciers per beroep",
    "contractor_address": "Adres van leverancier",
    "contractor_locations": "Locaties van leveranciers",
    "loading_locations": "Locaties van leveranciers laden",
    "location": "Locatie",
    "map_options": "Kaartopties",
    "no_contractors_added": "Er zijn geen leveranciers toegevoegd",
    "no_contractors_with_geocoded_address": "Geen leveranciers met een gegeocodeerd adres gevonden voor deze selectie.",
    "none_assigned_yet": "Er zijn nog geen leveranciers toegewezen — voeg ze toe via Activiteitsplan → Inputs.",
    "num_contractors_mapped": "<strong>{{total}}</strong> {{contractors}} op de kaart",
    "num_contractors_one": "1 leverancier",
    "num_contractors_other": "{{count}} leveranciers",
    "num_outside_map_view": "<strong>{{numContractors}}</strong> buiten de kaartweergave",
    "occupation": "Beroep",
    "outside_map_view": "Leveranciers buiten het kaartweergave",
    "place_labels": "Plaatslabels",
    "radius": "Straal",
    "without_map_address": "{{numContractors}} zonder adres op de kaart"
  },
  "csv": {
    "import": {
      "external_csv": "Extern CSV-bestand",
      "use_this_column": "Deze kolom gebruiken"
    },
    "num_columns_one": "1 kolom",
    "num_columns_other": "{{count}} kolommen"
  },
  "dashboard": {
    "invited_only_in_progress": "Alleen activiteiten die in uitvoering zijn worden getoond",
    "recent_activities_no_notification_found": "Geen melding gevonden…",
    "todo": {
      "empty": "Geen huidige taken op de to-dolijst",
      "end_date": "Einddatum",
      "greenlight_date": "Groenlichtdatum",
      "last_update": "Laatste update",
      "upcoming": "Verwacht",
      "urgent": "Dringend"
    },
    "tour": {
      "activities": "<0>Dit is een overzicht van de activiteiten die binnen je organisatie lopen.</0><br/><br/><amber>Amber</amber> - activiteiten in ontwikkeling<br/><green>Groen</green> - actieve activiteiten<br/><blue>Blauw</blue> - voltooide activiteiten",
      "activity_panel": "Klik hier om al je activiteiten te bekijken en te openen of waarvoor je bent uitgenodigd.",
      "dashboard": "Klik hier om naar het dashboard te gaan voor een overzicht van taken, meldingen van de beheerder en een samenvatting van activiteiten.",
      "library": "Takso-bibliotheek. Bekijk de openbare rapporten van alle voltooide activiteiten binnen Takso.",
      "main_menu": "Dit is het hoofdmenu. Van hieruit kan je naar verschillende secties van Takso navigeren.",
      "notifications": "Communicatie van de Takso-beheerders van je organisatie verschijnt hier.",
      "organisation": "Klik hier om uw bedrijfsinformatie en organisatorische Takso-instellingen te beheren.",
      "page_help": "Paginahelp. Je kunt informatie en hulp voor elke pagina bekijken door op het helptabblad te klikken.",
      "reports": "Bekijk rapporten voor je account, gegenereerd op basis van geaggregeerde gegevens van elke activiteit in Takso.",
      "show_me_around": "Klik op \"Laat me rondkijken\" wanneer je deze rondleiding opnieuw wilt volgen.",
      "todo": "Dit zijn de taken die je nog moet voltooien; ze verdwijnen zodra je ze afrondt.",
      "user_settings": "Gebruikersinstellingen. Hier kan je gegevens en wachtwoord bijwerken, veelgestelde vragen vinden en uitloggen."
    },
    "upgrade": {
      "add_card": "Voeg een kaart toe om uw abonnement te starten.",
      "add_card_button": "Kaart toevoegen",
      "click_the_upgrade_button_to_start_your_subscription": "Klik op de upgradeknop om je abonnement te starten.",
      "ends_today": "Je gratis proefperiode eindigt vandaag.",
      "header": "Accountupgrade",
      "includes": "Je plan omvat",
      "modal_title": "ACCOUNT UPGRADEN",
      "payment_method": "BETAALMETHODE",
      "payment_method_placeholder": "Selecteer betaalmethode...",
      "payment_required": "Betaalmethode is vereist",
      "plan_title": "Je plan",
      "subscription_label": "ABONNEMENT",
      "subscription_placeholder": "Selecteer abonnementstype...",
      "subscription_required": "Abonnementstype is vereist",
      "trial_remaining": "Je hebt nog {{count}} dagen over van uw gratis proefperiode."
    }
  },
  "date": {
    "date": "Datum",
    "date_to_date": "{{startDate}} tot {{endDate}}",
    "placeholder_format_dd_mm_yyyy": "DD MM JJJJ",
    "year": "Jaar"
  },
  "date_range": {
    "last_28_days": "Laatste 28 dagen",
    "last_7_days": "Laatste 7 dagen",
    "last_calendar_year": "Vorig kalenderjaar",
    "last_financial_year": "Vorig boekjaar",
    "last_month": "Vorige maand",
    "last_quarter": "Vorig kwartaal",
    "placeholder": "DD MM JJJJ - DD MM JJJJ",
    "since_the_start": "Sinds het begin",
    "this_calendar_year": "Dit kalenderjaar",
    "this_financial_year": "Dit boekjaar",
    "this_month": "Deze maand",
    "this_quarter": "Dit kwartaal",
    "year_to_date": "Jaar tot nu toe"
  },
  "email": {
    "verification": {
      "business_organisation": "Bedrijf/Organisatie",
      "confirmation_required": "Bevestiging is vereist!",
      "enter_details_to_create_partner_record": "Voer gegevens in om een partnerrecord aan te maken.",
      "existing_user_match": "De ingevoerde gegevens komen overeen met een bestaande Takso-gebruiker.",
      "invitation_activity_type_not_accessible": "Je kunt deze gebruiker niet uitnodigen voor deze activiteit. Dit type activiteit is niet toegankelijk.",
      "you_cannot_invite_user_activity_organisation_not_matched": "Je kunt deze gebruiker niet uitnodigen voor deze activiteit. De organisatie komt niet overeen."
    }
  },
  "empty_message": {
    "no_activities": "Geen activiteiten",
    "no_organisations": "Geen organisaties...",
    "you_have_not_created_any_output_formats_yet": "Je hebt nog geen outputformaten aangemaakt…"
  },
  "error": {
    "403": {
      "description": "Je hebt geen toestemming om deze pagina te openen. Neem contact op met administrator om toegang aan te vragen.",
      "title": "Toegang geweigerd"
    },
    "404": {
      "button": "Breng me naar de startpagina",
      "description": "Helaas bestaat de pagina die je zoekt niet (meer), of er is een fout in de link die je hebt gevolgd of ingevoerd."
    }
  },
  "error_messages": {
    "action_not_allowed": "Actie niet toegestaan",
    "csv_is_required": "CSV is vereist",
    "invalid_csv_format": "Ongeldig CSV-formaat",
    "please_contact_support": "Neem contact op met de ondersteuning.",
    "please_fill_fields": "Vul de volgende velden in",
    "something_went_wrong": "Er is iets misgegaan"
  },
  "evidence_types": {
    "academic_literature": {
      "button": "Academische literatuur",
      "content": {
        "label": "Toelichting relevantie",
        "placeholder": "Waarom is dit relevant voor jouw doelstelling(en)?"
      }
    },
    "grey_literature": {
      "button": "Rapporten & grijze literatuur",
      "content": {
        "label": "Toelichting relevantie",
        "placeholder": "Waarom is dit relevant voor jouw doelstelling(en)?"
      }
    },
    "other_media": {
      "button": "Overige media",
      "content": {
        "label": "Toelichting relevantie",
        "placeholder": "Waarom is dit relevant voor jouw doelstelling(en)?"
      }
    },
    "practice_knowledge": {
      "button": "Praktijkkennis",
      "content": {
        "label": "Wat heb je geleerd?",
        "placeholder": "Wat heb je geleerd, en hoe verhoudt dit zich tot deze doelstelling?"
      }
    }
  },
  "expenditure_status": {
    "actual": "Werkelijk",
    "actual_program_contribution": "Werkelijke programmabijdrage",
    "actual_program_grant": "Werkelijke programmasubsidie",
    "program_contribution": "Programmabijdrage",
    "program_grant": "Programmasubsidie",
    "projected": "Gepland"
  },
  "formulary": {
    "abn": "Ondernemingsnummer (BTW of KVK)",
    "abn_acn": "Ondernemingsnummer (BTW of KVK)",
    "account_logo": "Account Logo",
    "activity_manager": "Activiteitmanager",
    "activity_notes": "Activiteitnotities",
    "address": "Adres",
    "address_line_1": "Adresregel 1",
    "address_line_2": "Adresregel 2",
    "anzsco_contractor_service_group": "ESCO Leveranciersdienstengroep",
    "anzsco_occupation_service_type": "ESCO Beroep / Diensttype",
    "business_org_name": "Bedrijfs-/organisatie­naam",
    "business_organisation_name": "Bedrijfs-/organisatienaam",
    "business_organization_name": "Bedrijfs-/organisatienaam",
    "city_suburb": "Stad / Gemeente",
    "city_suburb_slash": "Stad / Gemeente",
    "clear_selection": "Selectie wissen",
    "click_to_upload": "Klik om te uploaden",
    "company_business_name": "Bedrijfsnaam / Handelsnaam",
    "confirm_password": "Bevestig wachtwoord",
    "contact_email": "Contact-e-mail",
    "contact_number": "Contactnummer",
    "content": "Inhoud",
    "country": "Land",
    "created_date": "Datum aangemaakt",
    "currency_type": "Valutatype",
    "department": "Afdeling",
    "description": "Beschrijving",
    "different_postal_address": "Afwijkend postadres",
    "domain": "Domein",
    "email": "E-mail",
    "field_name": "Veldnaam",
    "file": {
      "upload": {
        "document_required": "Document is vereist",
        "no_attached_document": "Er is geen document bijgevoegd."
      }
    },
    "first_name": "Voornaam",
    "goal": "Doel",
    "goal_description": "Beschrijving van het doel",
    "grant_id": "Subsidie-ID",
    "id": "ID",
    "label": "Label",
    "last_name": "Achternaam",
    "location": {
      "address_label": "Adres",
      "enter_location_placeholder": "Voer een locatie in"
    },
    "manager_first_name": "Voornaam manager",
    "manager_surname": "Achternaam manager",
    "message": "Bericht",
    "name": "Naam",
    "new_password": "Nieuw wachtwoord",
    "no_description": "geen beschrijving",
    "no_outcomes": "Geen uitkomsten",
    "no_title": "geen titel",
    "no_users": "Geen gebruikers",
    "number_of_participants": "Aantal deelnemers",
    "occupation_service_type": "Beroep / Diensttype",
    "organisation_logo": "Organisatielogo",
    "organisation_name": "Organisatienaam",
    "organisation_sector_type": "Organisatiesectortype",
    "organization_type": "Organisatietype",
    "outcome": "Uitkomst",
    "output_format": "Outputformaat",
    "output_formatter": "Outputformatter",
    "password": "Wachtwoord",
    "password_validation": {
      "lowercase": "Minstens één kleine letter (a–z)",
      "min_length": "Minstens 8 tekens",
      "numeric": "Minstens één cijfer (0–9)",
      "special_character": "Minstens één speciaal teken",
      "uppercase": "Minstens één hoofdletter (A–Z)"
    },
    "payment_preference": "Betaalvoorkeur",
    "phone": "Telefoon",
    "phone_number": "Telefoonnummer",
    "phone_optional": "Telefoon (optioneel)",
    "placeholder": {
      "7_plus_characters": "7+ tekens",
      "choose_an_option": "Kies een optie",
      "choose_an_outcome": "Kies een uitkomst",
      "confirm_password": "Bevestig wachtwoord",
      "description_is_required": "Beschrijving is vereist",
      "enter_abn": "Voer ondernemingsnummer (BTW of KVK) in",
      "enter_abn_acn": "Voer ondernemingsnummer (BTW of KVK) in",
      "enter_activity_name": "Voer activiteitnaam in",
      "enter_activity_notes": "Voer activiteitnotities in",
      "enter_address_line_1": "Voer adresregel 1 in",
      "enter_address_line_2": "Voer adresregel 2 in",
      "enter_business_org_name": "Voer bedrijfs-/organisatienaam in",
      "enter_business_organization_name": "Voer bedrijfs-/organisatienaam in",
      "enter_company_business_name": "Voer bedrijfs-/handelsnaam in",
      "enter_confirm_password": "Bevestig nieuw wachtwoord",
      "enter_description": "Voer beschrijving in",
      "enter_email": "Voer e-mail in",
      "enter_email_address": "Voer e-mailadres in",
      "enter_first_name": "Voer voornaam in",
      "enter_group_name": "Voer groepsnaam in",
      "enter_last_name": "Voer achternaam in",
      "enter_name": "Voer naam in",
      "enter_new_password": "Voer nieuw wachtwoord in",
      "enter_organisation_name": "Voer organisatienaam in",
      "enter_phone": "Voer telefoonnummer in",
      "enter_phone_number": "Voer telefoonnummer in",
      "enter_position_designation": "Voer functie / titel in",
      "enter_postcode": "Voer postcode in",
      "enter_state": "Voer staat / provincie in",
      "enter_suburb": "Voer stad of gemeente in",
      "enter_support_description": "Voer ondersteuningsbeschrijving in",
      "enter_surname": "Voer achternaam in",
      "enter_title": "Voer titel in",
      "enter_venue_name": "Voer locatienaam in",
      "enter_web_domain": "Voer webdomein in",
      "enter_website": "Voer website in",
      "example_email": "voorbeeld@mail.com",
      "no_unit_selected": "Geen eenheid geselecteerd",
      "please_select_goal": "Selecteer alstublieft een doel",
      "please_select_objective": "Selecteer alstublieft een doel",
      "please_select_outcomes": "Selecteer alstublieft outputs",
      "please_select_output_format": "Selecteer alstublieft een outputformaat",
      "search_address_with_google": "Zoek adres met Google",
      "select_a_domain": "Selecteer een domein",
      "select_a_goal": "Selecteer een doel",
      "select_activity_type": "Selecteer een activiteitstype",
      "select_an_option": "Selecteer een optie",
      "select_an_user_type": "Selecteer een gebruikerstype",
      "select_contractor_service_group": "Selecteer een leveranciersdienstengroep",
      "select_country": "Selecteer een land",
      "select_currency_type": "Selecteer valutatype",
      "select_department": "Selecteer afdeling",
      "select_goal": "Selecteer doel",
      "select_organisation": "Selecteer organisatie",
      "select_organisation_user": "Selecteer organisatiegebruiker",
      "select_outcome": "Selecteer uitkomst",
      "select_output_format": "Selecteer outputformaat",
      "select_output_formatter": "Selecteer outputformatter",
      "select_payment_preference": "Selecteer betaalvoorkeur",
      "select_permission_type": "Selecteer toestemmingstype",
      "select_primary_objective": "Selecteer primaire doelstelling",
      "select_secondary_objective": "Selecteer secundaire doelstelling",
      "select_sector": "Selecteer een sector",
      "select_state": "Selecteer een staat / provincie",
      "select_status": "Selecteer status",
      "select_type": "Selecteer type",
      "select_unit": "Selecteer eenheid",
      "select_venue_type": "Selecteer een locatietype",
      "select_your_goal": "Selecteer je doel"
    },
    "position_designation": "Functie / Titel (optioneel)",
    "position_designation_optional": "Functie / titel (optioneel)",
    "post_code": "Postcode",
    "postal_address_line_1": "Postadresregel 1",
    "postal_address_line_2": "Postadresregel 2",
    "postal_city_suburb": "Stad of gemeente",
    "postal_code": "Postcode",
    "postal_postcode": "Postpostcode",
    "postal_state": "Provincie",
    "postcode": "Postcode",
    "primary_domain": "Primair domein",
    "primary_objective": "Primaire doelstelling",
    "primary_policy": "Primair domein voor activiteit",
    "primary_policy_note": "Je primaire beleidsdomein wordt ingevuld op basis van het geselecteerde doel.",
    "program_contribution": "Program­mabijdrage",
    "reference": "Verwijzing",
    "relationship": "Relatie",
    "reload_all_data": "Alle gegevens opnieuw laden",
    "search_venue": "Zoek locatie",
    "secondary_objective": "Secundaire doelstelling",
    "secondary_policy": "Secundair domein",
    "secondary_policy_note": "Je secundaire beleidsdomein wordt ingevuld op basis van het geselecteerde doel.",
    "select": "Selecteer",
    "select_organisation_user": "Selecteer organisatiegebruiker",
    "select_user": "Selecteer gebruiker",
    "select_user_type": "Selecteer een gebruikerstype",
    "select_users": "Selecteer gebruikers",
    "sender": "Afzender",
    "state": "Staat / Provincie",
    "state_province": "Staat / Provincie",
    "status": "Status",
    "subscription": "Abonnement",
    "suburb": "Stad of gemeente",
    "support_description": "Ondersteuningsbeschrijving",
    "supports_formats": "Ondersteunt jpg-, png- en gmp-formaten",
    "surname": "Achternaam",
    "takso_support_email": "Takso ondersteuningse-mail (systeem stuurt geen e-mails naar deze e-mail)",
    "title": "Titel",
    "unit": "Eenheid",
    "unsaved_changes": "Niet-opgeslagen wijzigingen",
    "updated_date": "Datum bijgewerkt",
    "user_name": "Gebruikersnaam",
    "user_type": "Gebruikerstype",
    "validation": {
      "abn_acn_required": "ondernemingsnummer (BTW of KVK) is vereist",
      "activity_manager_required": "Activiteitsmanager is vereist!",
      "activity_name_required": "Activiteitsnaam is vereist!",
      "activity_type_required": "Activiteitstype is verplicht",
      "address_line_1_required": "Adresregel 1 is vereist",
      "address_required": "Adres is vereist",
      "business_org_name_required": "Bedrijfs-/organisatienaam is vereist",
      "business_organisation_name_required": "Bedrijfs-/organisatienaam is vereist!",
      "city_suburb_required": "Stad / gemeente is verplicht",
      "company_business_name_required": "Bedrijfs-/handelsnaam is vereist",
      "confirm_password_required": "Bevestig wachtwoord is vereist",
      "confirmation_required": "Bevestiging is vereist!",
      "contact_number_required": "Contactnummer is vereist",
      "content_required": "Inhoud is vereist",
      "contractor_category_required": "Categorie leverancier is vereist",
      "contractor_service_group_required": "Leveranciersdienstengroep is vereist",
      "country_required": "Land is vereist",
      "currency_type_required": "Valutatype is vereist",
      "department_or_unit_name_required": "{{department_or_unit}} naam is vereist!",
      "description_required": "Beschrijving is verplicht",
      "document_file_required": "Documentbestand is verplicht",
      "document_title_required": "Documenttitel is vereist!",
      "doesnt_match_the_new_password": "Komt niet overeen met het nieuwe wachtwoord",
      "domain_required": "Domein is vereist",
      "email_does_not_match_org_email_domain": "Het e-mailadres komt niet overeen met het e-maildomein van de organisatie.",
      "email_invalid": "Voer een geldig e-mailadres in",
      "email_not_valid": "E-mailadres is ongeldig!",
      "email_required": "E-mail is vereist",
      "english_translation_required": "Vertaling is vereist (primaire taal)",
      "evidence_type_required": "Bewijstype is vereist",
      "expenditure_value_required": "De uitgavenwaarde is vereist",
      "file_too_large": "Bestand is te groot",
      "first_name_required": "Voornaam is vereist",
      "goal_required": "Doel is vereist",
      "goal_should_be_less_than_250_characters": "Doel mag maximaal 250 tekens bevatten",
      "grant_id_not_valid": "Subsidie-ID is ongeldig!",
      "grant_id_required": "Subsidie-ID is verplicht!",
      "group_name_required": "Groepsnaam is vereist",
      "industry_sector_type_id_required": "ID van sectortype is vereist",
      "last_name_required": "Achternaam is vereist",
      "link_invalid": "Link is ongeldig",
      "link_must_start_with": "Link moet beginnen met http:// of https://",
      "link_required": "Link is vereist",
      "linked_objectives_required": "Gekoppelde doelstellingen zijn vereist!",
      "manager_first_name_required": "Voornaam van activiteitmanager is vereist",
      "manager_surname_required": "Achternaam van activiteitmanager is vereist",
      "material_type_required": "Materiaaltype is vereist",
      "message_required": "Bericht is vereist",
      "min_10_digits": "Moet minimaal 10 cijfers bevatten",
      "minimum_10_digits": "Moet minimaal 10 cijfers bevatten",
      "must_be_a_minimum_of_10_digits": "Moet minimaal 10 cijfers bevatten",
      "must_be_a_minimum_of_15_digits": "Moet minimaal 15 cijfers bevatten",
      "name_required": "Naam is vereist",
      "no_negative_numbers": "Negatieve getallen worden niet geaccepteerd",
      "no_results_available_for": "Geen uitkomsten beschikbaar voor {{label}}",
      "notes_required": "Notities zijn vereist",
      "number_of_participants_considered_required": "Aantal overwogen deelnemers is vereist",
      "number_of_participants_must_be_nonzero": "Aantal deelnemers moet 0 of groter zijn",
      "number_of_participants_required": "Aantal deelnemers is vereist",
      "number_required": "Nummer is vereist",
      "occupation_service_type_required": "Beroep / diensttype is verplicht",
      "only_numbers_accepted": "Alleen cijfers toegestaan",
      "organisation_id_required": "Organisatie-ID is vereist!",
      "organisation_name_required": "Organisatienaam is vereist",
      "organisation_sector_type_required": "Organisatiesectortype is vereist",
      "outcome_required": "Uitkomst is vereist",
      "output_format_required": "Outputformaat is vereist",
      "output_formatter_required": "Outputformatter is vereist",
      "password_lowercase": "Minstens één kleine letter (a–z)",
      "password_min_length": "Minstens 8 tekens",
      "password_must_have_at_least_7_characters": "Wachtwoord moet minimaal 7 tekens bevatten",
      "password_numeric": "Minstens één cijfer (0–9)",
      "password_required": "Wachtwoord is verplicht",
      "password_special_character": "Minstens één speciaal teken",
      "password_uppercase": "Minstens één hoofdletter (A–Z)",
      "payment_preference_required": "Betaalvoorkeur is vereist",
      "phone_number_not_valid": "Telefoonnummer is ongeldig!",
      "phone_number_required": "Telefoonnummer is vereist",
      "phone_required": "Telefoon is verplicht",
      "please_enter_email": "Voer een geldig e-mailadres in",
      "please_enter_password": "Voer een geldig wachtwoord in",
      "please_enter_the_valid_format": "Voer een geldig formaat in",
      "please_enter_valid_email": "Voer een geldig e-mailadres in",
      "please_enter_valid_first_name": "Voer een geldige voornaam in",
      "please_enter_valid_organisation_name": "Voer een geldige organisatienaam in",
      "please_enter_valid_password": "Voer een geldig wachtwoord in",
      "please_enter_valid_surname": "Voer een geldige achternaam in",
      "postal_address_required": "Postadres is vereist",
      "postal_city_suburb_required": "Stad of gemeente is vereist",
      "postal_code_required": "Postcode is vereist",
      "postal_postcode_required": "Postpostcode is vereist",
      "postal_state_required": "Provincie is vereist",
      "postal_street_address_required": "Postadres is vereist",
      "postcode_required": "Postcode is vereist",
      "primary_objective_required": "Primaire doelstelling is vereist!",
      "primary_policy_required": "Primair beleidsdomein is vereist",
      "program_contribution_required": "Program­mabijdrage is vereist!",
      "program_contribution_value_required": "Program­mabijdragewaarde is vereist",
      "reference_field_label_required": "Label van verwijzingsveld is vereist!",
      "second_name_required": "Tweede naam is vereist!",
      "secondary_objective_required": "Secundaire doelstelling is vereist!",
      "select_activity_type_required": "Selectie van activiteitstype is vereist",
      "select_style": "Selecteer een stijl",
      "select_user_required": "Selectie van gebruiker is vereist",
      "source_required": "Bron is vereist!",
      "state_required": "Staat / provincie is vereist",
      "street_address_required": "Straatadres is vereist",
      "subscription_required": "Abonnement is vereist",
      "suburb_required": "Stad of gemeente is vereist",
      "surname_required": "Achternaam is vereist",
      "title_required": "Titel is vereist",
      "unable_to_invite_organisation_user_as_external": "Kan organisatiegebruiker niet uitnodigen als externe!",
      "unsupported_file_format": "Niet-ondersteund bestandsformaat",
      "user_type_required": "Gebruikerstype is vereist",
      "valid_email": "Voer een geldig e-mailadres in",
      "venue_name_required": "Locatienaam is verplicht!",
      "venue_type_required": "Locatietype is verplicht!",
      "web_domain_required": "Webdomein is verplicht"
    },
    "venue_name": "Locatienaam",
    "venue_type": "Locatietype",
    "web_domain": "Webdomein",
    "website": "Website"
  },
  "grant_trial": {
    "defined_texts": {
      "add_report_to_takso_library": "Voeg rapport toe aan de Takso-bibliotheek.",
      "continue_sentence_with_description": "Ga verder met de zin hierboven met je beschrijving.",
      "continue_sentence_with_evidence_summary": "Ga verder met de zin hierboven met je samenvatting van het bewijs.",
      "create_participant_sub_group": "Maak een subgroep van deelnemers aan.",
      "goal": "Doel",
      "objective_for_domain": "Doelstelling voor het domein {{domainName}}",
      "primary_policy_domain_populated": "Primair domein is ingevuld op basis van het geselecteerde doel.",
      "secondary_policy_domain_populated": "Secundair domein is ingevuld op basis van het geselecteerde doel."
    },
    "help_tips": {
      "activity_activity_plan": "<p><strong>Activiteitenplan </strong></p>\n<p><strong>Actie: </strong></p>\n<p>Deze pagina legt de praktische aspecten van de activiteit vast en wordt gebruikt voor de planning en raming van de activiteit. Zodra bevestigd is dat de activiteit doorgaat, wordt deze pagina opnieuw ingesteld en gebruik je ze om de werkelijke activiteitsgegevens te registreren.</p>\n<p><strong>Selecteer activiteitstype:</strong> gebruik het keuzemenu om de optie te selecteren die het beste je activiteit beschrijft. Opmerking: als je niet zeker weet wat je moet selecteren...</p>\n<p><strong>Samenvatting van de activiteit:</strong> voer een beschrijving in van de activiteit.</p> <br/><br/> <strong>Activiteitsdeelnemers:</strong> De activiteitenbeheerder het bestand heeft aangemaakt, wordt automatisch in dit veld opgenomen. Als je anderen wilt uitnodigen om te helpen, klik dan op ‘Gastgebruiker toevoegen’ en voer hun gegevens in. Bij uitnodiging ontvangen ze een e-mail om een wachtwoord in te stellen en in te loggen op dit bestand.<br/><br/>  <strong>Geplande input:</strong><br/><br/> <strong>Geplande bijdrage van het programma:</strong> Dit is het bedrag dat deze activiteit aanvraagt uit het totale programmabudget.<br/><br/> <strong>Uitgaven:</strong> Voer het bedrag in dat je plant te besteden aan de uitvoering van deze activiteit (inclusief de fondsen die je bij het programma aanvraagt).<br/><br/> <strong>'Groen licht'-datum:</strong> Dit is de datum waarop de definitieve beslissing om de activiteit uit te voeren moet worden genomen. Als de datum door de activiteitenbeheerder is ingevoerd, moet je ervoor zorgen dat alle pagina’s vóór deze datum zijn voltooid.<br/><br/> <strong>Start- en einddatum van de activiteit:</strong> Voer de verwachte begin- en einddatum in. Voor eendaagse activiteiten vul je dezelfde datum in voor beide velden.<br/><br/> <strong>Locatie:</strong> Voer de locaties in die je wilt gebruiken bij de uitvoering van deze activiteit. <br/><br/> <strong>Leveranciers:</strong> Als je diensten moet inkopen, voer hier de gegevens in via de knop ‘Nieuwe leverancier toevoegen’. Bij het toevoegen van een leverancier moet je twee beroepsniveaus selecteren volgens de Europese standaardclassificatie van beroepen (ESCO). Selecteer eerst de algemene beroepsgroep, daarna de specifieke functie.<br/><br/> Als je de dienst kent maar nog niet de specifieke leverancier, kun je bovenaan het pop-upvenster op ‘Verwacht’ klikken om alleen de ESCO-informatie op te slaan. <br/><br/> <strong>Partners:</strong> Voer personen of organisaties in die bijdragen aan de activiteit maar niet worden betaald. Dit kunnen mensen zijn die ondersteuning, middelen of financiële steun leveren. <br/><br/> <strong>Verwachte outputs:</strong> <strong>Andere inkomsten:</strong> Als je verwacht inkomsten te ontvangen (zoals ticketverkoop), voer een geschatte waarde in. <strong>Deelnemersvelden:</strong><br/><br/> De weergegeven velden variëren per geselecteerd activiteitstype. Voer in de relevante velden het aantal deelnemers in dat je verwacht te betrekken. Niet elk veld hoeft ingevuld te worden, maar ten minste één veld moet een waarde hebben. <br/><br/> Deelnemers worden ingedeeld in twee hoofdgroepen: <br/><br/> <strong>Actieve deelnemers:</strong> zijn betrokken bij het creatieve proces, zoals uitvoerders of workshopdeelnemers. Afhankelijk van de activiteit kunnen ze gratis deelnemen, betaald worden of betalen om mee te doen. <strong>Receptieve deelnemers:</strong> nemen niet deel aan de creatieve productie maar wonen creatieve activiteiten bij, zoals publiek of bezoekers. Zij kunnen gratis of betalend zijn.<br/><br/> <strong>Subgroep deelnemers:</strong> Hiermee kun je een subgroep aanduiden uit de hierboven vermelde deelnemers, bijvoorbeeld voor een aparte evaluatie-enquête. Als je een subgroep aanmaakt, kun je op de volgende pagina een evaluatieplan voor hen maken.</p>",
      "activity_documentation": "<p><strong>Documentatiepagina: </strong></p> <p><strong>Actie: </strong></p> <p>Op deze pagina voltooi je je activiteitsrecord voordat je het rapport indient bij de activiteitenbeheerder. <br/> <br/> Documenten en media: Upload foto's, video's, documenten enz. van de activiteit. <br/> <br/> Werkelijke inputs & werkelijke outputs: De informatie voor deze secties komt uit de gegevens die je na 'groen licht' op de pagina <strong>Activiteitsplan</strong> hebt ingevoerd. Controleer de gegevens op juistheid en keer bij wijzigingen terug naar de pagina Activiteitsplan om de informatie bij te werken. </p> <p><strong>Evaluatieanalyse:</strong> Geef in deze sectie een analyse van wat je uit de evaluatie hebt geleerd. Hebben je deelnemers de beoogde uitkomsten ervaren? In welke mate? Wat vertelden hun opmerkingen je over wat belangrijk was voor hun uitkomsten? </p> <p><strong>Reflectie:</strong> Kijk in deze sectie terug op de activiteit als geheel: was ze succesvol? Hoe weet je dat? Zijn de geplande uitkomsten bereikt? Heb je iets nieuws geleerd? Waren er problemen of informatie waarvan je je niet bewust was toen je begon met het plannen van deze activiteit? </p> <p><strong>Niet-gepubliceerde notitie:</strong> Als je informatie of opmerkingen wilt vastleggen die belangrijk zijn maar niet in het rapport thuishoren, kun je ze hier toevoegen. De notities zijn alleen leesbaar voor mensen die toegang hebben tot deze gegevens. </p> <strong>Achtergrond/informatie</strong> <p> De Evaluatieanalyse en de Reflectie worden toegevoegd aan het publiek rapport van deze activiteit. Denk bij het schrijven van deze secties na over welke informatie en lessen nuttig kunnen zijn of die je met anderen wilt delen. </p>",
      "activity_evaluation_plan": "<p><strong>Evaluatie </strong></p> <p><strong>Actie: </strong></p> <p> Op deze pagina bepaal je hoe je de uitkomsten van deze activiteit wilt evalueren. Takso heeft voor elke uitkomst een vooraf geschreven vraag, maar je moet zelf bepalen hoe je deelnemers wilt bevragen. <br/> <br/> Selecteer de knop Evaluatieplan toevoegen en volg de stappen om een evaluatieplan voor deze activiteit aan te maken en op te slaan. </p> <p> <strong>Achtergrond/informatie</strong> <p>De enquêtemethoden van Takso zijn onder meer direct interview, vragenlijst of focusgroep. Je kunt meerdere deelnemersgroepen in één enquête bevragen of afzonderlijke evaluatieplannen maken voor je individuele deelnemersgroepen. Takso laat niet toe dat je twee identieke evaluatieplannen maakt. Houd bij het overwegen van meerdere evaluaties rekening met de behoefte aan extra evaluatie en of je de middelen hebt om meerdere enquêtes uit te voeren. <br/><br/> Begin met het aanmaken van een evaluatieplan door de uitkomsten en deelnemersgroepen te selecteren die je wilt evalueren. </p> <strong>Aanbevolen steekproefgrootte,</strong> <p>Het getal voor de steekproefgrootte is bedoeld als richtlijn en niet als vereiste, en is ingesteld op een hoog betrouwbaarheidsniveau. Hoewel het voor een effectieve evaluatie belangrijk is na te denken over het aantal respondenten, is het ook belangrijk de evaluatie uit te voeren met het aantal mensen dat je kunt bereiken, afhankelijk van hun beschikbaarheid en je middelen. Elke evaluatie telt.</p> <strong>Enquêterespondent selecteren</strong> <p>In de meeste gevallen zijn de deelnemers de mensen die je vraagt na te denken over de uitkomsten van de activiteit. Dat is niet altijd geschikt. Als je deelnemersgroep bijvoorbeeld uit jonge kinderen bestaat, kun je een ouder vragen om als vertegenwoordiger voor het kind te antwoorden, of kun je een expert uit het veld die kennis heeft van de activiteit vragen om zijn of haar mening te geven over de ervaring van de deelnemers.</p> <p><strong>Deelnemer:</strong> selecteer deze optie wanneer de mensen die aan de activiteit deelnemen de enquête zullen beantwoorden.</p> <p><strong>Vertegenwoordiger:</strong> selecteer deze optie wanneer de persoon die de enquête beantwoordt niet de deelnemer zelf is, maar iemand die de deelnemer kent, zoals een ouder of verzorger.</p> <p><strong>Expert:</strong> selecteer deze optie wanneer de persoon die de enquête beantwoordt niet rechtstreeks betrokken is bij de deelnemers, maar over expertise beschikt waarmee de ervaring van de deelnemers kan worden beoordeeld.</p> <p><strong>Beoordeeld door de activiteitenbeheerder:</strong> in gevallen waarin evaluatie met deelnemers, vertegenwoordigers of experts niet mogelijk is of een geplande evaluatie niet heeft plaatsgevonden, vraagt deze methode de activiteitenbeheerder om zijn of haar eigen mening te geven over de uitkomsten van de deelnemers. Als je deze methode selecteert, hoef je geen andere velden op deze pagina in te vullen. De evaluatievraag verschijnt na 'groen licht' op deze pagina. </p> <strong>Enquêtemethode selecteren</strong> <p>Er zijn verschillende methoden in Takso ingebouwd en je kunt ook kiezen voor methoden buiten het systeem, zoals SurveyMonkey, papieren enquêtes en telefonische interviews. Alle gegevens worden, ongeacht de methode, weer in Takso vastgelegd. <br/><br/> Houd bij het kiezen van je evaluatiemethode rekening met de middelen die je beschikbaar hebt. Heb je bijvoorbeeld genoeg mensen om interviews af te nemen? Als je maar één persoon hebt, kan die misschien maar 10 mensen per uur bevragen. Heb je genoeg e-mailadressen voor een online enquête (en zijn mensen betrokken genoeg om te reageren)? Heb je telefoonnummers voor een telefonisch interview? Heb je een kleine deelnemersgroep, waarvoor een focusgroep nuttig is? Dit alles moet worden meegewogen bij het kiezen van je evaluatiemethode. </p> <p><strong>Interview:</strong> selecteer deze methode als je rechtstreeks met de evaluatiedeelnemers spreekt, persoonlijk of telefonisch. </p> <p><strong>Vragenlijst:</strong> selecteer deze methode als je wilt dat evaluatiedeelnemers zelf de vragen lezen en beantwoorden, via een e-maillink, papieren formulieren of een 'evaluatiekiosk' bij een evenement. </p> <p><strong>Focusgroep:</strong> selecteer deze methode als je een kleine groep evaluatiedeelnemers wilt samenbrengen voor een gesprek over de activiteit en de uitkomsten. </p> <strong>Dataverzamelingsmethode selecteren</strong> <p>Hoe je de gegevens verzamelt, hangt af van de deelnemers, de evaluatiemethode en je middelen. </p> <p><strong>Takso-link:</strong> Takso genereert een enquêtelink en antwoorden op de link worden automatisch aan Takso toegevoegd. De enquêtelinks zijn beschikbaar op deze pagina zodra de activiteit 'groen licht' heeft gekregen. </p> <p><strong>CSV-upload:</strong> Selecteer deze methode als je de evaluatie via een extern enquêteplatform zoals Survey Monkey of op papier wilt uitvoeren. De resultaten kunnen vervolgens in Takso worden geüpload met het CSV-sjabloon dat na 'groen licht' beschikbaar is. </p> <strong>Enquêtevraag</strong> <p>Nadat je je keuze hebt gemaakt, kun je de enquêtevraag op de pagina bekijken door de sectie met de naam van de uitkomst te openen. Als je een papieren enquête doet of platforms zoals Survey Monkey gebruikt, kun je de vraag kopiëren en plakken in het platform van je voorkeur.<br/><br/> De vragen zijn zo ontworpen dat respondenten de informatie krijgen die nodig is om de uitkomst te begrijpen voordat hun wordt gevraagd na te denken over hun ervaring. Daarom mag de vraagopzet niet worden gewijzigd. Als je aanvullende informatie wilt verzamelen, zoals demografische gegevens, doe dat dan nadat je de uitkomstvraag hebt gesteld, omdat de uitkomstvragen meer reflectie van de respondent vragen.<br/><br/> Als je de evaluatie uitvoert met de Takso-link, kun je delen van de vraagtekst aanpassen om de evaluatie beter af te stemmen op de activiteit. De bewerkbare delen zijn gemarkeerd in het vragenvoorbeeld. Als je tekst wijzigt, lees de vraag dan opnieuw om te controleren of de zin grammaticaal correct is. </p> <strong>Aangepaste vragen: </strong> <p> Als je de Takso-link gebruikt en extra informatie wilt verzamelen, kun je extra vragen toevoegen. Er zijn twee vooraf ingestelde vragen om postcode en leeftijd te verzamelen. Als je andere informatie wilt, vink dan het vakje voor aangepaste vraag aan en voer je eigen vraag in. Aangepaste vragen verschijnen in de enquêtelink met een vrij tekstveld voor antwoorden.<br/><br/> Je kunt ook het e-mailadres van respondenten opvragen door het vakje aan te vinken en een verzoek om e-mail in te voeren. </p> <strong>Bericht na voltooiing van de enquête: </strong> <p> Nadat respondenten een antwoord via de Takso-link hebben ingediend, zien zij een succesbericht. Dit bericht kun je hier aanpassen. <br/> <br/> Zodra je een evaluatieplan hebt opgeslagen. <br/> <br/> Als er informatie ontbreekt op de vorige pagina's, zie je een bericht over openstaande informatie in het blauw. Als er geen bericht over openstaande informatie is, wordt de activiteit beschouwd als klaar voor 'groen licht'. </p> <strong>Evaluatiepagina na 'groen licht': </strong> <p> Nadat 'groen licht' is gegeven, wordt de evaluatiepagina gereset en wordt dit de plek waar je de evaluatie beheert en de resultaten verzamelt. <br/> <br/> Enquête-informatie tonen: In deze sectie vind je de enquêtelinks, als je de Takso-link gebruikt. Er worden twee links gegenereerd: de link voor eenmalig gebruik accepteert slechts één antwoord van één apparaat en moet worden gebruikt als je de link naar individuele mensen stuurt. De link voor meervoudig gebruik accepteert meerdere antwoorden vanaf één apparaat en moet worden gebruikt als je verwacht dat meer dan één persoon op één apparaat zal antwoorden. Je kunt ook voor elke link een QR-code genereren. <br/> <br/> Als je CSV-upload hebt geselecteerd, vind je de enquêtevragen om te kopiëren naar je eigen enquêtetool. Als je de dataverzamelingsmethode wilt wijzigen, kun je dat hier doen. Je kunt de methode wijzigen tot het eerste antwoord is ingevoerd. </p> <strong>Evaluatiedetails tonen: </strong> <p> Hier worden de antwoorden voor je enquête verzameld. Als je de Takso-link voor de evaluatie gebruikt, zie je hier de resultaten binnenkomen.<br/><br/> Als je CSV-upload als dataverzamelingsmethode hebt geselecteerd, zie je een knop om een CSV-sjabloon te downloaden waarin je resultaten kunt invoeren, die je vervolgens kunt uploaden via de knop Uploaden. <br/><br/> Als je voor een evaluatie beoordeeld door de activiteitenbeheerder hebt gekozen, zie je alleen Evaluatiedetails tonen, met daarin de evaluatie die klaar staat om te worden ingevuld. <br/><br/> Zodra je zeker weet dat je alle antwoorden hebt ontvangen die je waarschijnlijk zult krijgen, kun je de evaluatie als gesloten markeren door de vraag boven de knop met evaluatie-informatie te beantwoorden. Als de evaluatie niet heeft plaatsgevonden, wordt de evaluatie bij het antwoord nee op deze vraag omgezet naar een evaluatie beoordeeld door de activiteitenbeheerder, die je dan kunt voltooien. </p>",
      "activity_evidence": "<p><strong>Bewijs </strong></p>\n<p><strong>Actie: </strong></p>\n<p>Op deze pagina moet je informatie invoeren over wat je weet over het behalen van de gekozen uitkomsten en waarom deze belangrijk zijn voor de gemeenschap met wie je wilt werken. De informatie op deze pagina vormt de bewijsbasis voor je voorgestelde activiteit.</p>\n<p>Je moet minimaal één bewijsstuk toevoegen voor elke doelstelling. Dit bewijs kan afkomstig zijn uit gepubliceerde bronnen of uit je eigen ervaring en praktijk.</p>\n<p>Je kunt bewijs invoeren door rechts op de pagina op de knop “Nieuw bewijs toevoegen” te klikken. Als je praktijkkennis invoert als bewijs, kun je je functietitel vermelden als bron. Alle praktijkkennis die je invoert blijft privé voor deze activiteit en is niet zichtbaar voor mensen zonder toegang tot de info over deze activiteit.</p>\n<p>Je kunt ook bewijs raadplegen dat door andere Takso-gebruikers is ingevoerd in hun activiteiten, en dit via het zoekveld aan de linkerkant van de pagina.</p>\n<p>Zodra je minstens één bewijsstuk hebt gekoppeld aan elke doelstelling, kun je doorgaan naar de volgende pagina.</p><p><strong>Tips voor bewijs: </strong></p>\n<p>Als je niet zeker weet welke informatie je als bewijs moet invoeren, kunnen de volgende vragen helpen: <br/><br/>\n<strong>Denk aan de mensen die je met deze activiteit wilt bereiken, </strong><br/><br/>\nWaarom zijn deze doelstellingen belangrijk voor hen? <br/>\nWaar staan ze nu in verhouding tot deze uitkomst?<br/><br/><br/>\n<strong>Denk aan de resultaten,</strong><br/><br/>\nWelke soorten activiteiten of processen helpen bij het bereiken van de beoogde resultaten?<br/>\nHoe weet je dat jouw activiteit debeoogde  resultaten zal opleveren?<br/>\nOver welke middelen beschik je en welke middelen heb je nog nodig om je activiteit uit te voeren?<br/></p>",
      "activity_goal": "<p><strong>Doel </strong></p>\n<p><strong>Actie: </strong></p>\n<p>De gegevens voor deze pagina zijn ingesteld toen dit record werd aangemaakt.  Je hoeft op deze pagina niets te doen.</p>\n<p><strong>Achtergrond: </strong></p>\n<p>Dit programma van activiteiten is opgezet om een doel van de financierende organisatie te realiseren. Het beoogde doel is op deze pagina ingevuld en als deze activiteit succesvol is, heeft ze bijgedragen aan het bereiken van het doel.</p>\n<p><strong>Domeinen: </strong></p>\n<p>Een domein is een werkgebied. Er zijn vijf domeinen (Cultureel, Sociaal, Economisch, Ecologisch en Democratisch bestuur) en elk domein heeft een reeks uitkomsten die door afzonderlijke activiteiten kunnen worden bereikt. De geselecteerde domeinen zijn gebaseerd op het geselecteerde doel, de beslissing van de activiteitenbeheerder.  In sommige gevallen is je wellicht een keuze aan resultaten voor deze activiteit aangeboden en die keuzes bepalen welke domeinen op deze pagina worden ingevuld.</p>",
      "activity_objective": "<p><strong>Doelstelling </strong></p>\n<p><strong>Actie: </strong></p>\n<p>De gegevens voor deze pagina zijn ingesteld toen dit record werd aangemaakt.  Je hoeft op deze pagina niets te doen.</p>\n<p><strong>Achtergrond: </strong></p>\n<p> </p>\n<p><strong>Uitkomsten: </strong></p>\n<p>De pagina Doelstelling geeft de uitkomst(en) aan die je met deze activiteit wilt bereiken. Met uitkomst bedoelen we de verandering die voor deelnemers optreedt als gevolg van het ervaren van een activiteit. In sommige gevallen zijn de uitkomsten die op deze pagina zijn geselecteerd bepaald door de activiteitenbeheerder. In andere gevallen is je gevraagd de uitkomsten te selecteren waarop je je wilt richten. Deze moeten op deze pagina terug te vinden zijn.  Neem bij problemen contact op met de activiteitenbeheerder.</p>",
      "activity_report": "<p><strong>Rapport: </strong></p> <p><strong>Actie: </strong></p> <p>Deze pagina toont het eindrapport van je activiteit, samengesteld uit de gegevens op de vorige pagina's. Je kunt een kopie van dit rapport downloaden via de knop Exporteren rechtsboven op de pagina.<br/><br/> Als er nog informatie openstaat van de vorige pagina's, zie je bovenaan de pagina een blauwe melding over openstaande informatie. Als er geen informatie openstaat, kun je het bestand afsluiten door onderaan de pagina op de knop Activiteit archiveren te klikken. </p> <strong>Achtergrond/informatie:</strong> <p>Zodra je je activiteit hebt gearchiveerd, wordt de activiteitenbeheerder op de hoogte gebracht dat je activiteit is afgerond en dat het rapport klaar is om te bekijken.  Als de activiteitenbeheerder wil dat je meer informatie aan het activiteitsrecord toevoegt, opent deze het record opnieuw en laat hij of zij je weten welke informatie je moet invoeren. </p>",
      "activity_theory_of_change": "<p><strong>Theory of Change </strong></p>\n<p><strong>Actie: </strong></p>\n<p>Op deze pagina voer je informatie in de tekstvakken in om een pitch (Theory of Change) te maken die uitlegt waarom je voorgestelde activiteit de uitkomsten zal bereiken.</p>\n<p>Per uitkomst zijn er twee tekstvelden in te vullen. Boven elk tekstveld staat het begin van een zin die je in het tekstveld moet voortzetten.</p>\n<p>In het eerste veld vat je de ideeën samen uit het bewijs dat je voor de uitkomst hebt ingevoerd. In het tweede beschrijf je wat je, op basis van dat bewijs, gaat doen om de uitkomst te bereiken.</p>\n<p>Een korte manier om hierover na te denken is:<br/><br/>\n<strong>Strevend naar</strong> geselecteerde uitkomst\n<strong>en in de wetenschap dat</strong> samenvatting van je bewijs, <strong>zullen we</strong> dit doen om de uitkomst te bereiken.</p>\n<p>Nadat je beide velden hebt ingevuld, selecteer je de knop Theory of Change bekijken om te controleren of je Theory of Change als een samenhangend idee leest.</p>"
    },
    "tooltips": {
      "active_participants_free": "Deelnemers die actief betrokken zijn (bijv. workshopdeelnemers, uitvoerders, enz.) en niet betalen om deel te nemen.",
      "active_participants_paid": "Deelnemers die actief betrokken zijn (bijv. workshopdeelnemers, uitvoerders, enz.) en worden betaald om deel te nemen.",
      "active_participants_paying": "Deelnemers die actief betrokken zijn (bijv. workshopdeelnemers, uitvoerders, enz.) en betalen om deel te nemen aan de activiteit.",
      "activity_approval": "Zodra aan alle planningsvereisten is voldaan, kun je de activiteit ‘groen licht’ geven om verder te gaan.",
      "activity_description": "Controleer of deze beschrijving nauwkeurig weergeeft wat is uitgevoerd.",
      "activity_members": "Klik op de knop ‘Gastgebruiker toevoegen’ om mensen uit te nodigen samen te werken aan dit activiteitenrecord. De activiteitenbeheerder wordt automatisch uitgenodigd.",
      "activity_name": "De ingevoerde naam van de activiteit kan hier worden gewijzigd of aangepast.",
      "activity_plan": "Deze pagina registreert input- en outputinformatie. Opmerking: in de planningsfase registreert deze pagina prognoses; zodra de activiteit is goedgekeurd, wordt hier de werkelijke informatie vastgelegd.",
      "activity_summary": "Deze beschrijving verschijnt bovenaan elk rapport dat voor deze activiteit wordt gegenereerd.",
      "actual_inputs": "Controleer of deze informatie correct is en breng eventuele wijzigingen aan via de Activiteit-pagina.",
      "actual_outputs": "Controleer of deze informatie correct is en breng eventuele wijzigingen aan via de Activiteit-pagina.",
      "add_new_evidence": "Voer informatie in uit je eigen ervaring of onderzoek ter ondersteuning van deze activiteit.",
      "create_multi_stage_evaluation_series": "Ontworpen voor langdurige activiteiten waarbij dezelfde deelnemers over een langere periode worden gevolgd.",
      "create_sub_group": "Maak een subgroep aan als je een enkele deelnemersgroep wilt opdelen in kleinere groepen voor evaluatie.",
      "documentation": "Voer je uiteindelijke analyse en reflectie over de activiteit in en bekijk de gegevens voor het eindrapport.",
      "evaluation": "Volg de stappen om een evaluatieplan voor deze activiteit te maken. Zie de hulp voor meer informatie.",
      "evaluation_results_analysis": "Analyseer de informatie uit je evaluatie en beschrijf wat deze vertelt over de uitkomsten van de deelnemers en welke factoren belangrijk waren.",
      "evidence": "Deze pagina registreert informatie over de beoogde uitkomsten en hoe deze te bereiken. Raadpleeg de hulp voor meer informatie.",
      "evidence_content": "Voer een samenvatting in van de informatie die je als bewijs wilt gebruiken. Samenvattingen moeten duidelijk en beknopt zijn en afkortingen of interne termen vermijden, aangezien je bewijs door anderen kan worden gelezen.",
      "evidence_source": "Voer een bronvermelding in voor de toegevoegde informatie. De verwijzing moet lezers in staat stellen de originele bron te vinden – auteur, jaar, titel en publicatie worden aangeraden, ook bij een URL. Voor praktijkkennis vermeld je je functie, jaar en waarop de kennis is gebaseerd.",
      "goal": "Deze pagina toont de doelen en domeinen die zijn geselecteerd voor het programma waar deze activiteit deel van uitmaakt.",
      "green_light_date": "Voer de datum in waarop je verwacht dat alle planningspagina’s in Takso voltooid zijn en een beslissing is genomen om de activiteit door te laten gaan. In sommige gevallen wordt deze datum ingesteld door de activiteitenbeheerder.",
      "make_visible_in_takso_library": "Om leren binnen de sector te bevorderen, worden eindrapporten toegevoegd aan de Takso-bibliotheek. Als je akkoord gaat dat het eindrapport (volgende pagina) wordt toegevoegd, schakel dan deze optie in.",
      "objective": "Op deze pagina zie je de uitkomsten (Doelstelling) die deze activiteit wil bereiken.",
      "projected_program_contribution": "Het bedrag dat vanuit het programma wordt gevraagd om bij te dragen aan de uitvoering van deze activiteit.",
      "receptive_participants_free": "Bezoekers die niet deelnemen aan creatieve productie en niet betalen om de activiteit bij te wonen.",
      "receptive_participants_paying": "Bezoekers die niet betrokken zijn bij creatieve productie en betalen om deel te nemen aan deze activiteit.",
      "reflection": "Kijk terug op de hele activiteit en geef een laatste reflectie over het verloop, de successen en de uitdagingen.",
      "report": "Bekijk en download het eindrapport en sluit het activiteitenrecord af.",
      "search_evidence": "Bekijk bewijzen die door Takso-gebruikers in hun activiteiten zijn ingevoerd.",
      "select_activity_type": "Selecteer uit de lijst het activiteitstype dat het best bij je voorgestelde activiteit past.",
      "select_data_collection_method": "Selecteer hoe je de gegevens verzamelt en de resultaten in Takso invoert.",
      "select_evaluation_group": "Selecteer de groep(en) aan wie je deze enquête wilt richten. Je kunt meerdere groepen in één evaluatieplan opnemen of aparte plannen maken. Let op: enquêtes voor subgroepen kunnen niet met andere groepen worden gecombineerd.",
      "select_evaluation_method": "Selecteer hoe je de enquête zult uitvoeren.",
      "select_new_contractor": "Klik op ‘Nieuwe leverancier toevoegen’ om gegevens in te voeren over personen of diensten die je moet inhuren voor deze activiteit.",
      "select_new_partner": "Klik op ‘Nieuwe partner toevoegen’ om gegevens in te voeren over personen/organisaties die bijdragen aan de activiteit zonder betaling te ontvangen.",
      "select_new_venue": "Klik op ‘Nieuwe locatie toevoegen’ om gegevens in te voeren over de locaties die nodig zijn voor deze activiteit.",
      "select_objectives": "Selecteer de doelstellingen die je in deze enquête wilt opnemen. Je kunt meerdere evaluatieplannen maken, maar elk resultaat moet in minstens één plan worden opgenomen.",
      "select_outcome": "Selecteer het resultaat om de enquêtevraag te bekijken. Gemarkeerde tekst kan worden aangeklikt en aangepast aan de activiteit en deelnemers.",
      "summarise_evidence": "Vat de belangrijkste punten van je bewijs samen.",
      "toc": "Op deze pagina maak je een programmalogica voor de activiteit op basis van de ingevoerde bewijzen. Raadpleeg de hulp voor meer informatie.",
      "total_amount_needed": "Totaalbedrag dat nodig is om deze activiteit uit te voeren.",
      "unpublished_report": "Voer gedachten en observaties in die je wilt vastleggen maar niet wilt opnemen in het eindrapport. Dit kunnen problemen of succesfactoren zijn. Deze velden zijn alleen zichtbaar voor wie toegang heeft tot dit record.",
      "upload_media": "Upload activiteitsmateriaal zoals foto’s, korte video’s en andere documenten. URL’s worden alleen als tekst opgeslagen en moeten in een browser worden geplakt om te bekijken.",
      "we_will": "Denk na over het bewijs dat je hierboven hebt samengevat en beschrijf het soort activiteit of proces dat het meest waarschijnlijk het resultaat zal bereiken."
    }
  },
  "html_editors": {
    "collapse": "Inklappen",
    "collapse_description": "Inklappen naar compacte weergave",
    "expand_to_fit": "Uitvouwen tot volledige breedte",
    "expand_to_fit_description": "Uitvouwen om de volledige tekst te tonen"
  },
  "image_picker": {
    "could_not_load_images": "Kon afbeeldingen niet laden. Probeer het opnieuw.",
    "dual_outcomes_one": "dubbele uitkomst",
    "dual_outcomes_other": "dubbele uitkomsten",
    "evaluation_plans_one": "evaluatieplan",
    "evaluation_plans_other": "evaluatieplannen",
    "loading_images": "Afbeeldingen laden",
    "no_images_found_upload": "Geen afbeeldingen gevonden. Upload eerst afbeeldingen naar de kaart <strong>Documenten & Media</strong> van de activiteit.",
    "plan_count_summary_fmt": "<strong>{{planCount}}</strong> {{evalPlans}} , <strong>{{dualActivityCount}}</strong> {{dualOutcomes}} , <strong>{{singleActivityCount}}</strong> {{singleOutcomes}}",
    "select_image_from": "Selecteer een afbeelding uit Documenten & Media",
    "single_outcomes_one": "enkele uitkomst",
    "single_outcomes_other": "enkele uitkomsten",
    "use_n_images_one": "{{count}} afbeelding gebruiken",
    "use_n_images_other": "{{count}} afbeeldingen gebruiken",
    "use_this_image": "Deze afbeelding gebruiken"
  },
  "images": {
    "upload_image": "Afbeelding uploaden"
  },
  "invoice_status": {
    "closed": "Gesloten",
    "fail": "Mislukt",
    "overdue": "Achterstallig",
    "paid": "Betaald",
    "pending": "In behandeling"
  },
  "library": {
    "browseActivities": {
      "activityBrowser": "Activiteitenbibliotheek",
      "activityBrowserSubTitle": "Verken activiteitenrapporten die op het Takso-platform zijn gemaakt.",
      "activityName": "Naam van de activiteit",
      "activitySummary": "Activiteitsoverzicht",
      "dateCreated": "Aangemaakt op:",
      "lastEdited": "Laatst bewerkt:",
      "noActivities": "Geen activiteiten...",
      "preview": "Voorbeeld",
      "scopes": {
        "all_takso": "All Takso Gegevens",
        "my_library": "Mijn Bibliotheek",
        "my_organisation": "Mijn Organisatie"
      },
      "searchActivities": "Activiteiten zoeken"
    }
  },
  "maps": {
    "boundary": "Grens",
    "heatmap": "Heatmap",
    "interactive": "Interactief",
    "map_options": "Kaartopties",
    "map_type": "Kaarttype",
    "report_view": "Rapportweergave",
    "yes_load_map": "Ja, kaart laden",
    "zoom_level": "Zoomniveau"
  },
  "network": {
    "back_online": "Weer online",
    "no_internet_connection": "Geen internetverbinding",
    "your_connection_is_slow": "Je verbinding is traag. Het opslaan van je werk kan vertraging oplopen."
  },
  "notifications": {
    "broadcast_message": "Broadcastbericht",
    "broadcast_new_message": "Nieuw broadcastbericht",
    "broadcast_notification": "Broadcastmelding",
    "broadcast_notification_super_admin": "Broadcastmelding - Superbeheerder",
    "no_notification_found": "Geen melding gevonden…",
    "received_notification": "Ontvangen melding",
    "select_organisation": "Selecteer organisatie",
    "select_organisation_is_required": "Selectie van organisatie is vereist",
    "send_to_all_organisation": "Verstuur naar alle organisaties",
    "title": "Meldingen",
    "view_broadcast_message": "Broadcastbericht bekijken"
  },
  "organisation": {
    "activities": {
      "invited": "Uitgenodigd",
      "managed": "Beheerd",
      "no_user_activities_yet": "Nog geen gebruikersactiviteiten…",
      "show_by": "Weergeven per:",
      "user_activities_header": "Gebruikersactiviteiten - {{user_name}}"
    },
    "communication": {
      "contact_support": "Contact opnemen met Takso-support",
      "errors": {
        "message_reqd": "Bericht is verplicht",
        "select_a_target": "Selecteer ten minste één bestemming (e-mail of dashboard)",
        "select_one_option_required": "Kies een bestemming",
        "select_users_required": "Kies een of meerdere gebruikers"
      },
      "new_badge": "Nieuw",
      "no_notification_found": "Geen melding gevonden...",
      "notification_creation_header": "Contact opnemen met organisatiegebruikers",
      "notification_creation_trigger": "Contact opnemen met organisatiegebruikers",
      "select_users_heading": "GEBRUIKERS SELECTEREN",
      "select_users_placeholder": "Selecteer gebruikers",
      "send_to_all_users": "Alle gebruikers",
      "send_to_myself": "Test naar mijzelf versturen",
      "send_to_org_admins": "Organisatiebeheerders",
      "send_to_selected_users": "Geselecteerde gebruikers",
      "sender": "Afzender",
      "view_broadcast_message": "Broadcastbericht bekijken"
    },
    "contacts": {
      "add_new_contractor": "Nieuwe leverancier toevoegen",
      "add_new_partner": "Nieuwe partner toevoegen",
      "confirm_delete_contractor": "Weet je zeker dat je deze leverancier wil verwijderen?",
      "confirm_delete_partner": "Weet je zeker dat je deze partner wilt verwijderen?",
      "delete_contractor_with_name": "Leverancier verwijderen - {{name}}",
      "delete_partner_with_name": "Partner verwijderen - {{name}}",
      "manage_contacts": "Contacten beheren",
      "no_activities_for_partner": "Er zijn geen activiteiten gekoppeld aan deze partner...",
      "no_contractors_added": "Er zijn geen leveranciers toegevoegd...",
      "no_partners": "Er zijn geen partners toegevoegd...",
      "partner_form": {
        "anonymous_donor": "Anonieme donor",
        "funding": "Financiering",
        "in_kind": "In natura",
        "in_kind_value": "Waarde in natura",
        "network": "Netwerk",
        "relationship": "Relatie"
      },
      "update_contractor_header": "Leverancier bijwerken",
      "view_contractor_with_name": "Leverancier bekijken - {{name}}",
      "view_history": "Geschiedenis bekijken"
    },
    "core_data": {
      "confirm_delete_doc": "Weet je zeker dat je dit document in kerngegevens wilt verwijderen?",
      "delete_doc_in_core_data": "Document in kerngegevens verwijderen",
      "format": "Formaat",
      "report_name": "Rapportnaam",
      "set_cultural_assets": "Culturele activa en begrote terugkerende uitgaven instellen"
    },
    "department_and_units": {
      "add_department": "Afdeling toevoegen",
      "add_unit": "Eenheid toevoegen",
      "add_unit_to_department": "Eenheid aan afdeling toevoegen",
      "all_department_goals_are_available_for_this_department": "Alle afdelingsdoelen zijn beschikbaar voor deze afdeling",
      "all_org_goals": "Alle organisatiedoelen",
      "all_org_goals_are_available_for_selection": "Alle organisatiedoelen zijn beschikbaar voor selectie",
      "all_organisation_goals_are_available_for_this_department": "Alle organisatiedoelen zijn beschikbaar voor deze afdeling",
      "are_you_sure_you_want_to_remove_this_department_or_unit": "Weet je zeker dat je de {{department_or_unit}} wilt verwijderen?",
      "categories": "Categorieën",
      "department": "Afdeling",
      "department_description": "Beschrijving van de afdeling",
      "department_name": "Naam van de afdeling",
      "direct": "Direct",
      "edit_department": "Afdeling bewerken",
      "edit_dept_labels": "Afdelingslabels bewerken",
      "edit_labels": "Labels bewerken",
      "edit_unit": "Eenheid bewerken",
      "goals": "Doelen",
      "inherited_goals": "Overgenomen doel(en)",
      "label_plural": "Label (meervoud)",
      "label_singular": "Label (enkelvoud)",
      "leave_row_blank_to_remove_label": "Laat een rij leeg om dat niveau te verwijderen.",
      "level": "Niveau",
      "no_admins_assigned": "Geen beheerders toegewezen.",
      "no_departments_or_units_have_been_added": "Er zijn geen afdelingen of eenheden toegevoegd",
      "please_create_a_department": "Maak eerst een afdeling aan",
      "remove_admin": "Beheerder verwijderen",
      "remove_departement_or_unit": "{{department_or_unit}} verwijderen",
      "select_departments": "Selecteer afdelingen",
      "select_goals": "Selecteer doelstellingen",
      "some_org_goals_are_available_for_selection": "Sommige organisatiedoelen zijn beschikbaar voor selectie",
      "specific_goals": "Specifieke doelstellingen",
      "unit_description": "Beschrijving van de eenheid",
      "unit_name": "Naam van de eenheid"
    },
    "goals": {
      "browse_help_message": "Dit document dient als referentie voor de doelen van je {{type}}",
      "browse_info_message": "Maximale bestandsgrootte - 50 MB",
      "browse_label": "{{type}} strategisch plan uploaden",
      "create_strategic_document": "Strategisch document aanmaken",
      "delete_goal_title": "Doel verwijderen",
      "delete_goalconfirm": "Weet je zeker dat je dit doel wil verwijderen?",
      "document_title": "Documenttitel",
      "document_title_required": "Documenttitel is vereist",
      "form": {
        "obtain_from": "Je kunt doelen distilleren uit de strategische documenten van je {{type}} (max. 250 tekens)",
        "optional": "(optioneel)",
        "primary_policy_domain_for_goal": "Primair domein voor het doel",
        "short_description": "Een korte beschrijving van het doel"
      },
      "new_strategic_document": "Nieuw strategisch document",
      "noGoals": "Er zijn geen {{type}} doelstellingen toegevoegd...",
      "noStrategicDocuments": "Er zijn geen strategische documenten aangemaakt",
      "organisation_strategic_document": "Strategisch document van de organisatie",
      "policy_name_description": "{{policyName}} (i.e. {{policyDescription}})",
      "report_year": "Rapportjaar",
      "strategic_plan_title": "Strategisch document van de organisatie",
      "title": "Doel van de organisatie"
    },
    "goals_not_created": "Doelen zijn nog niet aangemaakt.",
    "messages": {
      "account_checklist": "Accountchecklist voor activiteitenplanning",
      "account_checklist_item_created": "Je checklist-item is succesvol aangemaakt!",
      "account_checklist_item_deleted": "Je checklist-item is succesvol verwijderd!",
      "account_checklist_item_updated": "Je checklist-item is succesvol bijgewerkt!",
      "account_contractor": "Accountleverancier",
      "account_contractor_created": "Leverancier is succesvol aangemaakt!",
      "account_contractor_deleted": "Leverancier is succesvol verwijderd!",
      "account_contractor_updated": "Leverancier is succesvol bijgewerkt!",
      "account_core_data": "Kerngegevens account",
      "account_core_data_updated": "Je kerngegevens zijn succesvol bijgewerkt!",
      "account_goal": "Accountdoel",
      "account_goal_created": "Je accountdoel is succesvol aangemaakt!",
      "account_goal_deleted": "Je accountdoel is succesvol verwijderd!",
      "account_goal_info": "Accountdoelinformatie",
      "account_goal_references": "Accountdoelverwijzingen",
      "account_goal_references_archived": "Je doelverwijzingen zijn succesvol gearchiveerd!",
      "account_goal_references_created": "Je doelverwijzingen zijn succesvol aangemaakt!",
      "account_goal_references_deleted": "Je doelverwijzingen zijn succesvol verwijderd!",
      "account_goal_references_updated": "Je doelverwijzingen zijn succesvol bijgewerkt!",
      "account_goal_updated": "Je accountdoel is succesvol bijgewerkt!",
      "account_guest_user": "Accountgastgebruiker",
      "account_guest_user_activity_reassigned": "Activiteit van gastgebruiker is succesvol herverdeeld!",
      "account_info": "Accountinformatie",
      "account_info_updated": "Je accountinformatie is succesvol bijgewerkt!",
      "account_partner": "Accountpartner",
      "account_partner_created": "Partner is succesvol aangemaakt!",
      "account_partner_deleted": "Partner is succesvol verwijderd!",
      "account_partner_updated": "Partner is succesvol bijgewerkt!",
      "account_strategic_plan_uploaded": "Je strategisch plan is succesvol geüpload!",
      "account_user": "Accountgebruiker",
      "account_user_created": "Accountgebruiker is succesvol aangemaakt!",
      "account_user_deleted": "Accountgebruiker is succesvol verwijderd!",
      "account_user_invited_activities_withdrawn": "Alle uitgenodigde activiteiten van de accountgebruiker zijn ingetrokken!",
      "account_user_password_reset": "Wachtwoord van accountgebruiker is succesvol opnieuw ingesteld!",
      "account_user_type_updated": "Gebruikerstype is succesvol bijgewerkt!",
      "account_venue_created": "Locatie is succesvol aangemaakt!",
      "account_venue_deleted": "Locatie is succesvol verwijderd!",
      "account_venue_updated": "Locatie is succesvol bijgewerkt!",
      "account_venues": "Accounteventlocaties",
      "annual_report": "Jaarverslag",
      "annual_report_plan_uploaded": "Je jaarverslagplan is succesvol geüpload!",
      "core_data_document_removed": "Het document in kerngegevens is succesvol verwijderd.",
      "cross_reference_document": "Kruisverwijzingsdocument",
      "cross_reference_document_created": "Kruisverwijzingsdocument is succesvol aangemaakt!",
      "cross_reference_document_updated": "Kruisverwijzingsdocument is succesvol bijgewerkt!",
      "get_account_checklist_for_activity_reporting": "Accountchecklist ophalen voor activiteitenrapportage",
      "reset_password": "Wachtwoord resetten",
      "your_password_has_been_successfully_reset": "Je wachtwoord is succesvol opnieuw ingesteld!"
    },
    "organization": {
      "checklist": "Checklist",
      "settings": "Instellingen"
    },
    "page_title": "Organisatie | {{appName}}",
    "permissions": {
      "environmental_tester": "Omgevingstester"
    },
    "profile": {
      "leave_modal_content": "Je hebt niet-opgeslagen wijzigingen. Wilt je de pagina verlaten?",
      "leave_modal_title": "Weet je zeker dat je deze pagina wilt verlaten?"
    },
    "settings": {
      "archive_goal_references": "Doelverwijzingen archiveren",
      "archived_goal": "Gearchiveerd doel",
      "checklist": {
        "add_checklist_item_header": "Nieuw checklist-item toevoegen",
        "add_checklist_item_trigger": "Checklist-item toevoegen",
        "checklist_question": "Checklistvraag",
        "confirm_delete": "Weet je zeker dat je dit checklist-item wilt verwijderen?",
        "delete_checklist_item": "Checklist-item verwijderen",
        "edit_checklist_item": "Checklist-item bewerken",
        "label": "Checklist",
        "question_required": "Vraag is vereist"
      },
      "confirm_archive": "Weet je zeker dat je deze verwijzingen wilt archiveren?",
      "cross_reference": "Kruisverwijzing",
      "deleted_goal": "Verwijderd doel",
      "departments": "Afdelingen",
      "departments_units": "Afdelingen en eenheden",
      "end_cross_referencing_confirmation": "Weet je zeker dat je niet langer wilt dat activiteiten kruisverwijzingen registreren?",
      "end_cross_referencing_title": "Kruisverwijzingen beëindigen",
      "item": "Item",
      "new_cross_reference_document": {
        "being_built": "Deze functie wordt momenteel ontwikkeld en zal binnenkort beschikbaar zijn.",
        "create_new": "Nieuw kruisverwijzingsdocument aanmaken",
        "in_the_meantime": "Neem intussen contact op met Takso-support",
        "request_suffix": "om te vragen dat je nieuwe verwijzingen aan je account worden toegevoegd.",
        "support_email": "support@takso-outcomes.com"
      },
      "no_checklist_added": "Er zijn geen checklists toegevoegd...",
      "no_reference_added": "Er is geen verwijzing toegevoegd",
      "once_selected_goal_immutable": "Zodra je een doel selecteert, kan je dit niet meer wijzigen",
      "organisation_settings": {
        "calendar_year": "Kalenderjaar",
        "calendar_year_range": "1 januari tot 31 december",
        "cross_reference": "Kruisverwijzing",
        "culture_counts": "Culture Counts",
        "departments_tooltip": "Schakel in als je rapporten per afdeling wilt genereren",
        "enter_management_code_label": "Voer label voor beheercode in",
        "financial_reporting_period": "Financiële rapportageperiode",
        "financial_year": "Boekjaar",
        "financial_year_range": "1 juli tot 30 juni volgend jaar",
        "management_code": "Beheercode",
        "require_approval": "Goedkeuring vereist"
      },
      "organization_settings": "Organisatie-instellingen",
      "reference_document": "Verwijzingsdocument",
      "reference_form": {
        "accepted_file_types": "Toegestane bestandstypen: .pdf, .docx",
        "add_more_references": "Meer verwijzingen toevoegen",
        "browse_file": "Bestand selecteren",
        "document_title": "Documenttitel",
        "document_title_required": "Documenttitel is vereist",
        "max_file_size": "Maximale bestandsgrootte - 50 MB",
        "reference_field_label": "Label van verwijzingsveld",
        "reference_field_label_required": "Label van verwijzingsveld is vereist",
        "reference_required": "Verwijzing is vereist",
        "title": "Kruisverwijzingsdocument toevoegen",
        "update_cross_reference_document_header": "Kruisverwijzingsdocument bijwerken",
        "upload_reference_document": "Verwijzingsdocument uploaden"
      },
      "update_reference_trigger": "Verwijzing bijwerken"
    },
    "tabs": {
      "contacts": "Contacten",
      "profile": "Profiel",
      "settings": "Instellingen",
      "user_management": "Gebruikersbeheer",
      "venues": "Locaties"
    },
    "unsaved_modal_content": "JE hebt niet-opgeslagen wijzigingen. Wilt je de pagina verlaten?",
    "unsaved_modal_title": "Weet je zeker dat je deze pagina wilt verlaten?",
    "update_details": "Organisatiedetails bijwerken",
    "user_management": {
      "cdn_admin": "cdn-beheerder",
      "change_user_type_header": "Gebruikerstype wijzigen - {{user_name}}",
      "change_user_type_trigger": "Gebruikerstype wijzigen",
      "delete_user": "Gebruiker verwijderen",
      "delete_user_confirmation": "Weet je zeker dat je deze gebruiker wilt verwijderen?",
      "delete_user_header": "Gebruiker verwijderen - {{user_name}}",
      "department_removed_from_user": "De gebruiker is uit de afdeling verwijderd",
      "guest_users": "Gastgebruikers",
      "manage_users": "Gebruikers beheren",
      "no_guest_users_added": "Er zijn geen gastgebruikers toegevoegd...",
      "no_users_added": "Er zijn geen gebruikers toegevoegd...",
      "none": "Geen",
      "on_confirming_removal_the_user_will_be_withdrawn_from_all_invited_activities": "Bij bevestiging van verwijdering wordt de gebruiker verwijderd uit alle uitgenodigde activiteiten.",
      "password_change_header": "Wachtwoord opnieuw instellen - {{user_name}}",
      "reassign_activities": "Activiteiten overdragen",
      "reassign_activity": {
        "activity_part_of_group": "Deze activiteit maakt deel uit van een groep met {{count}} andere activiteiten. Als je deze activiteit uit de groep wilt halen en overdragen aan een andere gebruiker, selecteer 'Enkele activiteit'. Als je alle activiteiten in de groep wilt overdragen aan een nieuwe gebruiker, selecteer 'Alle activiteiten'.",
        "all_activities_need_to_be_transferred_before_users_can_be_removed_from_the_account": "Alle activiteiten moeten worden overgedragen voordat gebruikers uit het account kunnen worden verwijderd.",
        "assign_to_required": "Toewijzen aan is verplicht",
        "reassign_activities": "Activiteiten overdragen",
        "reassign_all_activities": "Alle activiteiten overdragen",
        "reassign_an_activity": "Een activiteit overdragen",
        "select_activities_from_required": "Selecteer activiteiten van is verplicht",
        "select_activities_required": "Selecteer activiteiten is verplicht",
        "transfer_all": "Alle beheerde activiteiten van één gebruiker naar een andere overdragen",
        "transfer_individual": "Beheer van afzonderlijke activiteiten overdragen",
        "user_has_archived_activities": "Gebruiker heeft {{completedOwned}} gearchiveerde activiteiten. Gearchiveerde activiteiten toewijzen aan geselecteerde gebruiker?",
        "user_has_owned_activities": "Gebruiker heeft {{ownedActivities}} eigen activiteiten. Activiteiten van deze gebruiker moeten eerst worden toegewezen."
      },
      "remove_user_invited_activities": "Uitgenodigde activiteiten verwijderen - {{user_name}}",
      "select_user_type": "Selecteer een gebruikerstype",
      "this_user_is_invited_to_in_active_activity": "Deze gebruiker is uitgenodigd voor {{count}} actieve activiteit.",
      "this_user_is_invited_to_in_active_and_in_development_activity": "Deze gebruiker is uitgenodigd voor {{count}} actieve activiteit en {{count2}} activiteit in ontwikkeling.",
      "this_user_is_invited_to_in_development_activity": "Deze gebruiker is uitgenodigd voor {{count}} activiteit in ontwikkeling.",
      "user_type": "Gebruikerstype",
      "user_type_required": "Gebruikerstype is verplicht",
      "view_guest_users_activities_header": "Activiteiten van gastgebruikers bekijken: {{user_name}}",
      "view_guest_users_activities_trigger": "{{count}} activiteiten"
    },
    "venues": {
      "add_new_venue": "Nieuwe locatie toevoegen",
      "delete_venue_confirm_text": "Weet je zeker dat u deze locatie wilt verwijderen?",
      "delete_venue_header": "Locatie verwijderen - {{name}}",
      "manage_venues": "Locaties beheren",
      "no_venues_added": "Er zijn geen locaties toegevoegd",
      "this_venue_is_owned_by": "Deze locatie is eigendom van {{org}}",
      "venue_update_header": "Locatie bijwerken - {{name}}"
    }
  },
  "other_translation": {
    "copied": "Gekopieerd",
    "copy": "Kopiëren",
    "table": {
      "no_records_found": "Geen records gevonden..."
    }
  },
  "outcomes": {
    "formal": "Formeel",
    "formal_title": "Formele titel",
    "graded": "Gescoord",
    "graded_title": "Gescoorde titel",
    "graded_version": "Gescoorde versie",
    "not_set_click_edit_to_add": "Niet ingesteld — klik op Bewerken om toe te voegen"
  },
  "output_formats": {
    "enter_formula_here": "Voer hier de formule in",
    "errors": {
      "not_possible_to_delete_previously_saved": "Eerder opgeslagen outputformaten kunnen niet worden verwijderd."
    },
    "format": "Formaat"
  },
  "permission_type": {
    "collaborator": "Medewerker",
    "custom": "Aangepast",
    "documentor": "Documentalist",
    "report_only": "Alleen rapporteren"
  },
  "policy": {
    "cultural": "Cultureel",
    "economic": "Economisch",
    "environment": "Ecologisch",
    "environmental": "Omgeving",
    "governance": "Democratisch Bestuur",
    "social": "Sociaal"
  },
  "postcode_maps": {
    "boundaries_unavailable": "Grenzen niet beschikbaar",
    "click_a_row_to_zoom": "Klik op een rij om in te zoomen · klik opnieuw om de selectie op te heffen",
    "csv": {
      "external_csv_no_csv_uploaded": "Extern CSV-bestand <span> — geen CSV geüpload</span>",
      "no_column_heading": "<strong>{{fileName}}</strong> lijkt {{postcodes}} te bevatten zonder kolomkop. Gebruiken voor de kaart?",
      "select_poctcode_column": "<strong>{{fileName}}</strong> heeft {{columns}} — selecteer de kolom met postcodes:",
      "upload_to_enable": "Upload een CSV-bestand naar Documenten & Media van de activiteit om dit in te schakelen"
    },
    "different_postcodes_fmt": "<strong>{{num}}</strong> verschillende {{postcodes}}",
    "errors": {
      "boundaries_error": "Fout bij grenzen"
    },
    "fit_to_data": "Aanpassen aan de gegevens",
    "hide_table": "Tabel verbergen",
    "loading_boundaries": "Grenzen laden",
    "loading_postcode_data": "Postcodegegevens laden",
    "no_postcode_responses": "Er zijn geen postcodegegevens geregistreerd voor deze activiteit.",
    "no_valid_postcodes_in_csv": "Geen geldige postcodes gevonden in het geselecteerde CSV-bestand.",
    "num_postcodes_one": "1 postcode",
    "num_postcodes_other": "{{count}} postcodes",
    "num_with_postcode_fmt": "<strong>{{responsesWithPostcode}}</strong> met postcode",
    "outside_map": "buiten de kaart",
    "pct_of_total": "{{pct}}% van het totaal",
    "place_labels": "Plaatslabels",
    "postcode_origin": "Herkomst postcode",
    "postcodes_one": "postcode",
    "postcodes_other": "postcodes",
    "show_table": "Tabel tonen"
  },
  "question_generator": {
    "by_outcome_we_mean": "Met {{outcome}} bedoelen we dat verbeelding, creativiteit of nieuwsgierigheid worden gestimuleerd, waardoor mensen meer zin krijgen om deel te nemen of zelf iets cultureels te maken.",
    "can_you_tell_us_more_about_why_you_gave_this_rating": "Kan je ons vertellen <strong>waarom</strong> je deze beoordeling gaf?",
    "description": "Deze vragengenerator is gemaakt om proffessionals te ondersteunen bij het uitvoeren van evaluaties met behulp van het van het Uitkomstenschema van het Cultural Development Network.",
    "download_pdf": "Downloaden als PDF",
    "full_description_html": "<p>Deze vragengenerator is ontwikkeld om professionals te ondersteunen bij evaluaties volgens het Outcome Schema van het Cultural Development Network.</p><p>Voordat je evalueert, moet je duidelijk hebben <b>wat</b> je te weten wilt komen over je activiteit en <b>wie</b> je verwacht dat beïnvloed is door je activiteit. Als je het planningsproces hebt gevolgd dat wordt aanbevolen in het Plannings-framework van het CDN of in Takso, zul je ten minste twee doelstellingen voor je activiteit hebben vastgesteld die je evaluatie zal moeten meten. Als dat niet het geval is, raden we je aan uitkomsten te selecteren uit het <a href=\"https://www.culturaldevelopment.net.au/outcomes/\" target=\"_blank\">uitkomsten-schema</a> die je activiteit bedoeld is te bereiken. Idealiter is één van de uitkomsten een culturele uitkomst, aangezien je activiteit een culturele activiteit is. Je activiteit kan ook een uitkomst of uitkomsten uit andere domeinen  hebben, zoals sociaal of economisch. Is je activiteit een culturele activiteit maar je wil niet-culturele uitkomsten testen, dan kan dat ook. Selecteer een of meer van deze uit het uitkomsten-schema voordat je begint. We raden aan niet meer dan twee uitkomsten te selecteren, aangezien elke uitkomst werk vereist om gegevens te verzamelen en deze te analyseren.</p>",
    "how_did_you_form_the_assessment_to_provide_this_evaluation": "Hoe hebt je de beoordeling gevormd om deze evaluatie te geven? <em>(je kunt meerdere opties kiezen)</em>",
    "intended_outcome_was": "De beoogde uitkomst was {{outcome}} door deelname aan deze activiteit.",
    "introduction": "Inleiding",
    "outcome_description": "Beschrijving van uitkomst",
    "pre_evaluation_guidance": "Voordat je een evaluatie uitvoert, moet het duidelijk zijn <b>wat</b> je wilt te weten komen over je activiteit en <b>wie</b> volgens jou beïnvloed is door je activiteit. Als je het planningsproces hebt gevolgd dat wordt aanbevolen in het planningskader van CDN of in Takso, dan heb je voor je activiteit al minstens twee doelstellingen bepaald die je met de evaluatie wil meten. Als dat nog niet zo is, raden we aan om doelstellingen te kiezen uit het <a href=\"https://www.culturaldevelopment.net.au/outcomes/\" target=\"_blank\">doelstellingenoverzicht</a> die je met je activiteit wil bereiken. Idealiter is één van de uitkomsten een culturele uitkomst, aangezien je activiteit een culturele activiteit is. Je activiteit kan ook een uitkomst of uitkomsten uit andere domeinen  hebben, zoals sociaal of economisch. Is je activiteit een culturele activiteit maar je wil niet-culturele uitkomsten testen, dan kan dat ook. Selecteer een of meer van deze uit het uitkomsten-schema voordat je begint. We raden aan niet meer dan twee uitkomsten te selecteren, aangezien elke uitkomst werk vereist om gegevens te verzamelen en deze te analyseren",
    "quantitative_data_html": "<p>De beoogde uitkomst was {{outcome}} door deelname aan deze activiteit.</p><h4>Hoe heb je deze evaluatie beoordeeld? <em>(kies een of meer opties)</em></h4>",
    "question_for_qualitative_data": "Vraag voor kwalitatieve gegevens",
    "question_for_quantitative_data": "Vraag / vragen voor kwantitatieve gegevens",
    "reason_for_this_evaluation_method": "Reden voor deze evaluatiemethode <em>(je kan slechts één optie kiezen)</em>",
    "select_method": "Selecteer de methode waarmee je de evaluatie zult uitvoeren.",
    "select_objective": "Selecteer de doelstelling die je wilt meten",
    "select_policy_domain": "Selecteer een domein waartoe je activiteit behoort.",
    "title": "VRAAGGENERATOR"
  },
  "report": {
    "activityParticipants": {
      "activityParticipants": "Activiteitsdeelnemers"
    },
    "activityVenues": {
      "activityVenues": "Activiteitslocaties"
    },
    "activity_count": "Aantal activiteiten",
    "activity_count_with_count": "Aantal activiteiten: {{count}}",
    "activity_evaluations": "Activiteitsevaluaties",
    "activity_name": "Activiteitnaam",
    "actual_outcomes": "Werkelijke uitkomsten",
    "after_average": "Gemiddelde na",
    "after_rating": "Beoordeling na",
    "after_response": "Reactie na",
    "after_responses": "Na reacties",
    "average": "Gemiddelde",
    "back_to_outcomes_addressed": "Terug naar aangesproken uitkomsten",
    "before_average": "Gemiddelde voor",
    "before_rating": "Beoordeling voor",
    "before_response": "Reactie voor",
    "before_responses": "Reacties voor",
    "builder": {
      "activity_date_range": "Periode van de activiteit",
      "activity_did_not_proceed_no_funding": "Activiteit is niet doorgegaan. Financiering niet toegezegd.",
      "activity_mix": "Activiteitenmix",
      "activity_not_found": "Activiteit niet gevonden.",
      "activity_types": {
        "account_holder": "Accounthouder",
        "guest": "Gast",
        "linked_singles": "Gekoppelde enkelvoudinge activiteiten",
        "programs": "Programma's",
        "singles": "Enkelvoudige activiteiten",
        "singles_only": "Alleen enkelvoudige activiteiten"
      },
      "add_custom_section": "Aangepaste sectie toevoegen",
      "add_custom_section_optional": "Aangepaste sectie toevoegen (optioneel)",
      "add_images_optional": "Afbeeldingen toevoegen (optioneel)",
      "add_images_or_graphics": "Afbeeldingen/graphics toevoegen",
      "add_more_images": "Meer afbeeldingen toevoegen",
      "add_text": "Tekst toevoegen",
      "additional_assets": "Aanvullende elementen zoals afbeeldingen voor de voettekst, watermerken of scheidingslijnen. Details worden nog bevestigd.",
      "additional_text": "Aanvullende tekst",
      "appendix_contractors": "Bijlage: Leveranciers",
      "brand_colors_and_banner": "Huiskleuren & banner",
      "breakdown_of_linked_activity_types": "Gekoppelde activiteitstypen per categorie (infrastructuur, ontwikkeling, presentatie)",
      "charts": "Grafieken",
      "click_to_edit_heading": "Klik hier om de kop te bewerken",
      "color_picker_in_next_phase": "De kleurenkiezer komt in de volgende fase.",
      "completed_activity_mix": "Programma's / Gekoppelde enkelvoudige activiteiten / Alleen enkelvoudige activiteiten",
      "completed_ownership_breakdown": "Programma's / Enkelvoudige activiteiten van accounthouders / Enkelvoudinge activiteiten van gasten / Alleen enkelvoudinge activiteiten",
      "completed_programs_vs_singles": "Programma's versus enkelvoudige activiteiten",
      "connections": "Verbindingen",
      "contractors": {
        "occupation_category": "Beroepscategorie",
        "service_type": "Soort dienst"
      },
      "contractors_by_occupation": "Leveranciers per beroep",
      "cover_image": "Omslagafbeelding",
      "cover_image_editing": {
        "add_cover_image": "Omslagafbeelding toevoegen",
        "change_cover_image": "Omslagafbeelding wijzigen",
        "change_image": "Afbeelding wijzigen",
        "reposition": "Verplaatsen",
        "reposition_or_zoom": "Omslagafbeelding verplaatsen of zoomen"
      },
      "cover_image_selected_from": "De omslagafbeelding wordt geselecteerd uit het gedeelte <strong>Documenten & Media</strong> van de organisatie op de documentatiepagina.",
      "enable_show_in_report": "Schakel 'Weergeven in rapport' in voor deze grafiek op het tabblad Grafieken.",
      "evaluation_report": "Evaluatierapport",
      "executive_summary": {
        "author_comment": "Begin met één uitspraak over waarom dit programma bestaat — niet wat het heeft gedaan, maar waarom het ertoe doet. De gegevens tonen {{numEventsFmt}} door de gemeenschap geleide {{events}} verspreid over {{grantRounds}}, met een geschat bereik van {{totalReach}} en ondersteund door {{volunteers}} vrijwilligers. Dat is de schaal, maar de uitspraak die dit inkadert moet gaan over zelfexpressie van de gemeenschap en cultureel leven, niet alleen over cijfers.",
        "grant_dollars": "Subsidie ($)",
        "title": "Managementsamenvatting",
        "writer_note": "Het bereikcijfer ({{totalReach}}) kan beïnvloed zijn door een klein aantal zeer grote evenementen. Bepaal in je inleiding of je opent met het opvallende getal of dit in context plaatst. Beide zijn verdedigbaar; de keuze bepaalt hoe de lezer het karakter van het programma begrijpt."
      },
      "funded_events": "Gefinancierde evenementen",
      "funded_programs_summary": "Overzicht van gefinancierde programma's",
      "grant_programs": "Subsidieprogramma's",
      "grant_rounds_one": "1 subsidieronde",
      "grant_rounds_other": "{{countFmt}} subsidierondes",
      "grant_rounds_zero": "geen subsidierondes",
      "highest_gain_across_outcomes": "De grootste stijging was te zien bij {{outcomeName}} (+{{points}}), van {{avgPre}} naar {{avgPost}}), gemeten over {{events}}. Begin je verhaal over de uitkomsten met dit resultaat.",
      "highest_gain_outcome": "Begin de toelichting op je resultaten met het resultaat met de grootste stijging",
      "how_often_each_outcome_measure_is_used": "Hoe vaak elke uitkomstmaat wordt gebruikt bij de onderling gekoppelde activiteiten",
      "how_outcome_measures_co_occur": "Hoe uitkomstmaten bij verschillende activiteiten voorkomen — verbonden knooppunten hebben activiteiten gemeen, geïsoleerde knooppunten (rechtsboven) komen afzonderlijk voor. Klik op twee knooppunten om hun verband weer te geven.",
      "image_picker_in_next_phase": "Afbeeldingskiezer volgt in de volgende fase.",
      "infographic_coming_soon": "Infographic volgt binnenkort",
      "inputs": {
        "author_comment": "Beschrijf wat er dankzij deze investering is bereikt in de gemeenschap en hoe dit tijdens de verschillende programmarondes is gegroeid. Let op: het aantal vrijwilligers ({{volunteerCount}}) staat voor de extra inzet vanuit de gemeenschap, bovenop de subsidie. Tip: reken dit aantal om naar een geschatte geldbedrag om de totale investering in de gemeenschap extra duidelijk te maken.",
        "events": "Evenementen",
        "grant_awarded": "Toegekende subsidie",
        "investment_by_type": "Investering per type (subsidie, in natura, vrijwilligers)",
        "investment_chart_available_in_future": "Investeringsgrafiek — beschikbaar in een toekomstige update.",
        "program": "Programma",
        "venue_breakdown_chart_available_in_future": "Grafiek met locatieverdeling — beschikbaar in een toekomstige update.",
        "volunteers": "Vrijwilligers"
      },
      "insert_section_heading": "Sectietitel invoegen",
      "intended_impact": {
        "activity_type_breakdown": "Verdeling naar activiteitstype",
        "activity_type_breakdown_chart_title": "Verdeling naar activiteitstype: infrastructuur / ontwikkeling / presentatie",
        "author_comment": {
          "describe_actitivy_types": "Beschrijf elk activiteitstype en wat het bereikt.",
          "multiple_output_types_one": "Voor de gehele gesubsidieerde activiteit geldt:",
          "multiple_output_types_other": "Over de door de „{{countFmt}}” gefinancierde activiteiten:",
          "no_output_types": "Beschrijf de soorten activiteiten die door dit programma zijn gefinancierd en hoe zij de beoogde impact realiseren.",
          "one_output_type_one": "De gefinancierde activiteit was van het type {{outputType}}. Beschrijf wat dit in de praktijk betekent en hoe dit activiteitstype de beoogde uitkomsten van het programma realiseert.",
          "one_output_type_other": "Alle {{countFmt}} gefinancierde activiteiten waren van het type {{outputType}}. Beschrijf wat dit in de praktijk betekent en hoe dit activiteitstype de beoogde uitkomsten van het programma realiseert."
        },
        "author_comment_theory_of_change": "Beschrijf de theory of change  in de woorden van de begunstigden. Benoem het model expliciet in plaats van het evenement per evenement te beschrijven. Overweeg ook het onderscheid tussen receptieve deelname (aanwezig zijn als publiek) en actieve deelname (creëren, optreden, deelnemen aan wedstrijden).",
        "title": "Beoogde impact"
      },
      "intended_outcomes": {
        "author_comment": "De uitkomsten die in dit programma worden gebruikt, moeten rechtstreeks aansluiten op de doelen van jouw organisatie. Leg uit dat het programmaontwerp deze samenhang heeft gecreëerd, en niet alleen de keuzes van de begunstigden.",
        "charts": {
          "number_of_funded_activities": "Aantal gefinancierde activiteiten per uitkomstmaat"
        },
        "outcome_surveys_conducted": "Uitgevoerde uitkomstenquêtes",
        "section_title": "Beoogde resultaten die bijdragen aan het doel",
        "writer_note": {
          "considerations_one": "De begunstigden van dit programma kozen steevast voor ‘<em>{{outcome1}}</em>’ als hun belangrijkste uitkomstmaat. Overweeg om deze focus te benoemen als een bewust onderdeel van het programmaontwerp.",
          "considerations_other": "De meest gekozen uitkomsten waren <em>{{outcome1}}</em> en <em>{{outcome2}}</em>. Ga na of in je rapport deze combinatie wordt genoemd als een bewust onderdeel van het programmaontwerp.",
          "think_about_how_the_program_maps": "Denk na over de manier waarop het programma aansluit bij een eventuele culturele strategie of een welzijnskader. Zijn er departement-overstijgende uitkomsten die het benoemen waard zijn?"
        }
      },
      "investment": "Investering (alleen voltooide activiteiten)",
      "investment_and_resourcing_by_program": "Investering en middelen per programma",
      "linked_activities_one": "<strong>{{count}}</strong> gekoppelde activiteit",
      "linked_activities_other": "<strong>{{count}}</strong> gekoppelde activiteiten",
      "linked_activities_zero": "<strong>0</strong> gekoppelde activiteiten",
      "linked_cnt_one": "{{count}} gekoppeld",
      "linked_cnt_other": "{{count}} gekoppeld",
      "linked_cnt_zero": "Niet gekoppeld",
      "loading_activities": "Activiteiten laden",
      "loading_activity": "Activiteit laden",
      "logo_help": "Het hier opgeslagen logo verschijnt in rapportkoppen en in Word-/PDF-exports. Het wordt op organisatieniveau opgeslagen — één logo per organisatie.",
      "manager_assessed_writer_note": "De hier gebruikte evaluatiemethode is een zelfbeoordeling door de activiteitenbeheerder op basis van Takso's gemodelleerde voor-/nameting, geen enquête onder deelnemers. Je rapport moet dit duidelijk vermelden.",
      "measure_for_effect": "Meten van effect",
      "measures_for_change": "Meten van verandering",
      "no_activities_match_current_filters": "Geen activiteiten komen overeen met de huidige filters.",
      "no_analysis_run_yet": "Nog geen analyse uitgevoerd",
      "no_evaluation_plans": "Geen evaluatieplannen voor deze activiteit.",
      "no_linked_activities_found": "Geen gekoppelde activiteiten gevonden.",
      "no_reflection_recorded": "Geen reflectie geregistreerd.",
      "num_events_one": "{{countFmt}} evenement",
      "num_events_other": "{{countFmt}} evenementen",
      "num_events_zero": "{{countFmt}} evenementen",
      "num_linked_activities_one": "<strong> {{countFmt}} </strong> gekoppelde activiteit",
      "num_linked_activities_other": "<strong> {{countFmt}} </strong> gekoppelde activiteiten",
      "num_linked_activities_zero": "<strong> {{countFmt}} </strong> gekoppelde activiteiten",
      "num_linked_one": "1 gekoppeld",
      "num_linked_other": "{{countFmt}} gekoppeld",
      "num_linked_zero": "Geen enkele gekoppeld",
      "num_outcomes_one": "{{count}} uitkomst",
      "num_outcomes_other": "{{count}} uitkomsten",
      "num_outcomes_zero": "{{count}} uitkomsten",
      "num_participants_one": "1 deelnemer",
      "num_participants_other": "{{countFmt}} deelnemers",
      "num_participants_zero": "Geen deelnemers",
      "num_points_one": "{{count}} punt",
      "num_points_other": "{{count}} punten",
      "num_points_zero": "0 punten",
      "num_programs_fmt_one": "<strong>{{count}}</strong> programma",
      "num_programs_fmt_other": "<strong>{{count}}</strong> programma's",
      "num_programs_fmt_zero": "<strong>{{count}}</strong> programma's",
      "num_programs_one": "{{countFmt}} programma",
      "num_programs_other": "{{countFmt}} programma's",
      "num_programs_ul_one": "{{countFmt}} Programma",
      "num_programs_ul_other": "{{countFmt}} Programma's",
      "num_programs_ul_zero": "{{countFmt}} Programma's",
      "num_programs_zero": "{{countFmt}} programma's",
      "org_logo": "Organisatielogo",
      "organisation_goals_one": "Doel van de organisatie",
      "organisation_goals_other": "Doelen van de organisatie",
      "other_graphics": "Overige afbeeldingen",
      "oucome_rating_distributions": "Verdeling van uitkomstbeoordelingen",
      "outcome_change_descrip": "Verandering = gemiddelde beoordeling na minus gemiddelde beoordeling voor. De scores zijn schattingen van managers op basis van de door Takso gemodelleerde verdeling, en zijn niet afkomstig uit enquêtes onder deelnemers.",
      "outcome_ladder_description": "De uitkomstenlijst laat zien op welke uitkomsten de gefinancierde activiteiten zich het vaakst richtten. Gebruik deze grafiek om de breedte van de aangepakte maatschappelijke resultaten te tonen. Een activiteit kan meer dan één evaluatie bijdragen aan een uitkomst wanneer er afzonderlijke evaluaties worden uitgevoerd voor verschillende deelnemersgroepen.",
      "outcome_relationship": {
        "description_one": "1 activiteit heeft betrekking op beide uitkomstmaten in de huidige dataset.",
        "description_other": "{{count}} De activiteiten hebben betrekking op beide uitkomstmaten in de huidige dataset.",
        "description_zero": "Er zijn geen gegevens over gelijktijdig voorkomen beschikbaar voor dit paar.",
        "outcome_a": "Uitkomst A",
        "outcome_b": "Uitkomst B",
        "placeholder_section": {
          "activity_breakdown": "Uitsplitsing van activiteiten — activiteiten die op beide resultaten zijn gericht",
          "comparison_and_trend": "Vergelijking en trend - verschillen tussen de uitkomstresultaten",
          "evaluation_rating_comparison": "Vergelijking van beoordelingsscores — hoe deelnemers elke uitkomst beoordeelden",
          "timeline": "Tijdlijn — wanneer deze uitkomsten doorgaans samen worden behandeld"
        },
        "subtitle": "Analyse van de relatie tussen uitkomsten",
        "title": "Takso · Uitkomstenanalyse"
      },
      "outcomes": {
        "change": "Verandering",
        "outcome_evaluation_results_manager_assessed": "Resultaten uitkomstevaluatie: zelfbeoordeling door de activiteitenbeheerder (voor tot na, schaal 1–10)",
        "outcome_evalution_results": "Resultaten uitkomstevaluatie",
        "rating_after": "Beoordeling na",
        "rating_before": "Beoordeling voor"
      },
      "outcomes_measured": "Gemeten uitkomsten",
      "outcomes_measured_across_events": "De gegevens tonen {{outcomes}} gemeten bij {{events}}.",
      "page_1": "Pagina 1",
      "participant_origin_postcode_map": "Herkomst van deelnemers — kaart met postcodes",
      "participant_rating_dist_charts_for_future": "Grafieken met de verdeling van deelnemersbeoordelingen — beschikbaar in een toekomstige update.",
      "participant_types": "Deelnemerstypen",
      "participants": {
        "author_comments": "Het totale bereikcijfer van {{value}} op {{events}} is aanzienlijk. In je rapport moet duidelijk worden uitgelegd wat de verhouding is tussen passieve (publiek) en actieve (artiesten, deelnemers aan wedstrijden, workshopdeelnemers) deelname, en moet worden vermeld hoe het aantal bezoekers is gemeten — geschat of geteld.",
        "event": "Evenement",
        "largest_events_by_participant_reach": "Grootste evenementen op basis van het aantal deelnemers",
        "outputs_participation": "Outputs: Deelname",
        "participant_type_chart_available_later": "Grafiek met deelnemerstypen — beschikbaar in een toekomstige update.",
        "participant_type_ladder": "Deelnemerstypeladder: verdeling tussen receptief en actief",
        "participation_by_program": "Deelname per programma",
        "receptive_percentage": "Receptief %",
        "total_reach": "Totaal bereik"
      },
      "participants_by_activity_type": "Deelnemers per activiteitstype",
      "people_one": "1 persoon",
      "people_other": "{{countFmt}} personen",
      "people_zero": "geen personen",
      "photo_crop": {
        "drag_hints": "Sleep om het formaat van de bijgesneden afbeelding aan te passen",
        "drag_to_crop_the_bottom": "Sleep om de onderkant bij te snijden",
        "drag_to_crop_the_left": "Sleep om de linkerkant bij te snijden",
        "drag_to_crop_the_right": "Sleep om de rechterkant bij te snijden",
        "drag_to_crop_the_top": "Sleep om de bovenkant bij te snijden",
        "drag_to_resize_crop_line": "Sleep om het formaat van de snijlijn te wijzigen",
        "hints": "Sleep de foto om de uitsnede als geheel te verplaatsen; gebruik de ronde handgreep om het formaat te wijzigen. Met de handgrepen aan de randen van de gestreepte uitsnijdlijn pas je één zijde tegelijk aan; met de vierkante hoekhandgrepen schaal je proportioneel. Beide opties veranderen het uitgesneden deel zonder het eindresultaat te verplaatsen of te schalen"
      },
      "position_cover_image": "Omslagafbeelding positioneren",
      "preferences": {
        "activity_settings": "activiteitsinstelling",
        "appendices": "Bijlagen",
        "banner_and_spot_colour_label": "Bannerkleur en accentkleur",
        "banner_colour_applied": "Wordt toegepast op de kopteksten van tabelkolommen en accentelementen in het hele rapport. Als deze optie is uitgeschakeld, hebben de kopteksten een effen witte achtergrond.",
        "body_font_size": "Lettergrootte hoofdtekst",
        "body_font_size_hint": "Geldt voor de lopende tekst in het hele document",
        "chart_title_style": "Opmaak van de grafiektitel",
        "chart_title_style_hint": "Op grafiektitels toegepaste opmaakstijl voor kopteksten",
        "charts": "Deze voorkeuren bepalen hoe grafieken voor deze organisatie worden weergegeven. Of een grafiek wordt opgenomen in een geëxporteerd rapport, stel je per grafiek in met de schakelaar <strong>Opnemen in rapport</strong> op de grafiek zelf.",
        "colour": "Kleur",
        "colours": "Kleuren",
        "conclusions": "Conclusies",
        "conclusions_hint": "Bevindingen, reflectie, volgende stappen",
        "corporate_statement": "Bedrijfsverklaring",
        "corporate_statement_disabled_hint": "Geen bedrijfsverklaring — voeg er een toe via Organisatie › Instellingen",
        "corporate_statement_hint": "Voeg de openbare bedrijfsverklaring in als pagina 2",
        "cover_image_background_colour": "Achtergrondkleur omslagafbeelding",
        "cover_page": "Omslagpagina",
        "cover_page_hint": "Titelpagina met rapportkop, activiteitsnaam en organisatienaam",
        "cover_photo": {
          "default_description": "De standaardkleur is donkergrijs (#1f2937). Kies \"Geen kleur\" om het vak transparant te laten."
        },
        "document": "Document",
        "end_signature": "Afsluitende handtekening",
        "end_signature_disabled_hint": "Geen afsluitende handtekening — upload er een via Organisatie › Instellingen › Rapporten",
        "end_signature_hint": "Toon de afsluitende handtekeningafbeelding van de organisatie onderaan het rapport",
        "evaluation_hint": "Kerngegevens, methodologie, bevindingen over uitkomsten",
        "evidence_ref_table": "Referentietabel bewijs",
        "executive_summary": "Managementsamenvatting",
        "executive_summary_hint": "Achtergrond, samenvatting van bevindingen",
        "font_family": "Lettertypefamilie",
        "footer_text": "Voettekst",
        "glossary": "Woordenlijst",
        "graded_outcome_measures": {
          "heading": "Gescoorde uitkomstmaten",
          "is_activity_own_setting": "Dit is de eigen instelling van deze activiteit — ze verandert niet automatisch als de standaardinstelling van de organisatie (momenteel {{onOrOff}}) later wordt gewijzigd.",
          "select_activity": "Selecteer een activiteit om dit voor een specifiek rapport in te stellen. Hiermee wordt voor elke uitkomstmaat een toegankelijke versie in gewone taal weergegeven in plaats van de volledige formele definitie.",
          "show_accessible_version": "Toon in het rapportsjabloon een toegankelijke versie in eenvoudige taal van elke uitkomstmaat in plaats van de volledige formele definitie."
        },
        "header_and_footer": "Koptekst &amp; voettekst",
        "include_footer": "Voettekst opnemen",
        "include_footer_hint": "Verschijnt onderaan elke pagina",
        "include_header": "Koptekst opnemen",
        "include_header_hint": "Verschijnt bovenaan elke pagina na de omslag",
        "intended_impact": "Beoogde impact",
        "intended_impact_hint": "Doelstellingen, theory of change, bewijs",
        "left_header_text": "Koptekst links",
        "letterbox_colour_behind_cover_photo": "De kleur van de brievenbus achter de omslagfoto is zichtbaar in elke ruimte waar de afbeelding het kader niet volledig vult, en terwijl de afbeelding wordt geladen.",
        "no_colour": "geen kleur",
        "no_colour_set_pick_one": "Geen kleur ingesteld — kies er een",
        "org_default": "Organisatiestandaard",
        "org_name_hint": "Laat dit veld leeg om de naam uit de database te gebruiken",
        "org_settings_hint": "Pas de rapport- en grafiekopties voor {{org}} aan. Als je de weergave van <strong>een aangepaste instelling</strong> in- of uitschakelt, wordt de standaardinstelling van het platform overschreven. Gebruik <em>‘Reset’</em> om een veld terug te zetten naar de standaardinstelling.",
        "pick_colour": "Kleur kiezen",
        "remove_background_colour_overlay": "Achtergrondkleur-overlay verwijderen",
        "report_header": "Rapportkoptekst",
        "report_header_hint": "Kop bovenaan de voorpagina — bijv. de rapporttitel of de naam van de reeks",
        "report_sections": "Rapportsecties",
        "reset_to_white": "Terugzetten naar wit",
        "revert_to_platform_default": "Terug naar de standaardinstellingen van het platform",
        "select_banner_and_spot_colour": "Selecteer de banner- en accentkleur voor de rapporten van deze organisatie. De standaardkleur is wit.",
        "show_page_numbers": "Paginanummers tonen",
        "strategic_alignment": "Strategische afstemming",
        "strategic_alignment_hint": "Doel van de organisatie, kruisverwijzingen",
        "survey_responses_appendix": "Bijlage met enquêtereacties",
        "survey_responses_appendix_hint": "Bijlage 2 — opmerkingen van deelnemers, gegroepeerd per sessie. Opmerking: er is een vermelding dat er opmerkingen beschikbaar zijn, voor zover deze zijn vastgelegd.",
        "survey_stats_line": "Rapportweergave: rij met enquêtestatistieken",
        "survey_stats_line_hint": "Toon \"N enquêtes met N reacties van N deelnemers (N%)\" in plaats van de standaardweergave \"evaluatieplannen · deelnemers · reacties\"",
        "table_of_contents": "Inhoudsopgave",
        "use_org_default": "Gebruik in plaats daarvan de standaardinstelling van de organisatie"
      },
      "prepared": "Opgesteld",
      "prepared_using_takso": "Opgesteld met Takso",
      "preview": {
        "activity_evaluated_against": "Deze activiteit is geëvalueerd aan de hand van {{outcomes}}",
        "activity_record_type": {
          "program": "Programma",
          "single_independent": "Enkelvoudig – Zelfstandig",
          "single_linked": "Enkelvoudig – Gekoppeld"
        },
        "appendix": "Bijlage",
        "background_table": {
          "column_headings": {
            "team": "Team",
            "title": "Titel",
            "type": "Type",
            "when": "Wanneer",
            "where": "Waar"
          }
        },
        "chart_not_captured": "Grafiek niet vastgelegd — gebruik het tabblad Grafieken om deze grafiek in het rapport op te nemen.",
        "conclusion": "Conclusie",
        "conclusions": "Conclusies",
        "conclusions_and_actions": {
          "draw_out_one_or_two_findings": "Haal de een of twee bevindingen naar voren die het beste antwoord geven op \"wat is er veranderd?\" — koppel ze terug aan de uitkomsten waartegen deze activiteit is geëvalueerd, in plaats van de evaluatiegrafieken hieronder te herhalen.",
          "title": "Conclusies en acties"
        },
        "contents_page_hint": "De inhoudsopgave in het gedownloade bestand bevat koppelingen naar elke kop. Word werkt de paginanummers bij wanneer je het document voor het eerst opent (klik met de rechtermuisknop op ‘Inhoudsopgave’ → ‘Veld bijwerken’).",
        "cross_reference": "Kruisverwijzing",
        "edits_here_update_the_activity_record": "Wijzigingen hier zorgen ervoor dat het Takso-activiteitenoverzicht wordt bijgewerkt",
        "evaluation_plans": {
          "placeholder": "Zodra de activiteitsgegevens zijn geladen, verschijnen hier de onderdelen van het evaluatieplan. Elk plan in het Takso-record genereert één onderdeel, met de naam van het plan als koptekst."
        },
        "evidence": {
          "no_items": "Geen bewijs geregistreerd voor deze activiteit"
        },
        "evidence_based_insight": "op bewijs gebaseerd inzicht",
        "executive_summary": {
          "background": "Achtergrond"
        },
        "export": {
          "downlaod_report_docx": "Rapport downloaden (.docx)",
          "word_export_coming_soon": "Word-export volgt in de volgende fase"
        },
        "fast_facts": "Kerngegevens",
        "figure": "Figuur",
        "findings": "Bevindingen",
        "glossary": "Woordenlijst",
        "glossary_to_be_completed": "Woordenlijst — nog aan te vullen",
        "in_the_words_of_participants": "In de woorden van de deelnemers",
        "inputs_and_outputs": "Inputs en outputs",
        "intended_domain_outcome": "Beoogde uitkomst voor {{domain}}: {{outcome}}",
        "intended_impact": {
          "intended_domain_outcome": "Beoogde uitkomst voor {{domain}}: {{outcome}}",
          "intended_impact_title": "Beoogde impact en onderbouwing"
        },
        "intended_impact_and_reasoning": "Beoogde impact en onderbouwing",
        "manager_types": {
          "guest": "Gast",
          "staff": "Medewerker"
        },
        "measure": "Maatstaf",
        "measures": "Maatstaven",
        "methodology": "Methodologie",
        "next_steps": "Volgende stappen",
        "no_comment_for_this_measure": "geen opmerking voor deze maatstaf",
        "no_fast_facts_available": "Er zijn geen beknopte feiten beschikbaar voor deze activiteit",
        "no_goal_description_recorded": "Er is geen doelbeschrijving vastgelegd",
        "no_objectives_recorded": "Er zijn geen doelstellingen vastgelegd voor deze activiteit",
        "no_org_goal_recorded": "Er is geen organisatiedoel vastgelegd",
        "no_outcome_linked": "geen gekoppeld resultaat",
        "no_participant_quotes": "Er zijn geen citaten van deelnemers op de shortlist geplaatst. Ga naar het tabblad ‘Evaluatie’ in de activiteit en selecteer citaten uit de evaluatieantwoorden voor de shortlist.",
        "no_text_entered": "Er is geen tekst ingevoerd in het activiteitenoverzicht — klik om tekst toe te voegen.",
        "org_goal": "Doel van de organisatie",
        "our_evidence_for_this_theiry_includes": "Ons bewijs voor deze theorie omvat (zie bijlage voor details):",
        "outcome_measure": "uitkomstmaat",
        "page_break": "pagina-einde",
        "participant_quote_shortlist_one": "{{participantQuotes}} is op de shortlist gezet voor deze sectie.",
        "participant_quote_shortlist_other": "{{participantQuotes}} zijn op de shortlist gezet voor deze sectie.",
        "participant_quotes_one": "{{count}} deelnemerscitaat",
        "participant_quotes_other": "{{count}} deelnemerscitaten",
        "planned_approach": "geplande aanpak",
        "please_complete_your_reflection": "Documentatie: Voltooi  jouw reflectie over deze activiteit",
        "please_enter_final_activity_description": "Documentatie: Voer de definitieve activiteitsbeschrijving in",
        "ratings_from_1_to_10": "Beoordelingen van 1 tot 10, waarbij 1 \"Helemaal niet\" is en 10 \"Het meest\".",
        "reflection": "Reflectie",
        "result": "Resultaat",
        "select_participant_quote": "Selecteer deelnemerscitaat voor deze uitkomst",
        "select_participant_quotes": "Selecteer deelnemerscitaten",
        "select_participant_quotes_for_findings": "Selecteer deelnemerscitaten voor de bevindingen",
        "show_non_editable_text": "Niet-bewerkbare tekst tonen",
        "slides_tab": {
          "description": "De slide-indeling staat in je eigen .pptx-sjabloon, gemaakt in PowerPoint — niet hier. Geef een vorm een naam die overeenkomt met een van de onderstaande velden, en deze wordt automatisch ingevuld bij het exporteren. Namen die niet in een bepaald sjabloon worden gebruikt, worden gewoon overgeslagen, zodat het ene sjabloon volledig kan verschillen van het andere zonder dat je iets aan de code hoeft te veranderen.",
          "description2": "<strong>De namen van de grafiekvelden</strong> worden nu direct bij elke grafiek op het tabblad <strong>‘Grafieken’</strong> weergegeven (het kleine ‘pptx’-pictogram boven elke grafiek; klik erop om te kopiëren) — dat is de actieve grafiek waarnaar de naam daadwerkelijk verwijst, dus ze worden hier niet herhaald.",
          "export_to_pptx": "Exporteren naar .pptx",
          "not_built_yet": "Nog niet gebouwd. Volgende stappen: het uploaden van een sjabloon op organisatieniveau (naar het voorbeeld van de bestaande Word-sjabloon in de organisatie-instellingen), het eindpunt voor geaggregeerde statistieken en de exportpijplijn voor het vastleggen en invullen zelf.",
          "planned_pending_report_builder_aggregate_stats": "Ingepland, maar wacht nog op het 'Report Builder aggregate-stats' eindpunt — is nog niet actief",
          "powerpoint_export": "PowerPoint-export",
          "report_context_text_fields": "Rapportcontext — tekstvelden",
          "stats_text_fields": "Statistieken — tekstvelden"
        },
        "state_plainly_activity_achievments": "Geef duidelijk aan of de activiteit het beoogde doel heeft bereikt, en op welke punten het bewijs het sterkst of het zwakst is.",
        "survey_responses": "Enquêteantwoorden",
        "survey_responses_appendix_hint": "Opmerkingen van respondenten zijn beschikbaar voor deze bijlage — schakel 'Bijlage met enquêteantwoorden' in bij 'Voorkeuren' om ze op te nemen.",
        "text_available": "Tekst beschikbaar in het activiteitenoverzicht.",
        "theory_of_change_not_yet_recorded": "Theory of Change nog niet vastgelegd voor deze doelstelling",
        "therefore_we_will": "Daarom zullen wij",
        "this_activity_ran_on_dates": "Deze activiteit vond plaats {{dates}}{{deliveredBy}}.",
        "this_activity_ran_on_dates_consider_naming": "Geef eventueel aan welke specifieke behoefte of kans binnen de gemeenschap hiertoe aanleiding heeft gegeven — in de bovenstaande tabel ‘Achtergrond’ staan de praktische details vermeld, maar niet de motivatie.",
        "we_know_that": "Wij weten dat"
      },
      "preview_report": "Voorbeeldrapport",
      "primary_brand_colors": "Primaire en secundaire merkkleuren die in exports worden toegepast op achtergronden van sectiekoppen, scheidingslijnen en bannergebieden.",
      "program_cnt_one": "{{count}} programma",
      "program_cnt_other": "{{count}} programma's",
      "program_cnt_zero": "Geen programma's",
      "receptive": "Receptief",
      "receptive_vs_active": "Receptief versus actief",
      "remove_cover_image": "Coverafbeelding verwijderen",
      "remove_custom_section": "Aangepaste sectie verwijderen",
      "report_graphics_and_branding": "Rapportgrafieken en huisstijl",
      "report_preview": "Rapportvoorbeeld",
      "report_types": {
        "mixed_report": "Gemengd rapport",
        "multi_program_report": "Multi-programmarapport",
        "multi_single_report": "Rapport met meerdere enkelvoudige activiteiten",
        "program_report": "Programmarapport",
        "single_activity_report": "Rapport voor enkelvoudige activiteit"
      },
      "select_activity_to_view_postcode_map": "Selecteer een activiteit om de postcodekaart te bekijken.",
      "select_org_to_manage_report_graphics": "Selecteer een organisatie om de grafieken in haar rapport te beheren.",
      "select_org_to_view_activities": "Selecteer hierboven een organisatie om de activiteiten ervan te bekijken.",
      "selected_cnt_one": "{{count}} geselecteerd",
      "selected_cnt_other": "{{count}} geselecteerd",
      "selected_cnt_zero": "Niets geselecteerd",
      "selection": "Selectie",
      "single_cnt_one": "{{count}} enkelvoudige",
      "single_cnt_other": "{{count}} enkelvoudige",
      "single_cnt_zero": "Geen enkelvoudige",
      "strategic_alignment": "Strategische afstemming",
      "summary": "Samenvatting",
      "surveys_condicted": "Uitgevoerde enquêtes",
      "table_of_contents": {
        "appendix_funded_activities": "Bijlage: gefinancierde activiteiten",
        "evaluation": "Evaluatie",
        "executive_summary": "Managementsamenvatting",
        "intended_impact": "Beoogde impact",
        "strategic_alignment": "Strategische afstemming"
      },
      "table_of_contents_label_short": "Inhoud",
      "title": "Rapportgenerator",
      "total_activities": "Totaal aantal activiteiten: {{value}}",
      "total_activities_loading": "Totaal aantal activiteiten: …",
      "total_grant": "totale subsidie",
      "total_reach": "totaal bereik",
      "total_width_all_activities_description": "De totale breedte omvat alle activiteiten {{orgNameOrAllOrgs}}",
      "total_width_completed_activities_description": "De totale breedte geeft de voltooide activiteiten weer {{orgNameOrAllOrgs}}",
      "untitled_section": "Sectie zonder titel",
      "upload_in_next_phase": "Het uploaden volgt in de volgende fase.",
      "volunteers_one": "1 vrijwilliger",
      "volunteers_other": "{{countFmt}} vrijwilligers",
      "volunteers_zero": "geen vrijwilligers"
    },
    "charts_will_be_available_in_future_update": "Grafieken zijn beschikbaar in een toekomstige update.",
    "count": "Aantal",
    "date_period": "Datumperiode",
    "evalplan": "Evaluatieplan",
    "evaluation_plan_count": "Aantal evaluatieplannen",
    "evaluation_plan_count_with_count": "Aantal evaluatieplannen: {{count}}",
    "evaluation_plan_name": "Evaluatieplannaam",
    "evaluations_using_self_assessment_and_intercept_methods_cannot_be_aggregated_with_other_methods": "Evaluaties met zelfbeoordeling en interceptmethoden kunnen niet worden samengevoegd met andere methoden. Om zelfbeoordeelde of interceptresultaten te bekijken, selecteer je ze in het veld methode hierboven.",
    "exit_report_view": "Rapportweergave verlaten",
    "from_date_to_date": "{{startDate}} tot {{endDate}}",
    "include_graph_in_report": "Grafiek opnemen in rapport",
    "include_in_report": "Opnemen in rapport",
    "inputs": "Inputs",
    "linked_activity_count": "Aantal gekoppelde activiteiten",
    "management_summary": {
      "all_departments": "Alle afdelingen",
      "all_managers": "Alle beheerders",
      "ascending": "Oplopend",
      "az": "A–Z",
      "completed": "Voltooid",
      "contact": "Contact",
      "custom_selection": "Aangepast (geavanceerd filter)",
      "descending": "Aflopend",
      "green_light_on": "Groen licht {{date}}",
      "guest": "Gast",
      "least_developed": "Minst ontwikkeld",
      "managed_by": "Beheerd door",
      "newest": "Nieuwste",
      "no_activities": "Geen activiteiten",
      "no_dates": "Geen datums",
      "oldest": "Oudste",
      "status_result": "Status/Resultaat",
      "strategic_plan_document": "Strategisch plandocument",
      "summary_management_overview": "Samenvattend beheeroverzicht",
      "total": "Totaal",
      "total_activities": "Totaal activiteiten",
      "za": "Z–A"
    },
    "message_banner": {
      "evaluations_using_mgr_assessment_and_intercept_methods_cannot_be_aggregated_with_other_methods": "Evaluaties die gebruikmaken van een beoordeling door de activiteitenbeheerder of interceptmethoden kunnen niet worden samengevoegd met andere methoden. Selecteer een methode in het bovenstaande veld om de resultaten van de managerbeoordeling of interceptmethode te bekijken.",
      "evaluations_using_self_assessment_and_intercept_methods_cannot_be_aggregated_with_other_methods": "Evaluaties met zelfbeoordeling en interceptmethoden kunnen niet worden samengevoegd met andere methoden. Om zelfbeoordeelde of interceptresultaten te bekijken, selecteert je ze in het methodeveld hierboven.",
      "in_development_and_active_figures_reflect_status_on_final_day_of_the_search_period": "In ontwikkeling en actieve cijfers weerspiegelen de status op de laatste dag van de zoekperiode. De voltooide cijfers weerspiegelen activiteiten die in deze periode zijn afgerond. Zie de helppagina voor meer informatie.",
      "mgr_assessed_evaluation_is_provided_by_a_single_person": "De beoordeling wordt ingevuld door één persoon, meestal de activiteitenbeheerder. De enkele score wordt vervolgens met behulp van een standaarddeviatie over een normale verdeling (klokcurve) gespreid.",
      "self_assessed_evaluation_is_provided_by_a_single_person": "Een zelfbeoordelingsevaluatie wordt uitgevoerd door één persoon, meestal de activiteitmanager. De beoordeling wordt verdeeld via een standaarddeviatie om de enkele score over de normale verdeling te verspreiden."
    },
    "no_data_available": "Geen gegevens beschikbaar",
    "no_data_in_that_method": "Geen gegevens in die methode.",
    "no_inputs_found": "Geen inputs gevonden...",
    "no_outcome_selected": "Geen uitkomst geselecteerd",
    "no_outputs_found": "Geen outputs gevonden...",
    "no_response": "Geen reactie",
    "no_responses": "Geen reacties",
    "num_responses_one": "reactie",
    "num_responses_other": "reacties",
    "organizationActivitySummary": {
      "activityOverview": "Overzicht activiteiten",
      "banner": "In ontwikkeling en actieve cijfers weerspiegelen de status op de laatste dag van de zoekperiode. De voltooide cijfers weerspiegelen activiteiten die in deze periode zijn afgerond. Zie de helppagina voor meer informatie.",
      "organisationType": "Organisatietype",
      "totalActivities": "Totaal aantal activiteiten"
    },
    "outcome_measure": "Uitkomstmaat",
    "outcome_overview": "Overzicht uitkomsten",
    "outcome_rating_distrib": {
      "errors": {
        "error_loading_ratings": "Fout bij het laden van beoordelingen"
      },
      "no_completed_eval": "Er zijn nog geen voltooide evaluatiereacties voor deze uitkomst.",
      "rating_1_to_10": "Beoordeling (1–10)"
    },
    "outcomes_addressed": "Aangesproken uitkomsten",
    "outcomes_reported": "Gerapporteerde uitkomsten",
    "outcomes_reported_with_title": "Gerapporteerde uitkomsten: {{title}}",
    "outputs": "Outputs",
    "participants": "Deelnemers",
    "please_select_an_outcome_type": "Selecteer alstublieft een uitkomsttype.",
    "post_pre_survey_evaluation": "Post-Pre enquête-evaluatie",
    "post_result": "Na resultaat",
    "pre_post": "Pre-Post",
    "pre_result": "Voor resultaat",
    "program_activity_count": "Aantal programma-activiteiten",
    "programmeActivity": {
      "activityParticipants": "Activiteitsdeelnemers",
      "noDataFound": "Geen gegevens gevonden.",
      "organisationType": "Organisatietype",
      "totalActivities": "Totaal aantal activiteiten"
    },
    "reportSelector": {
      "blankPreview": "Je rapport wordt hier weergegeven",
      "dateRange": "Datumbereik",
      "previewReport": "Voorbeeldrapport"
    },
    "report_view": "Rapportweergave",
    "respondent_percentage": "Percentage respondenten",
    "respondents": "Respondenten",
    "response": "Reactie",
    "responses": "Reacties",
    "responses_plural_one": "reactie",
    "responses_plural_other": "reacties",
    "results_are_generated_from_activities_funded_by": "Uitkomsten zijn gegenereerd uit activiteiten die gefinancierd zijn door {{programTitle}}",
    "select_an_outcome": "Selecteer een uitkomst",
    "select_options_are_required": "Selectieopties zijn verplicht",
    "self_assessed_evaluation_is_provided_by_a_single_person": "Een zelfbeoordelingsevaluatie wordt uitgevoerd door één persoon, meestal de activiteitmanager. De beoordeling wordt verdeeld via een standaarddeviatie om de enkele score over de normale verdeling te verspreiden.",
    "settings": {
      "corporate_public_statement": {
        "description": "N/A",
        "failed_to_save": "Het opslaan van de bedrijfsverklaring is mislukt.",
        "placeholder": "N/A",
        "saved": "Bedrijfsverklaring opgeslagen.",
        "section_heading": "Sectiekop",
        "title": "Openbare bedrijfsverklaring"
      },
      "end_signature": {
        "failed_to_remove": "Het verwijderen van de handtekeningafbeelding is mislukt.",
        "failed_to_upload": "Het uploaden van de handtekeningafbeelding is mislukt.",
        "label": "Slothandtekening",
        "removed": "Slothandtekening verwijderd.",
        "saved": "Slothandtekening opgeslagen."
      },
      "graded_outcome_measures": {
        "description": "Geef in rapporten standaard de in eenvoudige taal opgestelde, aangepaste versie van de uitkomstmaten weer, in plaats van de volledige formele definitie van de uitkomst. Hiermee wordt de beginstand van het selectievakje in de voorkeuren van rapportgenerator ingesteld — medewerkers kunnen dit per rapport nog steeds wijzigen.",
        "failed_to_save": "Het opslaan van de instellingen voor beoordeelde uitkomstmaten is mislukt.",
        "label": "Beoordeelde uitkomstmaten",
        "saved": "Instelling voor beoordeelde uitkomstmaten opgeslagen."
      },
      "save_report_settings": "Rapportinstellingen opslaan",
      "save_statement": "Verklaring opslaan",
      "takso_assisted_analysis": {
        "description": "Laat conceptteksten via machinaal lezen toe in rapportonderdelen. Hiervoor moet de functie voor ondersteunde beschrijvingen zijn ingeschakeld.",
        "title": "Takso-ondersteunde analyse"
      },
      "takso_assisted_descriptions": {
        "charts": {
          "description": "Toon bewerkbare gebieden voor grafiekbeschrijvingen onder datavisualisaties.",
          "label": "Grafiekbeschrijvingen (grijze blokken)"
        },
        "description": "Toon schrijfsuggesties en begeleidende tekst in activiteitsverslagen en rapportvoorbeelden. Standaard uitgeschakeld — medewerkers schrijven rechtstreeks vanuit de gegevens.",
        "label": "Takso-ondersteunde beschrijvingen",
        "show_in_reports": "Tonen in rapporten",
        "writing_prompts": {
          "description": "Toon vooraf ingevulde voorbeeldtekst in de schrijfvelden om de vertelstijl te sturen.",
          "label": "Voorgestelde schrijfsuggesties (platte tekst)"
        }
      },
      "template": {
        "current": "Huidig sjabloon",
        "title": "Word-sjabloon van de organisatie (.dotx)",
        "upload": "Sjabloon uploaden",
        "upload_description": "Upload een .dotx-bestand om je huisstijl toe te passen op alle Word-exports. Upload van sjablonen komt binnenkort."
      },
      "title": "Rapportinstellingen",
      "upload_end_signature_description": "Upload een afbeelding met de naam en contactgegevens van jouw organisatie. Deze verschijnt als vaste afsluitende handtekening onderaan elk rapport van uw organisatie. Ondersteunt PNG, JPG of GIF (max. 2 MB).",
      "upload_signature_image": "Handtekeningafbeelding uploaden"
    },
    "summary": {
      "activities_summary": "Samenvatting activiteiten",
      "strategic_plan_document": "Strategisch plandocument"
    },
    "survey_responses": "Enquêteantwoorden",
    "total_activity_participants": "Totaal aantal deelnemers aan activiteiten",
    "total_participants": "Totaal aantal deelnemers",
    "total_participants_assessed": "Totaal aantal beoordeelde deelnemers",
    "total_respondents": "Totaal aantal respondenten",
    "total_responses": "Totaal aantal reacties"
  },
  "reports": {
    "remove_this_chart": "Deze grafiek verwijderen"
  },
  "right_header_text": "Tekst rechterkoptekst",
  "role": {
    "guest": "Gast",
    "organisation_admin": "Organisatiebeheerder",
    "super_admin": "Superbeheerder",
    "user": "Gebruiker"
  },
  "routing": {
    "account": "Account",
    "accounts_users": "Accounts & Gebruikers",
    "activities": "Activiteiten",
    "activity": "Activiteit",
    "activity_participants": "Activiteitdeelnemers",
    "activity_preview": "Activiteitvoorbeeld",
    "activity_settings": "Activiteitinstellingen",
    "dashboard": "Dashboard",
    "library": "Bibliotheek",
    "logs": "Logbestanden",
    "organisation": "Organisatie",
    "reports": "Rapporten",
    "system_features": "Systeemfuncties",
    "system_logs": "Systeemlogboeken",
    "system_reports": "Systeemrapporten",
    "system_settings": "Systeeminstellingen",
    "takso_outcomes_planning_platform_help": "TAKSO OUTCOMES PLANNING PLATFORM – HELP",
    "user_profile": "Gebruikersprofiel"
  },
  "search": {
    "all_sectors": "Alle sectoren",
    "clear_filters": "Filters wissen",
    "no_results_found": "Geen resultaten gevonden",
    "record_type": "Recordtype",
    "search_by_name_or_email": "Zoeken op naam of e-mail",
    "sector": "Sector"
  },
  "sidebar": {
    "activity_notes": "Activiteitsnotities",
    "advanced_filter": {
      "activeParticipants": "Actieve deelnemers",
      "activityStatus": "Activiteitsstatus",
      "crossReference": "Kruisverwijzing",
      "departmentUnit": "Afdelingsonderdeel",
      "designation": "Benaming",
      "filterBy": "Filteren op:",
      "groupByStatus": "Groepeer op status",
      "noMethodsFound": "Geen methoden gevonden",
      "noOutcomeFound": "Geen uitkomst gevonden",
      "noParticipantsFound": "Geen deelnemers gevonden",
      "noVenueFound": "Geen locatie gevonden",
      "receptiveParticipants": "Ontvankelijke deelnemers",
      "record": "Record",
      "usedData": "Gebruikte gegevens"
    },
    "constants": {
      "activeParticipants": {
        "free": "Gratis",
        "paid": "Betaald",
        "paying": "Betalend"
      },
      "activityType": {
        "festivalProgram": "Festivalprogramma",
        "grantProgram": "Subsidieprogramma",
        "multiActivityProgram": "Multi-activiteitenprogramma",
        "singleActivity": "Enkele activiteit"
      },
      "organizationLevel": {
        "external": "Extern",
        "internal": "Intern"
      },
      "receptiveParticipants": {
        "free": "Gratis",
        "paying": "Betalend"
      }
    },
    "email_verification": {
      "dismiss": "Negeren",
      "request": "Het e-mailbeleid van Takso is bijgewerkt. Om e-mails te blijven ontvangen, verifieer alstublieft je e-mailadres.",
      "resend": "Verificatie opnieuw verzenden",
      "sent": "De verificatie-e-mail is verzonden. Controleer je postvak in om je e-mailadres te verifiëren."
    },
    "go_to_admin": "Naar admin",
    "go_to_home": "Naar home",
    "guest_account": "Gastaccount",
    "help": {
      "show_me_around": "Laat me rondkijken",
      "title": "Helpcentrum",
      "tour_description": "Maak kennis met Takso’s unieke functies voor activiteitenplanning en -evaluatie.",
      "tour_title": "Maak een korte rondleiding door Takso"
    },
    "help_center": "Helpcentrum",
    "help_label": "Help",
    "individual_account": "Individueel account",
    "log_out": "Uitloggen",
    "notes": {
      "are_you_sure_you_want_to_delete_this_note": "Weet je zeker dat je deze notitie wilt verwijderen?",
      "delete_note": "Notitie verwijderen",
      "enter_note": "Voer notitie in",
      "note_is_required_to_save": "Notitie is verplicht om op te slaan",
      "title": "Activiteitsnotities"
    },
    "panel": {
      "advanced_filter": "GEAVANCEERDE FILTER"
    },
    "show_me_around": "Laat me rondkijken",
    "take_a_quick_tour_of_takso": "Maak een korte rondleiding door Takso",
    "unsaved_note_modal": {
      "body": "Je hebt niet-opgeslagen wijzigingen. Wil je de pagina verlaten?",
      "title": "Weet u zeker dat je de pagina wilt verlaten?"
    },
    "user_profile": "Gebruikersprofiel",
    "walk_through_takso_s_unique_activity_planning_and_evaluation_features": "Loop door Takso's unieke functies voor activiteitenplanning en -evaluatie."
  },
  "specific_actions": {
    "add_contractor": "Leverancier toevoegen",
    "add_goal": "Nieuw doel toevoegen",
    "add_more_options": "Meer opties toevoegen",
    "add_note": "Notitie toevoegen",
    "add_partner": "Partner toevoegen",
    "add_reference": "Verwijzing toevoegen",
    "add_user": "Nieuwe gebruiker toevoegen",
    "add_venue": "Locatie toevoegen",
    "edit_department": "Afdeling bewerken",
    "edit_evaluation_method": "Evaluatiemethode bewerken",
    "edit_evidence": "Bewijs bewerken",
    "edit_feature": "Functie bewerken",
    "edit_goal": "Doelstelling bewerken",
    "edit_graded_outcome": "Gescoorde uitkomst bewerken",
    "edit_note": "Notitie bewerken",
    "edit_outcome": "Uitkomst bewerken",
    "edit_permission_group": "Rechtengroep bewerken",
    "edit_series": "Reeks bewerken",
    "edit_subtitle": "Ondertitel bewerken"
  },
  "store": {
    "errors": {
      "problem_with_rows_and_columns": "Er is een probleem met de volgende rijen en kolommen rij: 0 kolom: voor reactie (1-10) rij: 0 kolom: na reactie (1-10)"
    },
    "messages": {
      "account_card_added": "Accountkaart is succesvol toegevoegd!",
      "account_card_updated": "Accountkaart is succesvol bijgewerkt!",
      "account_goal_info": "Informatie over accountdoelen",
      "account_reassigned": "De activiteit is succesvol opnieuw toegewezen",
      "account_subscription": "Accountabonnement",
      "account_subscription_ended": "Accountabonnement is succesvol beëindigd!",
      "account_upgraded": "Account is succesvol geüpgraded!",
      "account_user": "Accountgebruiker",
      "activities_created": "{{numberOfLinkedActivities}} activiteiten succesvol aangemaakt!",
      "activities_reassigned": "Activiteiten succesvol overgedragen",
      "activity_invitation_sent": "Activiteitsuitnodiging is verzonden",
      "activity_report": "Activiteitsrapport",
      "activity_type_updated": "Activiteitstype bijgewerkt",
      "admin_added": "Beheerder is succesvol toegevoegd!",
      "admin_removed": "Beheerder is succesvol verwijderd!",
      "broadcast_notification": "Broadcastmelding",
      "department_updated": "Afdeling is succesvol bijgewerkt!",
      "dept_created": "Afdeling is succesvol aangemaakt!",
      "dept_deleted": "Afdeling is succesvol verwijderd!",
      "dept_labels": "Afdelingslabels",
      "email_verification": "E-mailverificatie",
      "final_eval_plan_closed": "Het definitieve evaluatieplan is succesvol afgerond.",
      "labels_updated": "Labels zijn succesvol bijgewerkt!",
      "linked_activity_accepted": "De gekoppelde activiteit is geaccepteerd",
      "linked_activity_reopened": "De gekoppelde activiteit is heropend voor beoordeling",
      "new_subscription_type_added": "Nieuw accountabonnementstype is succesvol toegevoegd!",
      "notification_sent": "Melding is verzonden.",
      "password_reset_email_sent": "E-mail voor het opnieuw instellen van het wachtwoord is verzonden",
      "password_reset_success": "Wachtwoord is succesvol opnieuw ingesteld",
      "password_updated": "Je wachtwoord is bijgewerkt",
      "payment_added": "Betaling is succesvol toegevoegd!",
      "profile_updated": "Uw profiel is bijgewerkt",
      "question_saved": "Vraag voltooid en opgeslagen",
      "report_assistance_settings_saved": "Instellingen voor rapportondersteuning opgeslagen.",
      "report_settings": "Rapportinstellingen",
      "successfully_completed": "Succesvol voltooid",
      "user_assigned_to_department": "De gebruiker is toegewezen aan de afdeling",
      "verification_sent_check_email": "De verificatie is verzonden. Controleer je e-mail."
    }
  },
  "survey": {
    "activity_survey": {
      "as_an_artist_in_art_not_apart_please_consider_the_following_questions_carefully": "Als artiest bij Art, Not Apart, overweeg de volgende vragen zorgvuldig.",
      "by_agency_and_voice_enabled_we_mean": "Met <label className='bold-text'>eigen regie en stem</label> bedoelen we dat je de vrijheid hebt om je meningen publiekelijk te uiten en dat deze welkom, gerespecteerd en gewaardeerd worden.",
      "by_knowledge_ideas_or_insight_we_mean": "Met <label className='bold-text'>kennis, ideeën of inzicht</label> bedoelen we dat je de vrijheid heeft om je meningen publiekelijk te uiten en dat deze welkom, gerespecteerd en gewaardeerd worden.",
      "do_you_have_any_other_comments_about_the_festival": "Hebt je nog andere opmerkingen over het festival?",
      "having_engaged_with_the_festival_how_much_agency_and_voice_do_you_feel_you_have": "Nu u betrokken bent geweest bij het festival, op een schaal van 1-10, waarbij 1 helemaal niet is en 10 het meest voorstelbare, hoeveel eigen regie en stem voelt u dat u <label className='bold-text'>nu</label> heeft?",
      "if_you_d_like_to_win_tickets_to_australian_dance_party_political_dance_escape_ferocity_techno_parties_cellar_door_wine_market_and_sound_and_fury_performance_art_party_events_leave_your_email_so_you_can_receive_this_prize": "Als je kans wilt maken op tickets voor Australian Dance Party (political dance), Escape Ferocity (techno parties), Cellar Door (wine market) en Sound and Fury (performance art party) evenementen, laat dan je e-mailadres achter zodat je deze prijs kunt ontvangen.",
      "please_tell_us_your_postcode": "Vertel ons je postcode",
      "question_1_knowledge_ideas_or_insight": "Vraag 1. Kennis, ideeën of inzicht.",
      "question_2_agency_and_voice": "Vraag 2: Eigen regie en stem",
      "thats_it_thanks_so_much_festival_photos_are_available_for_download_on_the_next_page": "Dat was het – hartelijk dank.<br></br>De festivalfoto's zijn beschikbaar om te downloaden op de volgende pagina.",
      "thinking_about_your_participation_what_have_you_gained": "Wanneer u denkt aan uw deelname aan dit festival, op een schaal van 1 tot 10, waarbij 1 helemaal niet is en 10 het meest voorstelbare, hoe zou u de hoeveelheid <label className='bold-text'>kennis, ideeën of inzicht</label> beoordelen die u hebt opgedaan?",
      "thinking_back_to_before_you_engaged_with_the_festival_how_much_agency_and_voice_do_you_feel_you_had": "Als u terugdenkt aan <label className='bold-text'>voordat</label> u betrokken was bij het festival, hoeveel eigen regie en stem voelt u dat u <label className='bold-text'>toen</label> had, op dezelfde schaal van 1-10?",
      "this_section_description": "Deze sectie stelt Art, Not Apart in staat meer inzicht te krijgen in de uitkomsten van haar activiteiten.<br></br>We vragen u om na te denken over de impact van het festival op u.",
      "this_survey_is_based_on_measurable_outcomes_developed_by_cultural_development_network_as_part_of_their_ongoing_research": "Deze enquête is gebaseerd op meetbare uitkomsten ontwikkeld door Cultural Development Network als onderdeel van hun voortgaande onderzoek. Deelname aan dit onderzoek zal <label className='bold-text'>Art, Not Apart</label> in staat stellen meer inzicht te krijgen in de resultaten van haar activiteiten en verbeterpunten.",
      "this_will_only_be_used_if_you_win_a_prize_thank_you": "Dit wordt alleen gebruikt om contact met je op te nemen als je een prijs wint, dat is alles.<br></br><Trans i18nKey='survey.activity_survey.thank_you'></Trans>"
    },
    "ageClassificationHelp": "ABS-leeftijdsclassificatie",
    "ageQuestionLabel": "Wat is jouw leeftijd?",
    "ana2020_official_photography": "ANA2020 Officiële fotografie",
    "assessment_based_on": "Waarop is jouw beoordeling gebaseerd?",
    "assessment_basis_required": "Basis voor beoordeling is verplicht",
    "before_higher_than_after_fmt": "<div>Je beoordeling <strong>vóór deelname</strong> is hoger dan je beoordeling <strong>erna</strong>.</div> <p>Dit kan gebeuren als de activiteit niet aan je verwachtingen voldeed. <br/> Als dit niet de bedoeling was, controleer dan je beoordelingen, of ga door en vertel ons hieronder meer.</p>",
    "brokenLinkMessage": "Oeps! De gevraagde enquétekoppeling werkt niet",
    "closeConfirmationMessage": "Weet je zeker dat je deze enquête wilt sluiten?",
    "closeConfirmationTitle": "Sluitingsbevestiging",
    "completion_message": "Bedankt voor het invullen van de enquête, je antwoorden zijn ingediend.",
    "copied_to_clipboard": "Gekopieerd naar klembord",
    "copy_survey_question_link": "Kopieer enquêtevraag link",
    "csv_upload": "CSV Upload",
    "cultural_analysis_thanks": "Bedankt voor je bijdrage aan de culturele analyse van {{name}}.",
    "culture_counts": "Intercept (geïmporteerd)",
    "data_collection_method": "Dataverzamelingsmethode",
    "data_collection_method_required": "Dataverzamelingsmethode is verplicht",
    "defaultQuestionLabel": "Hoe gaat het met u?",
    "download_survey_pdf": "Download enquête PDF",
    "edit_title": "Titel van de enquête bewerken",
    "emailQuestionLabel": "Wat is het e-mailadres van je organisatie?",
    "ensure_previous_in_series_closed": "Zorg ervoor dat de resultaten van de vorige evaluatie in deze serie zijn afgesloten",
    "errors": {
      "title_required": "Een titel voor je enquêtes is vereist"
    },
    "evaluation_groups": "Evaluatiegroepen",
    "evaluation_method": "Evaluatiemethode",
    "evaluation_respondent_type": "Type evaluatierespondent",
    "facilitator_notes": "Facilitator notities",
    "facilitator_tips": "Tips bij het uitvoeren van deze evaluatie",
    "field_required": "Veld is verplicht",
    "generate_qr_code": "Genereer QR Code",
    "generated_by": "Enquête gegenereerd door",
    "go_to_culture_counts": "Ga naar Culture Counts",
    "go_to_survey": "Ga naar enquête",
    "higher_rating_warning": "<div> De beoordeling <strong>vóór deelname</strong> is hoger dan de beoordeling <strong>na deelname</strong>. </div> <p> Dit impliceert dat de activiteit niet aan de verwachtingen van de deelnemer voldeed. <br/> Als dit niet de bedoeling was, controleer dan jouw beoordelingen, of ga door en vertel ons hieronder meer. </p>",
    "links_and_tools_active_once_previous_plan_closed": "Enquêtelinks en uploadtools zijn actief zodra het vorige plan is gesloten",
    "maxCharactersError": "Maximum aantal tekens is 200",
    "mgr_assessed": "Beoordeeld door activiteitenbeheerder",
    "mgr_assessed_evaluation_method": "Evaluatiemethode beoordeeld door activiteitenbeheerder",
    "missing_survey_pdf_url": "Pdf-url van enquête ontbreekt",
    "multiple_use": "Meervoudig gebruik",
    "nextResponseButton": "Volgende reactie",
    "notCollectingResponsesMessage": "Deze evaluatie verzamelt momenteel geen reacties omdat de activiteit nog niet is gestart. Reacties kunnen worden ingediend zodra de activiteit is begonnen",
    "number_of_participants_considered": "Aantal beschouwde deelnemers",
    "online_survey": "Online enquête",
    "photo_link_description": "Hier is een link naar alle officiële foto's van het festival, vrij te gebruiken mits je de fotograaf volledig vermeldt. De namen zijn opgenomen in de titels van de hoofdmappen.",
    "postal_code": {
      "question": "Wat is je postcode?",
      "unavailable": "Postcode niet beschikbaar"
    },
    "printable_survey": "Afdrukbare enquête",
    "qualitative_question": "Kwalitatieve vraag",
    "reason_for_evaluation_method": "Reden voor deze evaluatiemethode",
    "reason_for_evaluation_method_required": "Reden voor de evaluatiemethode is verplicht",
    "selectAgePlaceholder": "Selecteer leeftijd",
    "select_before_response": "Selecteer je <strong>voorafgaande</strong> reactie.",
    "select_data_collection_method": "Selecteer dataverzamelingsmethode",
    "select_response": "Selecteer je antwoord.",
    "select_your_response": "Selecteer je antwoord.",
    "self_assessed": "Zelfbeoordeeld",
    "self_assessed_evaluation_method": "Zelfbeoordelingsmethode",
    "show_evaluation_question": "Toon evaluatievraag",
    "single_use": "Eenmalig gebruik",
    "surveyForPrefix": "ENQUÊTE VOOR ",
    "survey_link": "Enquêtelink",
    "survey_links_instructions_1": "Enquêtelinks zijn actief vanaf de eerste dag van je activiteit. Voor papieren enquêtes download je het CSV-bestand (hieronder beschikbaar onder 'Evaluatiedetails tonen'), voer je de antwoorden van deelnemers in en upload je het bestand opnieuw.",
    "survey_links_instructions_2": "Je kan voor elk evaluatieplan zowel online als papieren enquêtes gebruiken.",
    "survey_links_will_be_operational_from_the_first_day_of_your_activity_results_will_be_automatically_compiled_in_takso_and_visible_on_the_documentation_page": "Enquête links zijn operationeel vanaf de eerste dag van je activiteit. Uitkomsten worden automatisch verzameld in Takso en zijn zichtbaar op de documentatiepagina.",
    "survey_qr_code": "Enquête QR Code",
    "takso_link": "Takso Link",
    "tell_us_more_one_rating": "Kan je ons vertellen waarom je deze beoordeling gaf?",
    "tell_us_more_two_ratings": "Kan je ons vertellen waarom je deze beoordelingen gaf?",
    "title_tooltip": "Dit is de titel die op je enquêtes wordt weergegeven.",
    "title_used_on_survey": "Titel gebruikt in de enquête",
    "title_used_on_survey_updated_successfully": "Titel van de enquête is succesvol bijgewerkt",
    "unable_to_prepare_survey_download": "Kan het downloaden van de enquête niet voorbereiden.",
    "use_survey_link_info": "Gebruik de enquêtelinks voor directe antwoorden van deelnemers, of download en print de pdf-enquête voor papieren antwoorden.",
    "validEmailError": "Voer een geldig e-mailadres in",
    "when_you_are_ready_to_enter_survey_data_into_takso_select_show_evaluation_details_where_you_can_download_a_csv_template_to_enter_your_results_and_upload_to_takso": "Wanneer je klaar bent om enquêtegegevens in Takso in te voeren, selecteer \"Toon evaluatiedetails\", waar je een CSV-sjabloon kunt downloaden om jouw uitkomsten in te voeren en te uploaden naar Takso.",
    "you_can_use_the_links_above_to_refer_your_target_groups_to_your_survey_question_s_the_link_can_also_be_inserted_into_an_existing_survey_monkey_or_used_on_its_own_on_a_tablet_or_mobile_devise_for_interviews_or_focus_groups": "Je kunt de bovenstaande links gebruiken om uw doelgroepen door te verwijzen naar de enquêtevra(a)g(en). De link kan ook worden ingevoegd in een bestaande Survey Monkey, of op zichzelf worden gebruikt op een tablet of mobiel apparaat voor interviews of focusgroepen.",
    "you_will_find_survey_questions_below_when_adding_questions_to_your_survey_ensure_to_add_a_1_10_scale_at_the_appropriate_stage": "Je vindt hieronder enquêtevragen. Wanneer je vragen toevoegt aan de enquête, zorg ervoor dat je een schaal van 1-10 toevoegt in de juiste fase."
  },
  "toggle": {
    "see_all": "Alles weergeven",
    "see_less": "Minder weergeven",
    "see_more": "Meer weergeven",
    "show_all": "Alles weergeven",
    "show_less": "Minder weergeven",
    "show_more": "Meer weergeven",
    "view_less": "Minder bekijken",
    "view_more": "Meer bekijken"
  },
  "typeface": "Lettertype",
  "users": {
    "search": {
      "no_matching_user_filter_by_this_email": "Geen overeenkomstig gebruikersaccount — filter op dit e-mailadres",
      "use_input": "Gebruik \"{{value}}\""
    }
  },
  "utils": {
    "activity_and_project_validation": {
      "activity_dates_enter": "Voer alstublieft je activiteitsdatums in",
      "activity_dates_required": "Voer je activiteitsdatums in",
      "activity_name_required": "Geef je activiteit een geschikte naam",
      "activity_name_suitable": "Geef je activiteit een geschikte naam",
      "activity_summary_enter": "Voer een samenvatting van de activiteit in",
      "activity_summary_required": "Voer een samenvatting van de activiteit in",
      "activity_type_select": "Selecteer het activiteitstype",
      "actual_participant_field": "Voer een getal in bij ten minste één veld voor werkelijke deelnemers",
      "actual_participant_field_named": "Voer een aantal in bij het veld {{label}}",
      "approve_activity": "Keur deze activiteit alstublieft goed",
      "contractor_cost_required": "Voer de leverancierskosten in voor alle leveranciers",
      "enter_expenditure_or_tick_no_reportable_expenditure": "Voer een bedrag in bij Zaalhuur, een Opdrachtnemer of Overige uitgaven, of vink het vakje 'Geen te rapporteren overige uitgaven' aan",
      "evaluation_all_objectives_enter": "Voer minstens één evaluatieplan in voor alle doelstellingen",
      "evaluation_completed": "Bevestig alstublieft of de evaluatie van \"{{planName}}\" is voltooid.",
      "evaluation_no_responses": "\"{{evalName}}\" heeft geen geregistreerde antwoorden. Voer antwoorden in of voltooi een evaluatie van dit plan beoordeeld door activiteitenbeheerder.",
      "evaluation_participants_required": "Selecteer alstublieft minstens één evaluatiedeelnemersgroep voor \"{{planName}}\"",
      "evaluation_plan_enter": "Voer een evaluatieplan in",
      "evidence_for_outcome": "Voer bewijs in voor {{outcomeTitle}}",
      "evidence_required": "Voer bewijs in",
      "festival_type_select": "Selecteer minstens één festivaltype",
      "final_description_required": "Voer de definitieve activiteitsbeschrijving in",
      "goal_required": "Voer een doel in",
      "grants_application_closing_date": "Selecteer de sluitingsdatum van uw subsidieaanvraag",
      "green_light_date_required": "Selecteer de 'groen licht' datum",
      "green_light_date_select": "Selecteer alstublieft de 'groen licht' datum",
      "linked_activities_accepted": "Zorg ervoor dat alle gekoppelde activiteiten zijn geaccepteerd",
      "linked_activity_required": "Voer minstens één gekoppelde activiteit in",
      "mgr_assessment_required": "\"{{outcomeTitle}}\" in \"{{planName}}\" vereist een evaluatie van de activiteitenbeheerder. Klik op ‘Details bekijken’ en beantwoord de vragen voor de activiteitenbeheerder.",
      "no_responses_recorded": "\"{{planName}}\" heeft geen geregistreerde antwoorden voor \"{{outcomeTitle}}\". Voer antwoorden in of voltooi een evaluatie beoordeeld door activiteitenbeheerder van dit plan.",
      "objective_per_domain": "Selecteer alstublieft minstens één doelstelling per domein",
      "objectives_required": "Selecteer de doelstellingen",
      "output_format_enter": "Voer alstublieft je {{label}} in",
      "participant_numbers_required": "Voer het aantal deelnemers voor deze activiteit in",
      "participant_responses_mismatch_post": "Het aantal deelnemers dat de evaluatie heeft voltooid komt niet overeen met het aantal ingevoerde (POST) antwoorden van de deelnemers voor \"{{outcomeTitle}}\" in \"{{planName}}\". Neem contact op met Takso-admin voor meer informatie.",
      "participant_responses_mismatch_pre": "Het aantal deelnemers dat de evaluatie heeft voltooid komt niet overeen met het aantal ingevoerde (PRE) antwoorden van de deelnemers voor \"{{outcomeTitle}}\" in \"{{planName}}\".Neem contact op met Takso-admin voor meer informatie.",
      "partner_contribution_required": "Voer de bijdragekosten voor alle partners in",
      "projected_grants_pool": "Voer alstublieft je gepland totaal subsidiebudget in",
      "projected_participant_field": "Voer een waarde in voor minstens één gepland deelnemersveld",
      "reflection_required": "Voltooi alstublieft je reflectie over deze activiteit",
      "remove_projected_contractors": "Verwijder geplande leveranciers of vul alle vereiste informatie in",
      "secondary_objective_required": "Specificeer je secundaire doelstelling",
      "self_assessment_required": "Evaluatie: \"{{outcomeTitle}}\" in \"{{planName}}\" vereist een beoordeling van de activitietsbeheerder. Klik op 'Details bekijken' en beantwoord de vragen voor de beoordeling.",
      "theory_of_change_for_outcome": "Voer de Theory of Change voor {{outcomeTitle}} in of vul deze aan",
      "theory_of_change_required": "Voer de Theory of Change in of vul deze aan",
      "venue_details_required": "Voer alstublieft locatiedetails in"
    },
    "activity_description": {
      "festival": "Een programma met meerdere doelstellingen, uitgevoerd via gekoppelde activiteiten en publiek gepresenteerd als een gemeenschappelijk cultureel evenement.",
      "grant": "Een activiteit met meerdere doelstellingen, gerealiseerd via meerdere afzonderlijke activiteiten; opgestart via het aanvragen en verdelen van fondsen tussen de openingsdatum van de subsidie en de eindafrekening.",
      "multi_activity": "Een programma met meerdere doelstellingen, uitgevoerd via verschillende gekoppelde activiteiten die niet noodzakelijk publiek als één programma worden gepresenteerd.",
      "single": "Een activiteit die maximaal twee doelstellingen nastreeft; heeft een eigen start- en einddatum en maakt geen deel uit van een groter programma."
    },
    "collection_method": {
      "csv_upload": "CSV-upload",
      "culture_counts": "Intercept (geïmporteerd)",
      "link_plus_csv_upload": "Takso-link + CSV-upload",
      "takso_link": "Takso-link"
    },
    "date_picker": {
      "activity_end_date": "Einddatum activiteit",
      "activity_period": "Activiteitsperiode",
      "activity_start_date": "Startdatum activiteit",
      "festival_dates": "Festivaldata",
      "festival_end_date": "Einddatum festival",
      "festival_start_date": "Startdatum festival",
      "program_end_date": "Einddatum programma",
      "program_period": "Programmaperiode",
      "program_start_date": "Startdatum programma"
    },
    "error": {
      "idle_timeout": "Je bent te lang inactief geweest. Je moet opnieuw inloggen.",
      "invalid_value": "De ingevoerde waarde is ongeldig of vereist, controleer deze opnieuw!",
      "network_connection": "Netwerkverbindingsfout!",
      "no_permission": "Je hebt geen toestemming om deze actie uit te voeren",
      "record_not_found": "Sorry, record niet gevonden",
      "request_not_allowed": "Verzoek niet toegestaan",
      "something_wrong": "Oeps, er is iets misgegaan!",
      "timed_out": "Je sessie is verlopen!"
    },
    "evaluation_method": {
      "focus_group_experts": "Focusgroep - experts",
      "focus_group_participants": "Focusgroep - deelnemers",
      "focus_group_proxies": "Focusgroep - vertegenwoordigers",
      "intercept": "Intercept",
      "interview_expert": "Interview - expert",
      "interview_participant": "Interview - deelnemer",
      "interview_proxy": "Interview - vertegenwoordiger",
      "mgr_assessed": "Beoordeeld door de activiteitenbeheerder",
      "questionnaire_expert": "Vragenlijst - expert",
      "questionnaire_participant": "Vragenlijst - deelnemer",
      "questionnaire_proxy": "Vragenlijst - vertegenwoordiger",
      "quick_response": "Snelle respons",
      "self_assessed": "Zelfbeoordeeld"
    },
    "evidence": {
      "grants_program": "Bewijs ter ondersteuning van het subsidieprogramma",
      "objectives": "Bewijs"
    },
    "green_light": {
      "not_able": "Deze activiteit kan geen 'groen licht' krijgen omdat het gekoppelde programma nog geen 'groen licht' heeft ontvangen"
    },
    "program_type": {
      "festival_programs": "Festivalprogramma’s",
      "grant_programs": "Subsidieprogramma’s",
      "multi_activity_programs": "Multi-activiteitenprogramma’s"
    }
  }
}
